import { Size , Scale , SetStyles  , CreateElement , AddMouseDownListener, formatBytes, Filter, DrawSymbolImage, DrawSymbolImageSpine, FilterFeatures, IsEmptyOrNull} from ".././MyHelpers";
import { Resourceful } from "../ResourceManager/Resourceful";
import { ResourceIdentifier }  from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager }  from "../ResourceManager/ResourceManager";
import { DecodedImageResource, ImageResource }  from "../ResourceManager/ImageResource";
import { HTMLResource }  from "../ResourceManager/HTMLResource";
import { Settings, JackpotDisplayType, PanelType, JackpotDisplay, FillingPotFeature} from "../Settings";
import { BonusNameMap, Translator } from "../Translator";
import { SlotGameInitData } from "../SlotGameInitData";
import { SlotGame } from "../slot/SlotGame";
import { ZIndex } from "../ZIndex";
import { MyCanvas, MyCanvasContext } from "../slot/MyCanvas";
import { PayTable , PaytablePerSymbol } from "../slot/Paytable/Paytable";
// import { PayTableAmatic  } from "../slot/Paytable/PaytableAmatic";
import { SlotGameMessages } from "../slot/SlotGameScreenMessages"
import { SpanishTranslation , EnglishTranslation , TranslatedLocation } from "../Translator";
import { SlotSymbolSprite } from "../slot/SlotSymbolSprite";
import { BonusConfigurationList } from "../SlotGameInitData";
import { Bonus } from "../slot/Bonus/Bonus";
import { TweenMax } from "gsap";
import { IGroupedSimplePaytableData, PayTable8Squares } from "../slot/Paytable/PayTable8Squares";
import { IPaytableData, ISimplePaytableData, PayTableFactory } from "../slot/Paytable/PayTableFactory";
import { IPanelFactory } from "../slot/panel/IPanelFactory";
import { IPayTableFactory, IPaytableParams } from "../slot/Paytable/IPayTableFactory";
import { IPaytable } from "../slot/Paytable/IPayTable";
import { SlotSymbol } from "../slot/SlotSymbol";
import { ITranslatedImageParams, TranslatedImage } from "../slot/TranslatedImage";
//import type { UnlockRowsConfig } from "../slot/Bonus/ExtendedSpinAndHold/UnlockFeature";
import { CurrencyOption, ExtendedSpinAndHoldCommonConfiguration, FreegamesCommonConfiguration, FreegamesOption, IFeatureConfiguration, IPublicSimpleBonusTrigger, MultiBonusType, PlayWindow, PlusOneFeatureConfiguration, ScatterRandomAwardConfiguration, SettingsNode, SimpleSlotGameState, Symbol, SymbolType, UnlockRowsConfig } from "../api";
import { IBackendSettingsService } from "../../services/BackendSettingsService";
import { CanvasSprite, CanvasSpriteSizing } from "../slot/Sprite/CanvasSprite";
import { SpriteResource } from "../ResourceManager/SpriteResource";
import { ISprite } from "../slot/Sprite/ISprite";
import { service } from "../services";
import { SymbolsCollectionResources, SymbolTypeAnim } from "../slot/SpineSymbols/SymbolsCollection";
import { JSONResource } from "../ResourceManager/JSONResource";
import { Assets } from "pixi.js";
import { ISkeletonData } from "pixi-spine";
import { AtlasResource } from "../ResourceManager/AtlasResource";
import { assertEqual, assertNotNullish, assertTrue } from "../debug";
import { LayoutPotElement } from "../slot/FillingPot/LayoutPotElement";
import { ButtonColors } from "../slot/panel/panel";
import { JackpotDisplayProperties } from "../JackpotDisplayProperties";
import { MultiPotName } from "../slot/FillingPot/FamilyMultiBonusConstructiveFeature";
//import { FreegameBonusConfiguration } from "../slot/FreegameBonus/FreegameBonus";


export interface HelpPanelColor
{
	backgroundPanelColor: string;
}


export type SettingsValueType = "GROUP" | "ENABLED_DISABLED_GROUP" | "ENABLED_DISABLED" | "MONEY";
export interface IBackendSettings extends SettingsNode
{
	ID: string;
	Name: string;
	Type: SettingsValueType
	Values: IBackendSettings[],
	Value?: string | number;
}


const ListOfKnownBackendSettings = 
[
	"system.currency",
	"system.maxVolume",
	"system.defaultVolume",
	"play.malfunctionmessage",
	"play.translations.defaultTranslation",
	"play.translations.english",
	"play.translations.spanish",
	"play.translations.romanian",
	"play.speedtype",
	"play.celebration",
	"accounting.cashierEnabled",
] as const

type KnownSettingsKey = (typeof ListOfKnownBackendSettings)[number];

export class BackendSettings
{
	protected settings: IBackendSettings;
	protected parsedSettings: Map<string, IBackendSettings> = new Map<string, IBackendSettings>();

	public constructor(settings: IBackendSettings)
	{
		this.settings = settings;

		let settingsToCheck:
		{
			path: string;
			settings: IBackendSettings;
		}[] = [];

		settings.Values.forEach(v => settingsToCheck.push({
			path: v.ID,
			settings: v
		}));

		for (let i = 0; i < settingsToCheck.length; i++)
		{
			// add child settings
			if (settingsToCheck[i].settings.Values)
			{
				for (let j = 0; j < settingsToCheck[i].settings.Values.length; j++)
				{
					if (settingsToCheck[i].settings.Values[j])
					{
						try
						{
							settingsToCheck.push({
								path: settingsToCheck[i].path + "." + settingsToCheck[i].settings.Values[j].ID,
								settings: settingsToCheck[i].settings.Values[j]
							});
						}
						catch (e)
						{
						}
					}
				}
			}
		}

		settingsToCheck.forEach(s => {
			this.parsedSettings.set(s.path, s.settings);
		});

	}

	public GetBool(path: KnownSettingsKey, defaultValue: boolean = false): boolean
	{
		let s = this.parsedSettings.get(path);
		if (s && s.Value)
		{
			return s.Value == "1";
		}

		return defaultValue;
		//throw `No such settings value: ${path}`;
	}

	public GetNum(path: KnownSettingsKey, defaultValue: number): number
	{
		let s = this.parsedSettings.get(path);
		if (s && s.Value)
		{
			let n = Number(s.Value);
			if (isNaN(n))
			{
				return defaultValue;
			}

			return n;
		}

		return defaultValue;
	}

	public GetString(key: KnownSettingsKey, defaultValue?: string): string
    {
        let s = this.parsedSettings.get(key);
        if (s && s.Value)
        {
            if (typeof s.Value == "string")
            {
                return s.Value;
            }
        }

        return defaultValue;
    }

	public GetEnum<T>(key: KnownSettingsKey, defaultValue?: T): T
    {
        let s = this.parsedSettings.get(key);
        if (s && s.Value)
        {
			return s.Value as any as T;
        }

        return defaultValue;
    }

	public GetCurrency(key: KnownSettingsKey, defaultValue: CurrencyOption): CurrencyOption
	{
		let strVal = this.GetString(key);
		if (!strVal)
		{
			return defaultValue;
		}

		let val: CurrencyOption = JSON.parse(strVal);
		return val;
	}
}


export interface HelpParameters
{
	initData: SlotGameInitData;
	slotSize: Size;
	resid: ResourceIdentifier;
	translator: Translator;
	game: SimpleSlotGameState;
	backendSettings: IBackendSettingsService;
	symbols : SlotSymbol [],
	readonly symbolCollectionMap: Map<string, SymbolsCollectionResources>,
	readonly symbolTypeAnim : SymbolTypeAnim,
	readonly backgroundHelpPanelColor : HelpPanelColor
}

export type HideHelpCallback = () => void;
export class Help implements Resourceful {
	protected view: HTMLElement = null;
	protected resourcesBasePath: string = "";
	public hideHelpCallback: HideHelpCallback = null;

	protected gamePath: string = "";

	protected resid: ResourceIdentifier;
	protected logGroup: string;

	public helpPages: HelpPage[] = [];
	public pages: Map<string, HelpPage> = new Map<string, HelpPage>();


	protected left: HTMLElement = null;
	protected right: HTMLElement = null;
	protected exit: HTMLElement = null;
	protected ortizO: HTMLElement = null;

	protected selectedPage: HTMLElement = null;
	public selectedPageIndex: number = 0;

	protected lines: number[][];
	protected slotSize: Size = null;
	protected translator: Translator = null;
	protected ContentPage:HTMLElement=null;
	protected parameters: HelpParameters;
	protected SlideScaleMove=(Scale.X(1920))*(-1);

	protected symbols : SlotSymbol[];
	
	readonly backgroundHelpPanelColor = null; 

	//lines:number [][]
	constructor(parameters: HelpParameters) {

		this.resid = parameters.resid.Add("help");
		this.logGroup = "Help";
		this.translator = parameters.translator;
		this.backgroundHelpPanelColor = parameters.backgroundHelpPanelColor;


		this.view = CreateElement("div", {
			classes: ["help"],
			style: {
				position: "absolute",
				top: Scale.Ypx(0),
				left: Scale.Xpx(0),
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				display: "flex",
				flexDirection: "row",
				overflow: "hidden",
				zIndex: ZIndex.HelpInfo.toString(),

			}
		});

		this.view.classList.add("help");
		this.view.classList.add(this.resid.Scope());
		this.view.style.zIndex=ZIndex.HelpInfo.toString();
		this.lines = parameters.initData.Playlines;
		this.slotSize = parameters.slotSize;

		this.resourcesBasePath = Settings.ResourcesFolder + "multigame/help/";
		this.gamePath = Settings.ResourcesFolder + "multigame/slot/"+ (parameters?.initData?.Meta?.onlineParams?.original ?? parameters.initData.Name) +"/resources/" ;
		this.parameters=parameters;

		//symbols
		this.symbols = parameters.symbols;


		let paytable: HelpPage = new HelpPagePayTable(this.resourcesBasePath, this.resid, parameters.game.GameName, this.gamePath, this.translator ,this.symbols);
		this.helpPages.push(paytable);
		this.pages.set("Paytable", paytable);

		this.helpPages.push(new HelpPagePayLines(this.resourcesBasePath, this.resid, this.lines, this.slotSize, this.gamePath, this.translator, parameters.initData, parameters.game));

		let SimplePaytableData = parameters.initData.Paytable as any as ISimplePaytableData;

		if (parameters.initData.BonusConfiguration?.PickBonus != null) {
			this.helpPages.push(new HelpPageDiamondPot(this.resourcesBasePath, this.resid, this.gamePath, this.translator, parameters.initData.BonusConfiguration));
		}				
		if (parameters.initData.BonusConfiguration?.FreeGameBonus != null) {							
			this.helpPages.push(new HelpPageFreeGameBonus(this.resourcesBasePath, this.resid, this.gamePath, this.translator, parameters.initData.Name , parameters.initData.BonusTriggers , parameters.initData.BonusConfiguration.FreeGameBonus , parameters.symbolCollectionMap  ));
		}
		if (parameters.initData.BonusConfiguration?.BigSymbolFreegames != null) {
			this.helpPages.push(new HelpBigSymbolFreegames(this.resourcesBasePath, this.resid, this.gamePath, this.translator, parameters.initData.BonusConfiguration));
		}

		if (parameters.initData.BonusConfiguration?.BigSymbolSpinAndHold != null) {
			this.helpPages.push(new HelpBigSymbolFreegamesStikySpin(this.resourcesBasePath, this.resid, this.gamePath, this.translator, parameters.initData.BonusConfiguration));
		}

		if (parameters.initData.BonusConfiguration?.SpinAndHold != null) {
			this.helpPages.push(new HelpPageHoldAndSpin(this.resourcesBasePath, this.resid, this.gamePath, this.translator, parameters.initData ,  parameters.symbolCollectionMap , parameters.symbolTypeAnim));
		}

		if (parameters.initData.BonusConfiguration?.ExtendedSpinAndHold != null) {
			this.helpPages.push(new HelpPageExtendedHoldAndSpin(this.resourcesBasePath, this.resid, this.gamePath, this.translator, parameters.initData.BonusConfiguration.ExtendedSpinAndHold , parameters.symbolCollectionMap));
		}
		if(parameters.initData.EnabledBets.find(x => x.BuyBonusEnabled) && Settings.Screens == 1) {
			this.helpPages.push(new HelpPageBuyBonusOnline(this.resourcesBasePath, this.resid, this.gamePath, this.translator));
		}

		if(parameters.initData.EnabledBets.find(x => x.BuyBonusEnabled && Settings.Screens != 1)) {
			this.helpPages.push(new HelpPageBuyBonus(this.resourcesBasePath, this.resid, this.gamePath, this.translator));
		}
		if (parameters.initData.BonusConfiguration?.MultiBonus?.MultiFeatureConfiguration) {
			this.helpPages.push(new HelpPageMultibonus(this.resourcesBasePath, this.resid, this.translator, parameters.symbolCollectionMap, parameters.initData))
			this.helpPages.push(new HelpPageMultibonus2(this.resourcesBasePath, this.resid, this.translator, parameters.initData?.Meta?.onlineParams?.original ?? parameters.initData.GameName));
		}


		// if (parameters.initData.bonusConfiguration.DiamondSpin != null) {
		// 	this.helpPages.push(new HelpPageDiamondSpin(this.resourcesBasePath, this.resid, this.gamePath, this.translator, parameters.initData.bonusConfiguration));
		// }
		if (parameters.initData.Feature?.includes("ExpandingWildBulk")) {
			this.helpPages.push(new HelpPageExpandingWildBulk(this.resourcesBasePath, this.resid, this.gamePath, this.translator,parameters.initData , parameters.symbolCollectionMap));
		}
		else if (parameters.initData.Feature?.includes("ExpandingWildReel")) {
			this.helpPages.push(new HelpPageExpandingWildReel(this.resourcesBasePath, this.resid, this.gamePath, this.translator,parameters.initData, parameters.symbolCollectionMap, parameters.symbolTypeAnim));
		}
		else if (
			// check for normal paytable
			SimplePaytableData?.Pays?.some(p => p.Symbol.IsWild) ||
				
			// check for grouped paytable
			Object.values((SimplePaytableData as any as IGroupedSimplePaytableData)?.Groups ?? {}).some(g => g.Symbols.some(s => this.symbols.find(s2 => s2.ID == s).IsWild))
		)
		{
			this.helpPages.push(new HelpPageWild(this.resourcesBasePath, this.resid, this.gamePath, this.translator,parameters.initData, parameters.symbolCollectionMap));
		}
		//Add Slider Turbo Play 
		
		//if (parameters.backendSettings.Values.find(g => g.ID == "play").Values.find(v => v.ID == "turbo").Value == "1")
		if (parameters.backendSettings.GetBool("play.turbo", false))
		{
			this.helpPages.push(new HelpTurboPlayGame(this.resourcesBasePath, this.resid, this.gamePath, this.translator, parameters.initData.BonusConfiguration));
		}
		if(parameters.backendSettings.GetBool("play.allowdoubleup", false))
		{
			this.helpPages.push(new HelpPageDoubleUpGame(this.gamePath,this.resid, this.translator, parameters.backendSettings))
		}
		if (Settings.fillingPotFeature == FillingPotFeature.Enable)
		{
			//this.helpPages.push(new HelpPageFillingPot(this.resourcesBasePath, this.gamePath, this.resid, this.translator))
		}

		if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepShared) {
			this.helpPages.push(new HelpPageJackpotShared(this.resourcesBasePath, this.gamePath, this.resid, this.translator , parameters.symbolCollectionMap))
		}

		if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotStepShared) {
			this.helpPages.push(new HelpPageBonusMultiplier(this.resourcesBasePath, this.gamePath, this.resid, this.translator , parameters.symbolCollectionMap))
		}
		// if (parameters.backendSettings.GetString("insertCashType", "Cashable") == "Noncashable")
		// 	{
		// 		this.helpPages.push(new HelpSweeps(this.resourcesBasePath, this.resid, this.gamePath, this.translator,parameters.initData));
		// 	}
	}

	protected jackpotName: string = null;
	public PrepareResources(resourceManager: IWriteOnlyResourceManager): void {	
		
		this.jackpotName = Settings.JackpotDisplayType;
		if (JackpotDisplayProperties[Settings.JackpotDisplayType].alias != null || JackpotDisplayProperties[Settings.JackpotDisplayType].alias != undefined) {
			this.jackpotName = JackpotDisplayProperties[Settings.JackpotDisplayType].alias;
		}

		//resourceManager.Add(new HTMLResource(this.resourcesBasePath + "help.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new CSSResource(this.resourcesBasePath + "help.css", this.resid.ScopedResourceName("css"), this.resid.CSSScope()));
		resourceManager.Add(new ImageResource(this.resourcesBasePath + "LEFT.png", this.resid.ScopedResourceName() + "left"));
		resourceManager.Add(new ImageResource(this.resourcesBasePath + "RIGHT.png", this.resid.ScopedResourceName() + "right"));
		resourceManager.Add(new ImageResource(this.resourcesBasePath + "EXIT.png", this.resid.ScopedResourceName() + "exit"));
		
		if (Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay && !globalThis.jackpotDisplayGlobal?.GetSImgTitleJackpotSpine()){
			//resourceManager.Add(new SpriteResource(game.basepath + "resources/title_sprite", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
			resourceManager.AddGlobal(new SpriteResource(`${Settings.ResourcesFolder}multigame/multigame/img/JackpotsResources-Slider/`+this.jackpotName+"/titleJackpotDisplay", ResourceIdentifier.Global.Add(Settings.JackpotDisplayType).Add("presentation-title"), true,null, true));
		}
		if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz) {
		//olny load this image when its diamond Pot Ortiz Style
			resourceManager.Add(new ImageResource(this.resourcesBasePath + "ortizo.png", this.resid.ScopedResourceName() + "ortiz"));
		}
		//resourceManager.Add(new ImageResource(this.gamePath + "background.png", this.resid.ScopedResourceName() + "background"));
		
		for (let i = 0; i < this.helpPages.length; i++) {
			this.helpPages[i].PrepareResources(resourceManager);
		}

	}

	protected HelpContent: HTMLElement = null;

	public ResourcesLoaded(resourceManager: IReadOnlyResourceManager): void {

		//this.view.innerHTML += resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;
		//this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName() + "background").CssBackground();
		this.view.style.backgroundColor = "rgba(0,0,0,0.8)";
		this.view.style.backgroundSize="cover";


		//HELPO CONTENT 
		//CREATE DIV 
		
		this.HelpContent = CreateElement("div", {
			classes: ["help-content"],
			parentToAppend: this.view,
			style: {
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				display: "flex",

			}
		});

		//console.log("SymbolsCollectionHelp:",this.parameters.symbolCollectionMap);
		//console.log("ConfigBonus:",this.parameters.initData.BonusConfiguration);
		for (let i = 0; i < this.helpPages.length; i++) {
			this.helpPages[i].ResourcesLoaded(resourceManager);
			this.HelpContent.appendChild(this.helpPages[i].View());
		}
		let ContentPage = this.view.querySelectorAll(".page-content");
			
		//let backgroundColorPanel:HelpPanelColor=this.backgroundHelpPanelColor != null ? this.backgroundHelpPanelColor : this.BackgroundPanel()
		


		SetStyles(ContentPage,{
		
			backgroundImage: this.backgroundHelpPanelColor != null ? this.backgroundHelpPanelColor : this.BackgroundPanel().backgroundPanelColor,
			backgroundOrigin: " border-box",
			backgroundClip: "content-box, border-box",
			borderRadius:Scale.XYpx(16) ,
			border: Scale.XYpx(7)+"solid transparent",
			//backgroundClip: "padding-box",
			borderStyle: "inset",
			alignSelf: "center",
			//width: "90%",
			width: Scale.Wpx(1800),
			height: Scale.Hpx(850),
			display: "flex",
			flexWrap: "wrap",
			alignItems: "flex-start",
			alignContent: "center",
			//left:Scale.Xpx(2.5),
			position:"relative",
			//flexDirection: "column",
			flexShrink: "0",
		})
		


		let HelpNavigation = CreateElement("div", {
			classes: [ "help-navigation"],
			parentToAppend: this.view,
			style: {
				width: Scale.Wpx(1920),
				height: Scale.Hpx(100),
				position: "absolute",
				display: "flex",
				flexDirection: "row",
				justifyContent: "center",
				alignItems: "center",
				bottom: Scale.Ypx(0),
				color: "white",
				fontSize: Scale.fhpx(80),
				transform: "translateZ(0px)",

			}
		});

		//CHANGE FOR CODE 	
		//this.view.querySelector<HTMLElement>(".help-navigation").style.transform = "translateZ(0px)";


		this.selectedPage = this.helpPages[this.selectedPageIndex].View();

		this.left = CreateElement("div", {
			classes: [ "but-left"],
			parentToAppend: HelpNavigation,
			style: {
				width: Scale.Wpx(440),
				height: Scale.Hpx(100),
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				boxSizing: "border-box",
				backgroundColor: "rgb(0,0,0,0.5)",
				borderRadius: "100px",
				margin:"10px",
				textAlign: "center",
			}
		});

		//this.left = this.view.querySelector(".but-left");
		this.left.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName() + "left").CssBackground();
		// this.left.style.backgroundPosition = "center";
		// this.left.style.backgroundSize = "contain";
		// this.left.style.backgroundRepeat = "no-repeat";
		// this.left.innerHTML = "";
		this.exit = CreateElement("div", {
			classes: ["but-exit"],
			parentToAppend: HelpNavigation,
			style: {
				width: Scale.Wpx(440),
				height: Scale.Hpx(100),
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				boxSizing: "border-box",
				backgroundColor: "rgb(0,0,0,0.5)",
				borderRadius: "100px",
				margin:"10px",
				textAlign: "center",

			},
			mousedown: () =>{
				this.hideHelpCallback?.();
			}
		});

		//this.exit = this.view.querySelector(".but-exit");
		this.exit.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName() + "exit").CssBackground();
		//this.exit.style.backgroundPosition = "center";
		//this.exit.style.backgroundSize = "contain";
		//this.exit.style.backgroundRepeat = "no-repeat";
		//this.exit.innerHTML = "";




		this.right = CreateElement("div", {
			classes: [ "but-right"],
			parentToAppend: HelpNavigation,
			style: {
				width: Scale.Wpx(440),
				height: Scale.Hpx(100),
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				boxSizing: "border-box",
				backgroundColor: "rgb(0,0,0,0.5)",
				borderRadius: "100px",
				margin:"10px",
				textAlign: "center",

			}
		});



		//this.right = this.view.querySelector(".but-right");
		this.right.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName() + "right").CssBackground();
		//this.right.style.backgroundPosition = "center";
		//this.right.style.backgroundSize = "contain";
		//this.right.style.backgroundRepeat = "no-repeat";
		//this.right.innerHTML = "";


		if (Settings.JackpotDisplayType == JackpotDisplayType.DiamondPotOrtiz) {
			//use only for ortiz 
			//O Letter 

			this.ortizO = CreateElement("div", {
				classes: [ "but-right"],
				parentToAppend: this.view,
				style: {
					width: Scale.Wpx(229),
					height: Scale.Hpx(229),
					backgroundPosition: "center",
					backgroundSize: "contain",
					backgroundRepeat: "no-repeat",
					position: "absolute",
					display: "flex",
					right: Scale.Xpx(362),
					transform: "translateZ(0px)",

				}
			});


			this.ortizO.innerHTML = "";
		}
		else {
			//The others JackpotDisplay  types dont have some logo 

		}


		//this.view.style.backgroundImage = this.resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("background2"))
		//this.left.style.backgroundSize = "cover";



		AddMouseDownListener(this.left, () => {
			if (this.selectedPageIndex != 0) {

				this.selectedPageIndex = (this.selectedPageIndex - 1) % this.helpPages.length;
				if (this.selectedPageIndex == -1) {
					this.selectedPageIndex = this.helpPages.length - 1;
				}
				this.selectedPage = this.helpPages[this.selectedPageIndex].View();
				TweenMax.to(this.view.querySelector(".help-content"), 0.5,
					{ x: this.selectedPageIndex * (this.SlideScaleMove) }
				)
			}
		});

		AddMouseDownListener(this.right, () => {
			if (this.selectedPageIndex != this.helpPages.length - 1) {
				this.selectedPageIndex = (this.selectedPageIndex + 1) % this.helpPages.length;
				this.selectedPage = this.helpPages[this.selectedPageIndex].View();
				TweenMax.to(this.view.querySelector(".help-content"), 0.5,
					{ x: this.selectedPageIndex * (this.SlideScaleMove) }
				)
			}
		});

		AddMouseDownListener(this.exit, () => {
			this.view.style.visibility = "hidden";
			this.started = false;
			//this.selectedPageIndex = 0;
			//alert("exit");
		});
	}

	protected started = false;
	public Start(): void {
		this.started = true;
		this.selectedPageIndex = 0;
		TweenMax.set(this.view.querySelector(".help-content"), { x: this.selectedPageIndex * (this.SlideScaleMove) });
	}

	public IsStarted(): boolean {
		return this.started;
	}

	public View(): HTMLElement {
		return this.view;
	}

	public Stop():void{
		this.started = false;
	}

	public UpdateBet(totalBetCents: number, denomCents: number, lines: number): void {
		for (let i = 0; i < this.helpPages.length; i++) {
			this.helpPages[i].UpdateBet(totalBetCents, denomCents, lines);
		}
	}

	protected BackgroundPanel():HelpPanelColor
	{
		 let color:HelpPanelColor ={
		 	backgroundPanelColor: "linear-gradient(rgb(2,1,27),rgb(0,72,160),rgb(0,136,210),rgb(0,72,160),rgba(2,1,27)), linear-gradient(rgba(251, 255, 0, 0.801),rgb(248, 233, 135),rgb(62.4,35.7,3.1),rgb(248,233,135),rgb(62.4,35.7,3.1))",
		 };
		return color;
		
	}

	public Update(): void 
	{
		for (let page of this.helpPages)
		{
			page.Update();
		}
	}
}

class HelpPage implements Resourceful {
	protected readonly symbolsByJackpot = {
		[JackpotDisplayType.RapidDiamondPot]: ["SRA"],
		[JackpotDisplayType.PlayCityLink]: ["SRA"],
		[JackpotDisplayType.RapidDiamondPotStep]: ["SRA"],
	}

	protected title: string = "";
	//path of game
	protected path: string = "";
	protected resid: ResourceIdentifier = null;
	protected view: HTMLElement = null;
	protected pageTitle: HTMLElement = null;
	protected pageContent: HTMLElement = null;
	protected TitleCanvas: MyCanvas = null;
	protected fontHeight: number = Scale.fh(100);
	protected gameName : string = "";



	public constructor(title: string, path: string, resid: ResourceIdentifier) {
		this.title = title;
		this.path = path;
		this.resid = resid.Add("HelpPage");
		this.view = document.createElement("div");
		

		this.view = CreateElement("div", {
			classes: ["help-page"],
			style: {
				position: "relative",
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				display: "flex",
				flexDirection: "column",
				flexShrink: "0",

			}
		});
		// this.view.classList.add("help-page");

		this.pageTitle = CreateElement("div", {
			classes: ["title"],
			parentToAppend:this.view,
			style: {
				width:Scale.Wpx(1920),
				height:Scale.Hpx(108),			

			}
		});
		

		this.pageContent = CreateElement("div", {
			classes: ["page-content"],
			parentToAppend:this.view,
			style: {
				width:Scale.Wpx(1800),
				height:Scale.Hpx(850),
				display:"flex",
				//flexWrap:"wrap",
				//alignItems:"flex-start",
				alignContent:"center",
				justifyContent: "center",
				//flexFlow : "row",
				
			}
		});


		
	}

	public PrepareResources(resourceManager: IWriteOnlyResourceManager): void {

	}

	public ResourcesLoaded(resourceManager: IReadOnlyResourceManager): void {


	}


	protected CreateTitleCanvas() {

		this.TitleCanvas = new MyCanvas(new Size(Scale.W(1915), Scale.H(108)),{
			style:{
				display : "flex",
				zIndex : ""+ZIndex.BonusWin,
			},
		});		
		
		this.RedrawTitleCanvas("", this.TitleCanvas);
		
	}

	

	public RedrawTitleCanvas(text : string , TitleCanvas : MyCanvas ){

		TitleCanvas.Clear();
		TitleCanvas.context.font = "bold " + this.fontHeight + "px " + this.resid.ScopedResourceName("bigwincount");
		let gradient = TitleCanvas.context.createLinearGradient(TitleCanvas.rect.width / 2,
			TitleCanvas.rect.height / 2 - this.fontHeight / 2,
			TitleCanvas.rect.width / 2,
			TitleCanvas.rect.height / 2 + this.fontHeight / 2
		);


		gradient.addColorStop(0, "#F2E416");
		gradient.addColorStop(0.25, "#F2BE22");
		gradient.addColorStop(0.50, "#C2760E");
		gradient.addColorStop(0.75, "#F2BE22");
		gradient.addColorStop(1, "#F2E416");


		TitleCanvas.context.fillStyle = gradient;
		TitleCanvas.context.textBaseline = "middle";
		TitleCanvas.context.textAlign = "center";
		TitleCanvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		TitleCanvas.context.miterLimit = 2;

		TitleCanvas.context.shadowBlur = 20;
		TitleCanvas.context.shadowColor = "black";
		TitleCanvas.context.shadowOffsetX = 5;
		TitleCanvas.context.shadowOffsetY = 5;
		
		//TitleCanvas.context.clearRect(0, 0, (TitleCanvas.rect.width), (TitleCanvas.rect.height));
		TitleCanvas.context.strokeStyle = "black";
		TitleCanvas.context.lineWidth = 10;
		//TitleCanvas.context.strokeText(text, (TitleCanvas.rect.width / 2), (TitleCanvas.rect.height / 4));

		TitleCanvas.context.strokeText(text , TitleCanvas.size.Width / 2 , TitleCanvas.size.Height / 2 )
		TitleCanvas.context.fillText(text , TitleCanvas.size.Width / 2 , TitleCanvas.size.Height / 2 )

		

		TitleCanvas.RestoreContext();


	}

	public View(): HTMLElement {
		return this.view;
	}

	public UpdateBet(totalBetCents: number, denomCents: number, lines: number) { }

	public Update() {}
}


export class HelpPagePayTable extends HelpPage {
	protected paytable: IPaytable = null;
	protected paytableElement: HTMLElement = null;
	//path game of this method	
	protected gamePath = "";
	protected translator: Translator;

	//Symbols
	protected symbols : SlotSymbol[]
	constructor(path: string, resid: ResourceIdentifier, gameName: string, gamePath: string, translator: Translator , symbol : SlotSymbol[] ) {
		super("PayTable", path, resid)

		this.resid = this.resid.Add("HelpPagePayTable");
		this.view.classList.add(this.resid.Scope());
		this.gameName = gameName;
		this.gamePath = gamePath;
		this.translator = translator;
		this.symbols = symbol;

		//this.translator.LoadTranslation(SpanishTranslation);

	}

	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {

		//resourceManager.Add(new HTMLResource(this.path + "helpPagePayTable.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new CSSResource(Settings.ResourcesFolder + "multigame/slot/common/resources/paytable.css", this.resid.ScopedResourceName("css"), this.resid.CSSScope()));
		//seach a image background game
		// resourceManager.Add(new ImageResource(this.gamePath + "background.3.png", this.resid.ScopedResourceName() + "background1"));
		//resourceManager.AddGlobal(new ImageResource(this.gamePath + "paytable.png", ResourceIdentifier.Global.Add([this.gameName, "paytable", "background"]).Scope()));

	}



	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		//resourceManager.Add(new FontResource(resourceManager + "MexicanTequila.ttf", "." + this.resid.ScopedResourceName(["lines", "font"])));

		//use to put a backgoun in a div view
		// this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName() + "background1").CssBackground();
		//this.view.style.backgroundSize = "cover";

		this.CreateTitleCanvas();

		//this.view.innerHTML = resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;

		//this.pageTitle = this.view.querySelector(".title");

		SetStyles(this.pageTitle,
			{
				color: "yellow",
				fontSize: Scale.fhpx(80),
				fontFamily: "NotoSansDisplay-Black",
				textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
			});



		//this.pageTitle.innerHTML = "PAYTABLE";
		//this.View().querySelector(".title").appendChild(this.translator.Anchor(() => this.translator.t.paytable));

		this.RedrawTitleCanvas(this.translator.t.paytable, this.TitleCanvas);
		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);
		this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas(this.translator.t.paytable, this.TitleCanvas));

	}

	public PreprarePaytable(paytableParams: IPaytableParams, resourceManager: IWriteOnlyResourceManager)
	{
		// let paytableParams : IPaytableParams ={
		// 	paytable : this.initData.PayTable,
		// 	symbolSpriteAnims : this.symbolSpriteAnims,
		// 	viewSize : this.viewSize,
		// 	symbols : this.symbols,
		// 	nameGame : this.name,
		// } 
		
		const panelFactory: IPayTableFactory = new PayTableFactory();
		this.paytable =  panelFactory.CreatePayTable(paytableParams);
		this.paytable.PrepareResources(resourceManager);
	
	}

	public LoadPaytable(resourceManager: IReadOnlyResourceManager)
	{

		// const panelFactory: IPayTableFactory = new PayTableFactory();
		// this.paytable =  panelFactory.CreatePayTable(paytablePerSymbol,symbolSpriteAnims,viewSize , this.symbols);
		// // if (Settings.PayTableType == PayTableType.Old) {
		// 	this.paytable = new PayTable(paytablePerSymbol, symbolSpriteAnims, viewSize);
		// }
		// else if ( Settings.PayTableType == PayTableType.Amatic){
		// 	this.paytable = new PayTableAmatic(paytablePerSymbol, symbolSpriteAnims, viewSize);
		// }
		// else if ( Settings.PayTableType == PayTableType.EightSquares){
		// 	this.paytable = new PayTable8Squares(paytablePerSymbol, symbolSpriteAnims, viewSize);
		// }

		//this.paytable.BuildPaytable();
		this.paytable.ResourcesLoaded(resourceManager);		
		this.paytable.View().style.justifyContent = "center";
		this.paytable.View().style.alignItems = "center";
		SetStyles(this.paytable.View(), { transform: "scale(0.7)", transformOrigin : "center", margin: "auto"});
		this.pageContent.appendChild(this.paytable.View());

		// this.paytableElement = this.view.querySelector(".paytable");
		// //this.paytableElement.style.bottom =Scale.Ypx(108);

		// //To center Paytable
		// this.paytableElement.style.width = Scale.Wpx(1800);
		// this.paytableElement.style.height =Scale.Hpx(864);

		// SetStyles(this.view.querySelectorAll(".paytable-symbol-container"),
		// 	{
		// 		backgroundImage: resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add([this.gameName, "paytable", "background"]).Scope()).CssBackground(),
		// 		borderRadius:Scale.XYpx(0),
		// 		backgroundSize: "contain",
		// 		backgroundRepeat: "no-repeat",
		// 		backgroundPosition: "center",
		// 	});

			this.paytable.Update(true);		


	}

	public UpdatePayTable(message: SlotGameMessages.BetChange) {
		if (this.paytable != null) {

			this.paytable.SetBet(message);
		}

	}


	public override View(): HTMLElement {
		return this.view;
	}

	public override Update()
	{
		this.paytable.Update(false);
		if(this.TitleCanvas.WasContextLost()){
			this.RedrawTitleCanvas(this.translator.t.paytable , this.TitleCanvas);
		}
	}
}

export class HelpPagePayLines extends HelpPage {
	protected lines: number[][];
	protected slotSize: Size = null;

	//private colors: Color[] = [];
	protected gamePath = "";
	protected translator: Translator;
	protected game: SimpleSlotGameState = null;

	constructor(path: string, resid: ResourceIdentifier, lines: number[][], viewSize: Size, gamePath: string, translator: Translator, initData: SlotGameInitData, game: SimpleSlotGameState) {
		super("PayLines", path, resid)

		this.resid = this.resid.Add("HelpPagePayLines");
		

		let maxBetLines = initData.EnabledBets.map(b => b.Bet.Lines).reduce((a, b) => Math.max(a, b));
		this.lines = lines.slice(0, maxBetLines);

		this.slotSize = viewSize;
		this.gamePath = gamePath;
		this.translator = translator;
		this.game = game;
	}
	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//resourceManager.Add(new HTMLResource(this.path + "helpPagePayLines.html", this.resid.ScopedResourceName("html")));
		//seach a image background game
		// resourceManager.Add(new ImageResource(this.gamePath + "background.3.png", this.resid.ScopedResourceName() + "background2"));


	}
	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		//use to put a backgoun in a div view
		// this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName() + "background2").CssBackground();
		this.CreateTitleCanvas();

		this.view.style.backgroundSize = "cover";

		//this.view.innerHTML = resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;

		//this.pageTitle = this.view.querySelector(".title");

		SetStyles(this.pageTitle,
			{
				color: "yellow",
				fontSize: Scale.fhpx(80),
				fontFamily: "NotoSansDisplay-Black",
				textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
				justifyContent: "space-evenly",
			});/* 
		this.pageTitle.style.color = "yellow";
		this.pageTitle.style.fontSize = 50+"px";
		
		this.pageTitle.style.textAlign ="center"; */
		this.PlayLines(this.lines, this.slotSize);

		this.RedrawTitleCanvas(this.translator.t.paylines, this.TitleCanvas);
		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);
		this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas(this.translator.t.paylines, this.TitleCanvas));

	}

	public override View(): HTMLElement {
		//this.view.style.visibility = "hidden";
		return this.view;
	}


	protected PlayLines(lines: number[][], slotSize: Size): void {
		/* let linesContent = "";
		this.colors = MakeColorGradient(2.4, 2.4, 2.4, 0, 2, 4, 128, 127, 50, 1);


		for (let li = 0; li < lines.length; li++)
		{
			let color: Color = this.colors[li % this.colors.length];
			let lineNumber = li + 1;
			linesContent += `<div class="lines-line" id="linesline">
							<div class="lines-number" id="linesnumber">${lineNumber}</div>
							<div class="lines-window" id="lineswindow">`;

			for (let ri = 0; ri < lines[li].length; ri++) 
			{
				linesContent += `<div class="lines-reel" id="linesreel">`;

				for (let si = 0; si < slotSize.height; si++) 
				{
					if (si == lines[li][ri])
						//linesContent += `<div class="lines-symbol mark" style="background-color:rgba (${color.r, color.g, color.b, color.a})"></div>`;
						linesContent += `<div class="lines-symbol mark" style="background:rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})"></div>`;
					else
						linesContent += `<div class="lines-symbol"></div>`;
				}
				linesContent += `</div>`;
			}
			linesContent += `</div></div>`;
		} */

		//this.pageContent = this.view.querySelector(".page-content");
		//let paylines = this.view.querySelectorAll("#plines");
		let gamePlayLines = this.game as unknown as SlotGame;

		let paylines = CreateElement("div", {
			classes: ["plines"],
			parentToAppend:this.pageContent,
			style: {
			width: "100%",
			height: "100%",				
			margin:"0 auto",
			display:"flex",
			flexWrap:"wrap",
			alignItems:"flex-start",
			alignContent:"center",
			}
		});

		SetStyles(paylines,
			{
				alignContent: "center",
				justifyContent: "center",
			});

		let PayTableDivSize:Size =  new Size(150,76);
		
		paylines.innerHTML = gamePlayLines.CreatePlayLines(lines, slotSize, -1,PayTableDivSize,true);
		this.view.appendChild(this.pageContent);
	}

	public override Update() {
		if (this.TitleCanvas.WasContextLost()) {
			this.RedrawTitleCanvas(this.translator.t.paylines, this.TitleCanvas);
		}
	}
}

export class HelpPageExpandingWildBulk extends HelpPage {
	protected WildBulk: HTMLElement = null;
	protected gamePath = "";

	protected wildScreen: HTMLElement = null;
	//protected wildScreen2: HTMLElement = null;
	protected wildBulkDescription: HTMLElement = null;
	protected translator: Translator;
	protected pickImage: HTMLElement = null;

	protected BonusTrigger: HTMLElement = null;
	protected commonPath: string = Settings.ResourcesFolder + "multigame/slot/common/resources/PickBonus/";
	protected initData: SlotGameInitData;
	protected InfoCanvas: MyCanvas[] = [];
	protected InfofontHeight: number =Scale.fh(60);
	protected InfoSymbolTrigger: HTMLElement[] = [];
	protected Symbols : Symbol[] = [];
	protected bonusAndScatterSymbols : string [] = [];
	readonly symbolCollectionMap: Map<string, SymbolsCollectionResources> = null


	constructor(path: string, resid: ResourceIdentifier, gamePath: string, translator: Translator, initData: SlotGameInitData , symbolCollectionMap: Map<string, SymbolsCollectionResources>,) {
		super("ExpandingWildBulk", path, resid)

		this.resid = this.resid.Add("HelpPageExpandingWildBulk");
		this.gamePath = gamePath;
		this.translator = translator;
		this.initData = initData;		
		this.pageContent.style.flexDirection = "column";
		this.pageContent.style.alignItems = "flex-start";
		//this.pageContent.style.flexFlow = "row";
		this.pageContent.style.flexWrap = "wrap";	


		// this.bonusAndScatterSymbols = [
		// 	...initData.Symbols.filter(s=>s.SymbolType == "Scatter").map(s=>s.ID),
		// 	...initData.BonusTriggers.map(b=>b.SymbolName)
		// ].filter(Filter.UniqueItem);
		this.bonusAndScatterSymbols = [];
		//console.log("ScatterAndBonus:",this.bonusAndScatterSymbols)
		this.symbolCollectionMap = symbolCollectionMap;
	}

	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
	   //resourceManager.Add(new HTMLResource(this.path + "helpPageExpandingWildBulk.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new ImageResource(this.gamePath + "bulkwild.png", this.resid.ScopedResourceName(["wild", "image"])));
		// resourceManager.Add(new ImageResource(this.gamePath + "background.3.png", this.resid.ScopedResourceName(["background", "image"])));
		//resourceManager.Add(new ImageResource(this.gamePath + "bulkwildOnScreen.png", this.resid.ScopedResourceName(["wildScreen", "image"])));
		
		// if ( this.initData.BonusConfiguration?.BigSymbolFreegames != null || this.initData.BonusConfiguration?.FreeGameBonus != null )
		// {
		// 	resourceManager.Add(new ImageResource(this.gamePath + "trigger.png", this.resid.ScopedResourceName(["pick", "image"])));
		// }
		// if ( this.initData.BonusConfiguration?.PickBonus != null )
		// {
		// 	resourceManager.Add(new ImageResource(this.commonPath + "trigger.png", this.resid.ScopedResourceName(["diamon", "image"])));
		// }
		// if ( this.initData.BonusConfiguration?.SpinAndHold != null || this.initData.BonusConfiguration?.BigSymbolSpinAndHold != null )
		// {
		// 	resourceManager.Add(new ImageResource(this.gamePath + "HoldAndSpin/trigger.png", this.resid.ScopedResourceName(["TriggerStickySpin", "image"])));
		// } 	
		// if (this.initData.BonusConfiguration?.ExtendedSpinAndHold != null) {
		// 	let triggerPath = this.gamePath + "ExtendedHoldAndSpin/trigger.png";
		// 	if (this.symbolsByJackpot[Settings.JackpotDisplayType]?.includes("SRA")) {
		// 		triggerPath = this.gamePath + "ExtendedHoldAndSpin/SymbolJackpots/" + Settings.JackpotDisplayType + "/Help/trigger.png";
		// 	}
		// 	resourceManager.Add(new ImageResource(triggerPath, this.resid.ScopedResourceName(["ExtendedTriggerStickySpin", "image"])));
		// } 
	}

	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		// this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "image"])).CssBackground();

		this.view.style.backgroundSize = "cover";

		//this.view.innerHTML = resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;

		this.CreateTitleCanvas();


		this.wildBulkDescription = CreateElement("div", {
			classes: ["wildBulkDescriptionBulk"],
			parentToAppend:this.pageContent,
			style: {
				width:Scale.Wpx(1800),
				height:Scale.Hpx(1800),
				/* boxSizing:"border-box",
				border:"2px solid red", */
				color: "yellow",
				fontSize:Scale.fhpx(42),
				fontFamily: "NotoSansDisplay-Black",
				//textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
				display: "flex",
				flexDirection: "column",
			}
		});


		this.BonusTrigger = document.createElement("div");
		SetStyles(this.BonusTrigger,
			{
				//width:Scale.Wpx(500),
				//height:Scale.Hpx(250),
				//backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["diamon", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "flex",
				verticalAlign: "middle",
			});		

		this.WildBulk = document.createElement("span");
		SetStyles(this.WildBulk,
			{
				width:Scale.Wpx(300),
				height:Scale.Hpx(250),
				//backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["wild", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});

			//find all special symbols
		let symbolsNamesArray = this.initData.Symbols.filter(symbol => symbol.SymbolType != "Regular")		

		//let symbolPath = `ScreenAll-Multigame-${this.initData.Name}-Symbol`;
		//search wild symbol
		let nameWild = symbolsNamesArray.find(symbol => symbol.ID == "Wild");
		//create img form sprite added to resources manager		
		let wildReelImg = this.symbolCollectionMap.get("Symbol_"+nameWild.ID).imgResource.cloneNode(true) as HTMLSpanElement;
		wildReelImg.style.width = Scale.Wpx(300);
		wildReelImg.style.height =Scale.Hpx(250);
		wildReelImg.style.display = "flex";
		this.WildBulk.appendChild(wildReelImg);	
		
		
		//filter scatter symbols and takes only ID value		
		let symbolsSize = new Size(Scale.W(Math.max(300  - (this.bonusAndScatterSymbols.length * 50), 150 )), Scale.H(Math.max(250  - (this.bonusAndScatterSymbols.length * 25) ,150)))
		
		this.bonusAndScatterSymbols.forEach(symbol=>{
			let symbolImg = this.symbolCollectionMap.get("Symbol_"+symbol).imgResource.cloneNode(true) as HTMLSpanElement;
			symbolImg.style.width = "auto";
			symbolImg.style.height = symbolsSize.Height + "px";
			symbolImg.style.display = "flex";
			this.BonusTrigger.appendChild(symbolImg);
		})		

		//symbolPath = null;		
		wildReelImg = null;		
		nameWild = null;


		this.wildScreen = document.createElement("div");
		SetStyles(this.wildScreen,
			{
				width:Scale.Wpx(451),
				height:Scale.Hpx(254),				
				display: "inline-block",				
				margin: "0px",
				left : Scale.Xpx(-10),
				position : "relative",
			});

		let wildScreenShoot = new HelpWildScreenShoot(this.initData , this.symbolCollectionMap, SymbolTypeAnim.Sprites);
		await wildScreenShoot.ResourcesLoaded(resourceManager);
		this.wildScreen.appendChild(wildScreenShoot.View());

		SetStyles(this.pageTitle,
			{
				color: "yellow",
				fontSize:Scale.fhpx(80),
				fontFamily: "NotoSansDisplay-Black",
				textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
			});
	

		this.RedrawTitleCanvas(this.translator.t.wildBulkTitle, this.TitleCanvas);
		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);
		this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas(this.translator.t.wildBulkTitle, this.TitleCanvas));

		this.CreateContainerInfo(resourceManager);

	}

	public override View(): HTMLElement {
		return this.view;
	}

	public override Update() {
		if (this.TitleCanvas.WasContextLost()) {
			this.RedrawTitleCanvas(this.translator.t.wildBulkTitle, this.TitleCanvas);
		}
		for( let canvas of this.InfoCanvas){
			if(canvas.WasContextLost()){
				this.RedrawCanvaInfo();
			}
		}
	}

	public RedrawCanvaInfo(){
		this.SetInfoCanvas(this.translator.t.WildBulkDescription, this.InfoCanvas[0], 0, this.InfofontHeight);
		this.SetInfoCanvas(this.translator.t.WildTriggerBonus, this.InfoCanvas[1], Scale.X(0), this.InfofontHeight);
		this.SetInfoCanvas(this.translator.t.WildReplaceDescription, this.InfoCanvas[2], 0, this.InfofontHeight);
	}


	protected CreateContainerInfo(resourceManager: IReadOnlyResourceManager) {

		let starPositon: number = Scale.Y(117);
		let heightCanvasDiv: number = Scale.H(300);		
		for (let j = 0; j < 3; j++) {
			this.InfoSymbolTrigger[j] = document.createElement("div");
			this.InfoSymbolTrigger[j].style.width ="90%";
			//this.InfoSymbolTrigger[j].style.height = heightCanvasDiv + "px";
			this.InfoSymbolTrigger[j].style.right = Scale.Xpx(96);
			this.InfoSymbolTrigger[j].style.top = starPositon + "px";
			this.InfoSymbolTrigger[j].style.display = "flex";
			this.InfoSymbolTrigger[j].style.flexDirection = "row";
			this.InfoSymbolTrigger[j].style.color= "yellow";
			this.InfoSymbolTrigger[j].style.fontSize=Scale.fhpx(42);
			this.InfoSymbolTrigger[j].style.fontFamily="NotoSansDisplay-Black";
			this.InfoSymbolTrigger[j].style.webkitTextStroke=`${ Scale.fhpx(3)} black`;
			this.InfoSymbolTrigger[j].style.textAlign="left";	
			this.InfoSymbolTrigger[j].style.lineHeight="initial";
			this.InfoSymbolTrigger[j].style.margin="auto";
			this.InfoSymbolTrigger[j].style.justifyContent="center";
			this.InfoSymbolTrigger[j].style.alignItems="center";

			if (j == 0) {
				this.InfoSymbolTrigger[j].appendChild(this.WildBulk);
			}

			if (j == 1) {
				this.InfoSymbolTrigger[j].style.flexDirection = "row-reverse";
				this.InfoSymbolTrigger[j].appendChild(this.BonusTrigger);
				//this.InfoSymbolTrigger[j].appendChild(this.pickImage);
			}

			if (j == 2) {
				this.InfoSymbolTrigger[j].appendChild(this.wildScreen);
			}
			this.wildBulkDescription.appendChild(this.InfoSymbolTrigger[j]);
			starPositon = starPositon + heightCanvasDiv;
		}

		let translatedMessage1 = this.translator.Translate(() => this.translator.t.WildBulkDescription);		
		this.InfoSymbolTrigger[0].appendChild(translatedMessage1.location);

		let translatedMessage2 = this.translator.Translate(() => this.translator.t.WildTriggerBonus);		
		this.InfoSymbolTrigger[1].appendChild(translatedMessage2.location);

		let translatedMessage3 = this.translator.Translate(() => this.translator.t.WildReplaceDescription);		
		translatedMessage3.location.style.right = Scale.Xpx(-83);
		translatedMessage3.location.style.position = "relative";
		this.InfoSymbolTrigger[2].appendChild(translatedMessage3.location);

	}

	public SetInfoCanvas(text: string, Canvas: MyCanvas, xposition: number, fontHeight?: number) {
		Canvas.context.clearRect(0, 0, (Canvas.rect.width), (Canvas.rect.height));


		//add gradient
		Canvas.context.font = "bold " + this.InfofontHeight + "px " + "NotoSansDisplay-Black";

		Canvas.context.fillStyle = "yellow";

		Canvas.context.textBaseline = "middle";
		Canvas.context.textAlign = "center";
		Canvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		Canvas.context.miterLimit = Scale.fh(2);

		Canvas.context.shadowBlur = Scale.fh(10);
		Canvas.context.shadowColor = "black";
		Canvas.context.shadowOffsetX = Scale.fh(8);
		Canvas.context.shadowOffsetY = Scale.fh(8);


		let str = text;
		let x = xposition;
		let y = 0;
		let lineheight = fontHeight;
		let lines = str.split('\n');



		y = (Canvas.rect.height / 2) - ((fontHeight * lines.length) / 2);
		let resultado = (fontHeight * lines.length) / 2;

		for (let row = 0; row < lines.length; row++) {
			Canvas.context.strokeStyle = "black";
			Canvas.context.lineWidth =Scale.fh(10);
			Canvas.context.strokeText(lines[row], Canvas.size.Width / 2 , y + (row * lineheight));
			//Canvas.context.strokeStyle = "white";
			//Canvas.context.lineWidth =Scale.fh(10) /Scale.fh(4);
			Canvas.context.strokeText(lines[row], Canvas.size.Width / 2 , y + (row * lineheight));
			Canvas.context.fillText(lines[row], Canvas.size.Width / 2 , y + (row * lineheight));
		}

		Canvas.RestoreContext();
	}
	
}

export class HelpPageExpandingWildReel extends HelpPage {
	protected wildImage: HTMLElement = null;
	protected gamePath = "";

	protected wildReelDescription: HTMLElement = null;

	protected wildScreen: HTMLElement = null;
	//protected wildScreen2: HTMLElement = null;
	protected translator: Translator;
	//protected pickImage: HTMLElement = null;
	protected BonusTrigger: HTMLElement = null;
	protected commonPath: string = Settings.ResourcesFolder + "multigame/slot/common/resources/PickBonus/";
	protected initData: SlotGameInitData;
	protected InfoCanvas: MyCanvas[] = [];
	protected InfofontHeight: number = Scale.fh(60);
	protected InfoSymbolTrigger: HTMLElement[] = [];
	protected bonusAndScatterSymbols : string [] = [];
	readonly symbolCollectionMap: Map<string, SymbolsCollectionResources> = null;
	readonly symbolTypeAnim : SymbolTypeAnim = null;



	constructor(path: string, resid: ResourceIdentifier, gamePath: string, translator: Translator, initData: SlotGameInitData,symbolCollectionMap: Map<string, SymbolsCollectionResources>, symbolTypeAnim : SymbolTypeAnim) {
		super("ExpandingWildReel", path, resid)

		this.resid = this.resid.Add("HelpPageExpandingWildReel");
		this.gamePath = gamePath;
		this.translator = translator;
		this.initData = initData;
		this.pageContent.style.flexDirection = "column";
		this.pageContent.style.alignItems = "flex-start";
		//this.pageContent.style.flexFlow = "row";
		this.pageContent.style.flexWrap = "wrap";	
		
		// this.bonusAndScatterSymbols = [
		// 	...initData.Symbols.filter(s=>s.SymbolType == "Scatter").map(s=>s.ID),
		// 	...initData.BonusTriggers.map(b=>b.SymbolName)
		// ].filter(Filter.UniqueItem);
		this.bonusAndScatterSymbols = [];
		//console.log("ScatterAndBonus:",this.bonusAndScatterSymbols)
		this.symbolCollectionMap = symbolCollectionMap;
		this.symbolTypeAnim = symbolTypeAnim;
	}

	protected wildScreenShoot : HelpWildScreenShoot = null;
	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		this.wildScreenShoot = new HelpWildScreenShoot(this.initData , this.symbolCollectionMap, this.symbolTypeAnim);
		this.wildScreenShoot.PrepareResources(resourceManager);
	}

	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		this.view.style.backgroundSize = "cover";
		this.CreateTitleCanvas();

		this.wildReelDescription = CreateElement("div", {
			classes: ["wildBulkDescriptionReel"],
			parentToAppend:this.pageContent,
			style: {
				width:Scale.Wpx(1800),
				height:Scale.Hpx(1800),
				/* boxSizing:"border-box",
				border:"2px solid red", */
				color: "yellow",
				fontSize:Scale.fhpx(42),
				fontFamily: "NotoSansDisplay-Black",
				//textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
				display: "flex",
				flexDirection: "column",
			}
		});

		this.wildImage = document.createElement("div");
		SetStyles(this.wildImage,
			{
				width:Scale.Wpx(300),
				height:Scale.Hpx(250),				
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});


		//find all special symbols
		let symbolsNamesArray = this.initData.Symbols.filter(symbol => symbol.SymbolType != "Regular")
		let symbolPath = `ScreenAll-Multigame-${this.initData.Name}-Symbol`;
		//search wild symbol
		let nameWild = symbolsNamesArray.find(symbol => symbol.ID == "Wild");
		
		let wildReelImg = this.symbolCollectionMap.get("Symbol_"+nameWild.ID).imgResource.cloneNode(true) as HTMLSpanElement;
		wildReelImg.style.width = Scale.Wpx(300);
		wildReelImg.style.height =Scale.Hpx(250);
		wildReelImg.style.display = "flex";

		//let wildReelImg = wildReelMap.get("Wild");
		//wildReelImg.style.display = "flex";
		this.wildImage.appendChild(wildReelImg);		


		this.BonusTrigger = document.createElement("div");
		SetStyles(this.BonusTrigger,
			{				
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "flex",
				verticalAlign: "middle",
			});


		//filter scatter symbols and takes only ID value
		
		let symbolsSize = new Size(Scale.W(Math.max(300  - (this.bonusAndScatterSymbols.length * 50), 100 )), Scale.H(Math.max(250  - (this.bonusAndScatterSymbols.length * 25) ,50)))
		//create img form sprite added to resources manager
		this.bonusAndScatterSymbols.forEach(symbol=>{
			let symbolImg = this.symbolCollectionMap.get("Symbol_"+symbol).imgResource.cloneNode(true) as HTMLSpanElement;
			symbolImg.style.width = "auto";
			symbolImg.style.height = symbolsSize.Height + "px";
			symbolImg.style.display = "flex";
			this.BonusTrigger.appendChild(symbolImg);
		})

		symbolPath = null;
		//wildReelMap = null;
		wildReelImg = null;			
		nameWild = null;
		symbolsNamesArray = null;
		
		this.wildScreen = document.createElement("div");
		SetStyles(this.wildScreen,
			{
				width:Scale.Wpx(451),
				height:Scale.Hpx(254),				
				display: "inline-block",
				verticalAlign: "middle",
				margin: "0px",				
				position : "relative",
			});
			
		await this.wildScreenShoot.ResourcesLoaded(resourceManager);
		this.wildScreen.appendChild(this.wildScreenShoot.View());
		this.wildReelDescription.appendChild(this.wildScreen);

		SetStyles(this.pageTitle,
			{
				color: "yellow",
				fontSize:Scale.fhpx(42),
				fontFamily: "NotoSansDisplay-Black",
				textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
			});

		this.RedrawTitleCanvas(this.translator.t.wildReelTitle, this.TitleCanvas);
		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);
		this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas(this.translator.t.wildReelTitle, this.TitleCanvas));
		this.CreateContainerCanvas(resourceManager);
	}

	public override View(): HTMLElement {
		return this.view;
	}

	public override Update() {
		if (this.TitleCanvas.WasContextLost()) {
			this.RedrawTitleCanvas(this.translator.t.wildReelTitle, this.TitleCanvas);
		}
	}

	protected CreateContainerCanvas(resourceManager: IReadOnlyResourceManager) {
		
	
		let starPositon: number =Scale.Y(117);
		let heightCanvasDiv: number =Scale.H(300);
		let widthDiv: number = Scale.W(1728);
		for (let j = 0; j < 3; j++) {


			this.InfoSymbolTrigger[j] = document.createElement("div");
			this.InfoSymbolTrigger[j].style.width = "90%";
			//this.InfoSymbolTrigger[j].style.height = heightCanvasDiv + "px";
			this.InfoSymbolTrigger[j].style.right =Scale.Xpx(96);
			this.InfoSymbolTrigger[j].style.top = starPositon + "px";
			this.InfoSymbolTrigger[j].style.display = "flex";
			this.InfoSymbolTrigger[j].style.flexDirection = "row";			
			this.InfoSymbolTrigger[j].style.color = "yellow";
			//this.InfoSymbolTrigger[j].style.fontSize = Scale.fhpx(70);
			this.InfoSymbolTrigger[j].style.fontFamily = "NotoSansDisplay-Black";
			this.InfoSymbolTrigger[j].style.webkitTextStroke = `${ Scale.fhpx(3)} black`;
			this.InfoSymbolTrigger[j].style.textAlign = "left";
			this.InfoSymbolTrigger[j].style.lineHeight = "initial";
			this.InfoSymbolTrigger[j].style.margin = "auto";
			this.InfoSymbolTrigger[j].style.justifyContent="center";
			this.InfoSymbolTrigger[j].style.alignItems="center";

			if (j == 0) {
				this.InfoSymbolTrigger[j].appendChild(this.wildImage);
				//this.SetInfoCanvas(this.translator.t.WildReelDescription, this.InfoCanvas[j], 0, this.InfofontHeight);
			}

			if (j == 1) {
				this.InfoSymbolTrigger[j].style.flexDirection = "row-reverse";
				this.InfoSymbolTrigger[j].appendChild(this.BonusTrigger);				
			}

			if (j == 2) {
				this.InfoSymbolTrigger[j].appendChild(this.wildScreen);				
			}			
			this.wildReelDescription.appendChild(this.InfoSymbolTrigger[j]);
			starPositon = starPositon + heightCanvasDiv;
		}

		let translatedMessage1 = this.translator.Translate(() => this.translator.t.WildReelDescription);
		this.InfoSymbolTrigger[0].appendChild(translatedMessage1.location);

		let translatedMessage2 = this.translator.Translate(() => this.translator.t.WildTriggerBonus);
		this.InfoSymbolTrigger[1].appendChild(translatedMessage2.location);

		let translatedMessage3 = this.translator.Translate(() => this.translator.t.WildReplaceDescription);
		translatedMessage3.location.style.right = Scale.Xpx(-83);
		translatedMessage3.location.style.position = "relative";
		this.InfoSymbolTrigger[2].appendChild(translatedMessage3.location);
	}
}

export class HelpPageWild extends HelpPage {
	protected wildImage: HTMLElement = null;
	protected gamePath = "";

	protected wildReelDescription: HTMLElement = null;

	protected wildScreen: HTMLElement = null;
	//protected wildScreen2: HTMLElement = null;
	protected translator: Translator;
	//protected pickImage: HTMLElement = null;
	protected BonusTrigger: HTMLElement = null;
	protected commonPath: string = Settings.ResourcesFolder + "multigame/slot/common/resources/PickBonus/";
	protected initData: SlotGameInitData;
	protected InfoCanvas: MyCanvas[] = [];
	protected InfofontHeight: number = Scale.fh(60);
	protected InfoSymbolTrigger: HTMLElement[] = [];
	protected bonusAndScatterSymbols : string [] = [];
	readonly symbolCollectionMap: Map<string, SymbolsCollectionResources> = null;

	protected reelsWithWild: number[] = [];



	constructor(path: string, resid: ResourceIdentifier, gamePath: string, translator: Translator, initData: SlotGameInitData, symbolCollectionMap: Map<string, SymbolsCollectionResources>,) {
		super("WildStack", path, resid)

		this.resid = this.resid.Add("HelpPageWildStack");
		this.gamePath = gamePath;
		this.translator = translator;
		this.initData = initData;
		this.pageContent.style.flexDirection = "column";
		this.pageContent.style.alignItems = "flex-start";
		//this.pageContent.style.flexFlow = "row";
		this.pageContent.style.flexWrap = "wrap";	


		let symbolsConverted = this.initData.Symbols.filter(s => s.ID.includes("SRA"));
		console.log("symbolsConverted:",symbolsConverted);
		
		this.bonusAndScatterSymbols = [
			...initData.Symbols.filter(s=>s.SymbolType == "Scatter").map(s=>s.ID),
			...symbolsConverted.map(b=>b.ID)
		].filter(Filter.UniqueItem);
		//this.bonusAndScatterSymbols = [];
		//console.log("ScatterAndBonus:",this.bonusAndScatterSymbols)
		this.symbolCollectionMap = symbolCollectionMap;
	}

	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
	
	}

	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		this.view.style.backgroundSize = "cover";
		this.CreateTitleCanvas();

		this.wildReelDescription = CreateElement("div", {
			classes: ["wildBulkDescriptionReel"],
			parentToAppend:this.pageContent,
			style: {
				width:Scale.Wpx(1800),
				height:Scale.Hpx(1800),
				/* boxSizing:"border-box",
				border:"2px solid red", */
				color: "yellow",
				fontSize:Scale.fhpx(42),
				fontFamily: "NotoSansDisplay-Black",
				//textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
				display: "flex",
				flexDirection: "column",
			}
		});

		this.wildImage = document.createElement("div");
		SetStyles(this.wildImage,
			{
				width:Scale.Wpx(300),
				height:Scale.Hpx(250),				
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});


		//find all special symbols
		let symbolsNamesArray = this.initData.Symbols.filter(symbol => symbol.SymbolType != "Regular")
		let symbolPath = `ScreenAll-Multigame-${this.initData.Name}-Symbol`;
		//search wild symbol
		let nameWild = symbolsNamesArray.find(symbol => symbol.ID == "Wild");			
		//let wildReelImg = wildReelMap.get("Wild");
		let wildReelImg = this.symbolCollectionMap.get("Symbol_"+nameWild.ID).imgResource.cloneNode(true) as HTMLSpanElement;
		wildReelImg.style.width = Scale.Wpx(300);
		wildReelImg.style.height =Scale.Hpx(250);
		wildReelImg.style.display = "flex";
		//wildReelImg.style.display = "flex";
		this.wildImage.appendChild(wildReelImg);		


		this.BonusTrigger = document.createElement("div");
		SetStyles(this.BonusTrigger,
			{				
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "flex",
				verticalAlign: "middle",
			});


		//filter scatter symbols and takes only ID value
		
		let symbolsSize = new Size(Scale.W(Math.max(300  - (this.bonusAndScatterSymbols.length * 50), 100 )), Scale.H(Math.max(250  - (this.bonusAndScatterSymbols.length * 25) ,50)))
		//create img form sprite added to resources manager
		this.bonusAndScatterSymbols.forEach(symbol=>{
			let symbolImg = this.symbolCollectionMap.get("Symbol_"+symbol).imgResource.cloneNode(true) as HTMLSpanElement;
			symbolImg.style.width = "auto";
			symbolImg.style.height = symbolsSize.Height + "px";
			symbolImg.style.display = "flex";
			this.BonusTrigger.appendChild(symbolImg);
		})

		symbolPath = null;		
		wildReelImg = null;			
		nameWild = null;
		symbolsNamesArray = null;
		
		this.wildScreen = document.createElement("div");
		SetStyles(this.wildScreen,
			{
				width:Scale.Wpx(451),
				height:Scale.Hpx(254),				
				display: "inline-block",
				verticalAlign: "middle",
				margin: "0px",				
				position : "relative",
			});
			
		let wildScreenShoot = new HelpWildScreenShoot(this.initData, this.symbolCollectionMap , SymbolTypeAnim.Sprites);
		await wildScreenShoot.ResourcesLoaded(resourceManager);
		this.wildScreen.appendChild(wildScreenShoot.View());
		this.wildReelDescription.appendChild(this.wildScreen);

		SetStyles(this.pageTitle,
			{
				color: "yellow",
				fontSize:Scale.fhpx(42),
				fontFamily: "NotoSansDisplay-Black",
				textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
			});

		this.RedrawTitleCanvas("WILD STACK", this.TitleCanvas);
		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);
		this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas("WILD STACK", this.TitleCanvas));
		this.CreateContainerCanvas(resourceManager);
	}

	public override View(): HTMLElement {
		return this.view;
	}

	public override Update() {
		if (this.TitleCanvas.WasContextLost()) {
			this.RedrawTitleCanvas("WILD STACK", this.TitleCanvas);
		}
	}

	protected CreateContainerCanvas(resourceManager: IReadOnlyResourceManager) {
		
	
		let starPositon: number =Scale.Y(117);
		let heightCanvasDiv: number =Scale.H(300);
		let widthDiv: number = Scale.W(1728);
		for (let j = 0; j < 3; j++) {


			this.InfoSymbolTrigger[j] = document.createElement("div");
			this.InfoSymbolTrigger[j].style.width = "90%";
			//this.InfoSymbolTrigger[j].style.height = heightCanvasDiv + "px";
			this.InfoSymbolTrigger[j].style.right =Scale.Xpx(96);
			this.InfoSymbolTrigger[j].style.top = starPositon + "px";
			this.InfoSymbolTrigger[j].style.display = "flex";
			this.InfoSymbolTrigger[j].style.flexDirection = "row";			
			this.InfoSymbolTrigger[j].style.color = "yellow";
			//this.InfoSymbolTrigger[j].style.fontSize = Scale.fhpx(70);
			this.InfoSymbolTrigger[j].style.fontFamily = "NotoSansDisplay-Black";
			this.InfoSymbolTrigger[j].style.webkitTextStroke = `${ Scale.fhpx(3)} black`;
			this.InfoSymbolTrigger[j].style.textAlign = "left";
			this.InfoSymbolTrigger[j].style.lineHeight = "initial";
			this.InfoSymbolTrigger[j].style.margin = "auto";
			this.InfoSymbolTrigger[j].style.justifyContent="center";
			this.InfoSymbolTrigger[j].style.alignItems="center";

			if (j == 0) {
				let translatedMessage1 = this.translator.Translate(() => this.translator.t.wildStackDescription(this.wildImage.outerHTML, this.reelsWithWild));
				this.InfoSymbolTrigger[0].appendChild(translatedMessage1.location);
			}

			if (j == 1) {
				this.InfoSymbolTrigger[j].style.flexDirection = "row-reverse";
				this.InfoSymbolTrigger[j].appendChild(this.BonusTrigger);				
			}

			if (j == 2) {
				this.InfoSymbolTrigger[j].appendChild(this.wildScreen);				
			}			
			this.wildReelDescription.appendChild(this.InfoSymbolTrigger[j]);
			starPositon = starPositon + heightCanvasDiv;
		}
		let translatedMessage2 = this.translator.Translate(() => this.translator.t.WildStackFeature);
		this.InfoSymbolTrigger[1].appendChild(translatedMessage2.location);
	}
}


export class HelpPageFreeGameBonus extends HelpPage {
	
	protected TitleElement: HTMLElement = null;
	protected ContainerElement: HTMLElement = null;
	//protected view: HTMLElement = null;
	protected gamePath: string = null;
	protected translator: Translator = null;
	protected description: HTMLElement = null;
	protected trigger: HTMLElement = null;
	protected descriptionTranslate: TranslatedLocation = null;
	protected plusOneImg: HTMLElement = null;
	protected symbolTriggerImg: HTMLElement = null;
	protected screenShootBigFG: HTMLElement = null;
	protected infoContainer: HTMLElement[] = [];
	protected infoPlusOne: HTMLElement[] = [];
	//protected InfoCanvas: MyCanvas[] = [];
	//protected InfoCanvasCtx:CanvasRenderingContext2D[] =[] ;
	protected infofontHeight: number = Scale.fh(48);
	protected plusOnePath: string = Settings.ResourcesFolder + "multigame/slot/common/resources/FreeGameBonus/";
	protected numberFreeGames: HTMLElement;
	protected canvasNumberFreeGames: MyCanvas;
	protected canvasNumberFreeGamesCtx: MyCanvasContext;	
	protected NumbreFGfontHeight: number = Scale.fh(300);
	protected bonusNameSymbol : string  []= [];
	protected startingOptionsFreegames : FreegamesOption [] = [];
	protected plusOneFeature : PlusOneFeatureConfiguration  = null;
	protected simpleBonusTriggers : IPublicSimpleBonusTrigger[] = [];
	readonly symbolCollectionMap: Map<string, SymbolsCollectionResources> = null;

	constructor(path: string, resid: ResourceIdentifier, gamePath: string, translator: Translator, gameName : string , bonusTrigger : IPublicSimpleBonusTrigger[] , freegameBonusConfiguration: FreegamesCommonConfiguration, symbolCollectionMap: Map<string, SymbolsCollectionResources>) {
		super("FreeGameBonus", path, resid)
		this.resid = this.resid.Add("FreeGameBonus");
		this.gamePath = gamePath;
		this.translator = translator;		
		this.pageContent.style.flexDirection = "row";
		this.pageContent.style.alignItems = "flex-start";		
		this.pageContent.style.flexWrap = "wrap";	
		this.gameName = gameName;		
		this.simpleBonusTriggers = freegameBonusConfiguration.SimpleBonusTriggers;		
		//this.bonusNameSymbol = bonusTrigger.flatMap(b=>{return b.SymbolName})				
		this.startingOptionsFreegames = freegameBonusConfiguration.StartingOptions;
		this.plusOneFeature = freegameBonusConfiguration.FeatureConfigurations.find(feature => feature.FeatureType == "PlusOneFeature" ) as PlusOneFeatureConfiguration;		
		this.symbolCollectionMap = symbolCollectionMap;
	}

	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//resourceManager.Add(new HTMLResource(this.path + "BigSymbolFreeGame.html", this.resid.ScopedResourceName("html")));
		//resourceManager.Add(new ImageResource(this.gamePath + "HelpInfo/trigger.png", this.resid.ScopedResourceName(["trigger", "img"])));
		resourceManager.Add(new ImageResource(this.plusOnePath + "resources/addfreegames.png", this.resid.ScopedResourceName(["plusone", "img"])));
	}

	protected CreateInfoContainer() {
		//One Canvas per Row 
		//Create another for number of FreeGames that you could win
		for (let i = 0; i < 3; i++) {
			this.infoContainer[i] = CreateElement("div", {
				classes: ["description" + i],
				parentToAppend: this.pageContent,
				style: {
					width: Scale.Wpx(1160),
					//height: Scale.Hpx(350),
					display: "flex",
					position: "relative",
					margin: `${Scale.fhpx(20)} auto `,
					color: "yellow",
					fontSize: Scale.fhpx(42),
					fontFamily: "NotoSansDisplay-Black",
					webkitTextStroke: `${Scale.fhpx(3)}  black`,
					textAlign: "center",
					lineHeight: "initial",
					//padding : Scale.XYpx(10),
					flexDirection: "column",
					justifyContent : "center",
					alignItems : "center",
				}
			});
		}
	}

	protected SetNumberFreeGameCanvas(text: string, Canvas: MyCanvas , fontHeight: number ) {
		Canvas.context.font = "bold " + fontHeight + "px " + "NotoSansDisplay-Black";

		Canvas.context.fillStyle = "yellow";

		Canvas.context.textBaseline = "middle";
		Canvas.context.textAlign = "center";
		Canvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		Canvas.context.miterLimit = Scale.fh(2);

		Canvas.context.shadowBlur = Scale.fh(10);
		Canvas.context.shadowColor = "black";
		Canvas.context.shadowOffsetX = Scale.fh(8);
		Canvas.context.shadowOffsetY = Scale.fh(8);


		Canvas.context.clearRect(0, 0, (Canvas.size.Width), (Canvas.size.Height));
		Canvas.context.strokeStyle = "black";
		Canvas.context.lineWidth = Scale.fh(10);
		Canvas.context.strokeText(text, (Canvas.size.Width / 2), (Canvas.size.Height / 2));

		Canvas.context.strokeStyle = "white";
		Canvas.context.lineWidth = Scale.fh(10) / Scale.fh((4));
		Canvas.context.strokeText(text, (Canvas.size.Width / 2), (Canvas.size.Height / 2));

		Canvas.context.fillText(text, (Canvas.size.Width / 2), (Canvas.size.Height / 2));
	}

	protected SetInfoCanvas(text: string, Canvas: MyCanvas, xposition: number, fontHeight?: number) {
		Canvas.context.clearRect(0, 0, (Canvas.rect.width), (Canvas.rect.height));
		
		Canvas.context.font = "bold " + fontHeight + "px " + "NotoSansDisplay-Black";

		Canvas.context.fillStyle = "yellow";

		Canvas.context.textBaseline = "middle";
		Canvas.context.textAlign = "center";
		Canvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		Canvas.context.miterLimit = Scale.fh(2);

		Canvas.context.shadowBlur = Scale.fh(10);
		Canvas.context.shadowColor = "black";
		Canvas.context.shadowOffsetX = Scale.fh(8);
		Canvas.context.shadowOffsetY = Scale.fh(8);


		let str = text;
		let x = xposition;
		let y = 0;
		let lineheight = fontHeight;
		let lines = str.split('\n');



		y = (Canvas.rect.height / 2) - ((fontHeight * lines.length) / 2);
		let resultado = (fontHeight * lines.length) / 2;

		for (let row = 0; row < lines.length; row++) {
			Canvas.context.strokeStyle = "black";
			Canvas.context.lineWidth =Scale.fh(10);
			Canvas.context.strokeText(lines[row], Canvas.size.Width / 2 , y + (row * lineheight));
			Canvas.context.strokeStyle = "white";
			Canvas.context.lineWidth =Scale.fh(10) /Scale.fh(4);
			Canvas.context.strokeText(lines[row], Canvas.size.Width / 2 , y + (row * lineheight));
			Canvas.context.fillText(lines[row], Canvas.size.Width / 2 , y + (row * lineheight));
		}

		Canvas.RestoreContext();
	}	

	protected CreateNumberFreeGameCanvas(resourceManager: IReadOnlyResourceManager) {

		this.canvasNumberFreeGames = new MyCanvas(new Size(Scale.W(250), Scale.H(350)), {
            style: {
                //display: "flex",
                zIndex: "" + ZIndex.BonusWin,
            }
        });	
	} 

	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		this.CreateTitleCanvas();	
		this.CreateNumberFreeGameCanvas(resourceManager);
		let text = "FREEGAME BONUS";
		this.RedrawTitleCanvas(text, this.TitleCanvas);		
		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);
		this.symbolTriggerImg = this.symbolCollectionMap.get("Symbol_FG").imgResource.cloneNode(true)  as HTMLSpanElement;

		//parentToAppend : 
		SetStyles(this.symbolTriggerImg, {
			width: Scale.Hpx(300),
			height: Scale.Hpx(250),
			backgroundRepeat: "no-repeat",
			backgroundSize: "contain",
			backgroundPosition: "center",
			display: "flex",
			verticalAlign: "middle",
			margin: `auto ${Scale.fhpx(5)}`,
			position: "absolute",
			top: Scale.Ypx(60),
			left: Scale.Ypx(0),
		});		
		
		this.plusOneImg = CreateElement("div", 
		{
			style: {
				width: Scale.Hpx(450),
				height: Scale.Hpx(300),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["plusone", "img"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "flex",
				margin: `auto ${5}px`,
				position: "relative",
				top: Scale.Ypx(0),
				left: Scale.Xpx(40),
			}
		});

		this.numberFreeGames = document.createElement("div");
		this.numberFreeGames.style.width = Scale.Wpx(200);
		this.numberFreeGames.style.height = Scale.Hpx(300);
		this.numberFreeGames.style.left = Scale.Xpx(170);
		this.numberFreeGames.style.position = "relative";
		this.numberFreeGames.style.top =Scale.Ypx(-26);
		this.numberFreeGames.appendChild(this.canvasNumberFreeGames.view);
		this.plusOneImg.appendChild(this.numberFreeGames);

		this.SetNumberFreeGameCanvas(this.plusOneFeature.Value.toString(), this.canvasNumberFreeGames, this.NumbreFGfontHeight);
		this.CreateInfoContainer();

		this.pageContent.appendChild(this.symbolTriggerImg);

				
		
		let translatedInfoMessage1 = this.translator.Translate(() => this.translator.t.HelpInfoTriggerBigFG);
		this.infoContainer[0].appendChild(translatedInfoMessage1.location);		

		let translatedInfoMessage2 = this.translator.Translate(() => this.translator.t.HelpInfoPlusFG(this.plusOneFeature.Value , this.plusOneFeature?.MaxAdditionalFreegames ?? 0));
		this.infoContainer[1].style.flexDirection = "row";
		this.infoContainer[1].appendChild(translatedInfoMessage2.location);

		this.infoContainer[1].appendChild(this.plusOneImg);

		// TODO fix help
		// return;

		if (this.simpleBonusTriggers.length > 0) {
			// throw new Error("Many symbols can be bonus trigger")
			// let bonusTrigger = this.simpleBonusTriggers.find(ele=>ele);
			
			// let bonusSymbolTriggerContainer = this.symbolCollectionMap.get("Symbol_"+this.bonusNameSymbol[this.bonusNameSymbol.findIndex(name => name == bonusTrigger?.SymbolName)]).imgResource.cloneNode(true)  as HTMLSpanElement;
			// bonusSymbolTriggerContainer.style.width = Scale.Wpx(60);
			// bonusSymbolTriggerContainer.style.height = Scale.Wpx(50);
			// let translatedInfoMessage3 = this.translator.Translate(() => this.translator.t.HelpInfoFGBonusIntoBonus(BonusNameMap[bonusTrigger.BonusName].toUpperCase(), bonusTrigger?.Count , bonusSymbolTriggerContainer.outerHTML));
			// this.infoContainer[2].appendChild(translatedInfoMessage3.location);
		}


		
		let bonusWildSymbolContainerSymbolHelp=  this.symbolCollectionMap.get("Symbol_"+this.bonusNameSymbol[this.bonusNameSymbol.findIndex(name => name == "FG")])?.imgResource?.cloneNode(true)  as HTMLSpanElement;	

		if (bonusWildSymbolContainerSymbolHelp){

			bonusWildSymbolContainerSymbolHelp.style.width = Scale.Wpx(60);
			bonusWildSymbolContainerSymbolHelp.style.height = Scale.Wpx(50);
		}
		

		for (let startConfigData of this.startingOptionsFreegames) {		
			
			if (!bonusWildSymbolContainerSymbolHelp){
				return;
			}
			let translatedInfoMessage = this.translator.Translate(() => this.translator.t.StartingFreegamesHelp(startConfigData.Symbols, startConfigData.StartingFreegames , bonusWildSymbolContainerSymbolHelp?.outerHTML));
			translatedInfoMessage.location.style.display = "flex";
			this.infoContainer[0].appendChild(translatedInfoMessage.location);
		}

		for (let viewContainer of this.infoContainer) {
			this.pageContent.appendChild(viewContainer);
		}

		//bonusWildSymbolContainer = null;
		//symbolPath = null;
		//bonusMap = null;
		//bonusWildSymbolContainerSymbolHelp = null;
	}
	
	public override View(): HTMLElement {
		return this.view;
	}

	public override Update() {
		if (this.TitleCanvas.WasContextLost()) {
			this.RedrawTitleCanvas("FREEGAME BONUS", this.TitleCanvas);
		}
	}	
}

export class HelpPageDiamondPot extends HelpPage {
	protected bonusTrigger: HTMLElement = null;
	protected gamePath = "";
	protected commonPath: string = Settings.ResourcesFolder + "multigame/slot/common/resources/PickBonus/";

	protected pickDescription: HTMLElement = null;
	protected trigger: HTMLElement = null;
	//protected pick:NodeListOf<Element> = null;
	protected pick: HTMLElement = null;

	protected jp1: HTMLElement = null;
	protected jp2: HTMLElement = null;
	protected jp3: HTMLElement = null;
	//protected jp4:NodeListOf<Element> = null;
	protected jp4: HTMLElement = null;

	protected pot: HTMLElement = null;
	protected translator: Translator;

	protected pickBonusConfig: any = null;

	protected totalBetCents: number = 0;

	protected diamonPotDescription: TranslatedLocation = null;

	constructor(path: string, resid: ResourceIdentifier, gamePath: string, translator: Translator, pickBonusConfig: any) {
		super("DiamondPot", path, resid)

		this.resid = this.resid.Add("DiamondPot");
		this.gamePath = gamePath;
		this.translator = translator;
		this.pickBonusConfig = pickBonusConfig;
	}

	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//resourceManager.Add(new HTMLResource(this.path + "HelpPageDiamondPot.html", this.resid.ScopedResourceName("html")));

		resourceManager.Add(new ImageResource(this.commonPath + "trigger.png", this.resid.ScopedResourceName(["trigger", "image"])));

		resourceManager.Add(new ImageResource(this.gamePath + "pick.png", this.resid.ScopedResourceName(["pick", "image"])));

		resourceManager.Add(new ImageResource(this.commonPath + "sapphire.png", this.resid.ScopedResourceName(["sapphire", "image"])));
		resourceManager.Add(new ImageResource(this.commonPath + "emerald.png", this.resid.ScopedResourceName(["emerald", "image"])));
		resourceManager.Add(new ImageResource(this.commonPath + "ruby.png", this.resid.ScopedResourceName(["ruby", "image"])));
		resourceManager.Add(new ImageResource(this.commonPath + "diamond.png", this.resid.ScopedResourceName(["diamond", "image"])));

		resourceManager.Add(new ImageResource(this.commonPath + "pot.png", this.resid.ScopedResourceName(["pot", "image"])));

		// resourceManager.Add(new ImageResource(this.gamePath + "background.3.png", this.resid.ScopedResourceName(["background", "image"])));

	}

	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

		//use to put a backgound in the div view
		// this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "image"])).CssBackground();
		// this.view.style.backgroundSize = "cover";
		//this.view.innerHTML = resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;


		this.pickDescription = document.createElement("div")
		SetStyles(this.pickDescription,
			{
				width: "100%",
				height: "100%",
				color: "yellow",
				fontSize: Scale.fhpx(42),
				fontFamily: "NotoSansDisplay-Black",
				textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
				display: "flex",
				flexDirection: "column",
			})
			this.pageContent.appendChild(this.pickDescription)


		//this.pageTitle = this.view.querySelector(".title");

		SetStyles(this.pageTitle,
			{
				color: "yellow",
				//fontSize: Scale.fhpx(80),
				fontFamily: "NotoSansDisplay-Black",
				textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
				height : "10%",
			});

		//this.pageTitle.innerHTML = "DIAMOND POT BONUS";
		this.CreateTitleCanvas();

		this.trigger = document.createElement("span");
		SetStyles(this.trigger,
			{
				width: Scale.Wpx(150),
				height: Scale.Hpx(150),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["trigger", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			})
			;

		this.pick = document.createElement("span");
		SetStyles(this.pick,
			{
				width: Scale.Wpx(120),
				height: Scale.Hpx(120),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["pick", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});


		/**
		 * jp styles
		 */
		//this.jp1 = this.pickDescription.querySelector(".jp1");
		this.jp1 = document.createElement("span");
		SetStyles(this.jp1,
			{
				width: Scale.Wpx(100),
				height: Scale.Hpx(100),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["sapphire", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});


		this.jp2 = document.createElement("span");
		SetStyles(this.jp2,
			{
				width: Scale.Wpx(100),
				height: Scale.Hpx(100),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["emerald", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});

		this.jp3 = document.createElement("span");
		SetStyles(this.jp3,
			{
				width: Scale.Wpx(100),
				height: Scale.Hpx(100),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["ruby", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});


		this.jp4 = document.createElement("span");
		SetStyles(this.jp4,
			{
				width: Scale.Wpx(100),
				height: Scale.Hpx(100),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["diamond", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});

		/******** */


		this.pot = document.createElement("span");
		SetStyles(this.pot,
			{
				width: Scale.Wpx(220),
				height: Scale.Wpx(100),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["pot", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});




		this.diamonPotDescription = this.translator.Translate(() => {

			let picks: string = "" + 5;
			try {
				picks = this.pickBonusConfig.PickBonus.AvailablePicksPerPagePerBet[this.totalBetCents][this.pickBonusConfig.PickBonus.AvailablePicksPerPagePerBet[this.totalBetCents].length - 1];
			}
			catch (ex) { }

			return this.translator.t.diamondPotHelpDescription
				(
					this.trigger.outerHTML,
					this.pick.outerHTML,
					this.jp1.outerHTML,
					this.jp2.outerHTML,
					this.jp3.outerHTML,
					this.jp4.outerHTML,
					this.pot.outerHTML,
					"" + 5,
					picks,
					"" + 50,
				)
		});

		this.pickDescription.appendChild(this.diamonPotDescription.location);
		this.pageTitle.appendChild(this.TitleCanvas.View());
		this.RedrawTitleCanvas("DIAMOND POT BONUS", this.TitleCanvas);
	}

	public override View(): HTMLElement {
		return this.view;
	}

	public override UpdateBet(totalBetCents: number, denomCents: number, lines: number) {
		this.totalBetCents = totalBetCents;
		this.diamonPotDescription.Update();
	}

	public override Update() {
		if (this.TitleCanvas.WasContextLost()) {
			this.RedrawTitleCanvas("DIAMOND POT BONUS", this.TitleCanvas);
		}
	}
}

export class HelpPageDiamondSpin extends HelpPage {
	protected bonusTrigger: HTMLElement = null;
	protected gamePath = "";
	protected commonPath: string = Settings.ResourcesFolder + "multigame/slot/common/resources/DiamondSpin/";

	protected pickDescription: HTMLElement = null;
	protected trigger: HTMLElement = null;
	//protected pick:NodeListOf<Element> = null;
	protected MachineImg: HTMLElement = null;

	protected gold: HTMLElement = null;
	protected silver: HTMLElement = null;
	protected bronze: HTMLElement = null;
	protected graphite: HTMLElement = null;

	protected logo: HTMLElement = null;
	protected translator: Translator;

	protected pickBonusConfig: any = null;

	protected totalBetCents: number = 0;

	protected diamonPotDescription: TranslatedLocation = null;

	constructor(path: string, resid: ResourceIdentifier, gamePath: string, translator: Translator, pickBonusConfig: any) {
		super("DiamondSpin", path, resid)

		this.resid = this.resid.Add("DiamondSpin");
		this.gamePath = gamePath;
		this.translator = translator;
		this.pickBonusConfig = pickBonusConfig;
	}

	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//resourceManager.Add(new HTMLResource(this.path + "HelpPageDiamondSpin.html", this.resid.ScopedResourceName("html")));

		resourceManager.Add(new ImageResource(this.commonPath + "trigger.png", this.resid.ScopedResourceName(["trigger", "image"])));
		resourceManager.Add(new ImageResource(this.commonPath + "spin.png", this.resid.ScopedResourceName(["logo", "image"])));
		resourceManager.Add(new ImageResource(this.commonPath + "machineinfo.png", this.resid.ScopedResourceName(["machineinfo", "image"])));

		resourceManager.Add(new ImageResource(this.commonPath + "gold.png", this.resid.ScopedResourceName(["gold", "image"])));
		resourceManager.Add(new ImageResource(this.commonPath + "silver.png", this.resid.ScopedResourceName(["silver", "image"])));
		resourceManager.Add(new ImageResource(this.commonPath + "bronze.png", this.resid.ScopedResourceName(["bronze", "image"])));
		resourceManager.Add(new ImageResource(this.commonPath + "graphite.png", this.resid.ScopedResourceName(["graphite", "image"])));

		//resourceManager.Add(new ImageResource(this.commonPath + "pot.png", this.resid.ScopedResourceName(["pot", "image"])));

		// resourceManager.Add(new ImageResource(this.gamePath + "background.3.png", this.resid.ScopedResourceName(["background", "image"])));

	}

	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

		//use to put a backgound in the div view
		// this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "image"])).CssBackground();
		// this.view.style.backgroundSize = "cover";
		//this.view.innerHTML = resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;


		this.pickDescription = document.createElement("span");
		SetStyles(this.pickDescription,
			{
				width: "100%",
				height: "100%",
				color: "yellow",
				fontSize: "30px",
				fontFamily: "NotoSansDisplay-Black",
				textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
				display: "flex",
				flexDirection: "column",
			});
		this.pageContent.appendChild(this.pickDescription);


		//this.pageTitle = this.view.querySelector(".title");

		SetStyles(this.pageTitle,
			{
				color: "yellow",
				fontSize: "80px",
				fontFamily: "NotoSansDisplay-Black",
				textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
			});

		this.pageTitle.innerHTML = "PRECIOUS SPIN";

		this.trigger = document.createElement("span");
		SetStyles(this.trigger,
			{
				width: "150px",
				height: "150px",
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["trigger", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			})
			;

		this.MachineImg = document.createElement("span");
		SetStyles(this.MachineImg,
			{
				width: "220px",
				height: "120px",
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["machineinfo", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});


		/**
		 * jp styles
		 */
		//this.jp1 = this.pickDescription.querySelector(".jp1");
		this.gold = document.createElement("span");
		SetStyles(this.gold,
			{
				width: "133px",
				height: "133px",
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["gold", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});


		this.silver = document.createElement("span");
		SetStyles(this.silver,
			{
				width: "133px",
				height: "133px",
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["silver", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});

		this.bronze = document.createElement("span");
		SetStyles(this.bronze,
			{
				width: "133px",
				height: "133px",
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["bronze", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});


		this.graphite = document.createElement("span");
		SetStyles(this.graphite,
			{
				width: "133px",
				height: "133px",
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["graphite", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});

		/******** */


		this.logo = document.createElement("span");
		SetStyles(this.logo,
			{
				width: "300px",
				height: "140px",
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["logo", "image"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
			});





		this.diamonPotDescription = this.translator.Translate(() => this.translator.t.diamondspinhelp(this.trigger.outerHTML, this.logo.outerHTML, this.MachineImg.outerHTML, this.gold.outerHTML, this.silver.outerHTML, this.bronze.outerHTML, this.graphite.outerHTML));


		this.pickDescription.appendChild(this.diamonPotDescription.location);




	}

	public override View(): HTMLElement {
		return this.view;
	}

	public override UpdateBet(totalBetCents: number, denomCents: number, lines: number) {
		this.totalBetCents = totalBetCents;
		this.diamonPotDescription.Update();
	}

	public override Update() {
		if (this.TitleCanvas.WasContextLost()) {
			this.RedrawTitleCanvas("PRECIOUS SPIN", this.TitleCanvas);
		}
	}
}

export class HelpPageHoldAndSpin extends HelpPage {

	protected TitleElement: HTMLElement = null;
	protected ContainerElement: HTMLElement = null;
	//protected view: HTMLElement = null;
	protected gamePath: string = null;
	protected translator: Translator = null;
	protected description: HTMLElement = null;
	protected trigger: HTMLElement = null;
	protected descriptionTranslate: TranslatedLocation = null;
	protected LeftStickySpinImg: HTMLElement = null;
	protected RightStickySpinImg: HTMLElement = null;
	protected ScreenShootStickySpinImg: HTMLElement = null;
	protected InfoCanvas: MyCanvas[] = [];
	protected InfofontHeight: number = null;
	protected InfoSymbolTrigger: HTMLElement[] = [];
	protected stickyrightTranslator : TranslatedImage = null;
	protected initData: SlotGameInitData = null;
	protected triggerCountBonusHit : number = null;
	protected fullAwardBonusCount : number = null;
	readonly symbolCollectionMap: Map<string, SymbolsCollectionResources> = null;
	readonly symbolTypeAnim : SymbolTypeAnim = null;

	constructor(path: string, resid: ResourceIdentifier, gamePath: string, translator: Translator, initData: SlotGameInitData , symbolCollectionMap: Map<string, SymbolsCollectionResources> ,symbolTypeAnim : SymbolTypeAnim) {
		super("HelpPageHoldAndSpin", path, resid)
		this.resid = this.resid.Add("HelpPageHoldAndSpin");
		this.gamePath = gamePath;
		this.translator = translator;
		this.initData = initData;
		//this.view = document.createElement("div");
		//this.view.classList.add("help-page");

		let paramsStickyRight : ITranslatedImageParams = {
			resid : this.resid,
			path : this.gamePath + "HelpInfo/"+Settings.JackpotDisplayType.toString()+"Slides/stickyright",
			translator : this.translator,
			nameResourceImg : "stickyright",

		}

		this.stickyrightTranslator = new TranslatedImage(paramsStickyRight);

		this.triggerCountBonusHit = initData.BonusConfiguration.SpinAndHold.TriggerCount;

		const sraConfigs = FilterFeatures(initData.BonusConfiguration.SpinAndHold.MultiFeatureConfiguration, (f): f is ScatterRandomAwardConfiguration => f.FeatureType == "ScatterRandomAward");
		assertTrue(!IsEmptyOrNull(sraConfigs), "ScatterRandomAward must exist");
		const listSraConfigs = Object.values(sraConfigs);
		const fullCounts = listSraConfigs.map(c => c.FullCount).filter(Filter.UniqueItem);

		assertEqual(1, fullCounts.length, "All full counts should be equal. Found many different.");
		
		const unlockRowsConfig = Object.values(sraConfigs)[0];
		this.fullAwardBonusCount = fullCounts[0];
		
		this.symbolCollectionMap = symbolCollectionMap;
		this.symbolTypeAnim = symbolTypeAnim;
	}
	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//resourceManager.Add(new HTMLResource(this.path + "HelpPageHoldAndSpin.html", this.resid.ScopedResourceName("html")));
		// resourceManager.Add(new ImageResource(this.gamePath + "background.3.png", this.resid.ScopedResourceName(["background", "img"])));
		resourceManager.Add(new ImageResource(this.gamePath + "HoldAndSpin/trigger.png", this.resid.ScopedResourceName(["trigger", "img"])));


		//if( Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay ){
			//resourceManager.Add(new ImageResource(this.gamePath + "HelpInfo/"+Settings.JackpotDisplayType.toString()+"Slides/stickyleft.png", this.resid.ScopedResourceName(["stickyleft", "img"])));
			//resourceManager.Add(new ImageResource(this.gamePath + "HelpInfo/"+Settings.JackpotDisplayType.toString()+"Slides/stickyright.png", this.resid.ScopedResourceName(["stickyright", "img"])));
			//this.stickyrightTranslator.PrepareResources(resourceManager);
			//resourceManager.Add(new ImageResource(this.gamePath + "HelpInfo/"+Settings.JackpotDisplayType.toString()+"Slides/screenshootbg.png", this.resid.ScopedResourceName(["screenshootbg", "img"])));
		//}
	}
	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
	
		this.CreateTitleCanvas();

		let text = "STICKY SPIN BONUS";
		this.RedrawTitleCanvas(text, this.TitleCanvas);

		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);

	

		this.description = CreateElement("div", {
			classes: ["description"],
			parentToAppend: this.pageContent,
			style: {
				width: Scale.Wpx(1920),
				height: Scale.Hpx(1080),
				color: "yellow",
				fontSize: "20px",
				fontFamily: "NotoSansDisplay-Black",
				webkitTextStroke: `${ Scale.fhpx(3)} black`,
				textAlign: "center",
				display: "flex",
				flexDirection: "column",
			}
		});

		this.ScreenShootStickySpinImg = document.createElement("div");
		this.ScreenShootStickySpinImg.classList.add("ScreenShootStickySpinImg");
		this.ScreenShootStickySpinImg.setAttribute("class", "ScreenShootStickySpinImg");
		this.ScreenShootStickySpinImg.style.height =Scale.Hpx(260);
		this.ScreenShootStickySpinImg.style.width =Scale.Wpx(475);
		this.ScreenShootStickySpinImg.style.position = "absolute";
		this.ScreenShootStickySpinImg.style.top =Scale.Ypx(26);
		this.ScreenShootStickySpinImg.style.left =Scale.Xpx(20);
		//this.ScreenShootStickySpinImg.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["screenshootbg", "img"])).CssBackground();
		//this.ScreenShootStickySpinImg.style.backgroundPosition = "center";
		//this.ScreenShootStickySpinImg.style.backgroundSize = "contain";
		//this.ScreenShootStickySpinImg.style.backgroundRepeat = "no-repeat";
		let wildScreenShoot = new HelpWildScreenShoot(this.initData , this.symbolCollectionMap , this.symbolTypeAnim );
		await wildScreenShoot.ResourcesLoaded(resourceManager);
		this.ScreenShootStickySpinImg.appendChild(wildScreenShoot.View());
		this.description.appendChild(this.ScreenShootStickySpinImg);

		


		this.LeftStickySpinImg = document.createElement("div");
		this.LeftStickySpinImg.classList.add("LeftStickySpinImg");
		this.LeftStickySpinImg.setAttribute("class", "LeftStickySpinImg");
		this.LeftStickySpinImg.style.height =Scale.Hpx(260);
		this.LeftStickySpinImg.style.width =Scale.Wpx(475);
		this.LeftStickySpinImg.style.position = "absolute";
		this.LeftStickySpinImg.style.bottom = Scale.Ypx(45);
		this.LeftStickySpinImg.style.left = Scale.Xpx(20);
		//this.LeftStickySpinImg.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["stickyleft", "img"])).CssBackground();
		//this.LeftStickySpinImg.style.backgroundPosition = "center";
		//this.LeftStickySpinImg.style.backgroundSize = "contain";
		//this.LeftStickySpinImg.style.backgroundRepeat = "no-repeat";
		let wildScreenShootSRAFull = new HelpSRAFullAwardScreenShoot(this.initData,this.symbolCollectionMap , SymbolTypeAnim.Sprites);
		await wildScreenShootSRAFull.ResourcesLoaded(resourceManager);
		this.LeftStickySpinImg.appendChild(wildScreenShootSRAFull.View());
		this.description.appendChild(this.LeftStickySpinImg);

		



		this.RightStickySpinImg = document.createElement("div");
		this.RightStickySpinImg.classList.add("RightStickySpinImg");
		this.RightStickySpinImg.setAttribute("class", "RightStickySpinImg");
		this.RightStickySpinImg.style.height = Scale.Hpx(350);
		this.RightStickySpinImg.style.width = Scale.Wpx(475);
		this.RightStickySpinImg.style.position = "absolute";
		this.RightStickySpinImg.style.bottom = Scale.Ypx(0);
		this.RightStickySpinImg.style.right = Scale.Xpx(-5);
		//this.RightStickySpinImg.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["stickyright", "img"])).CssBackground();
		this.RightStickySpinImg.style.backgroundPosition = "center";
		this.RightStickySpinImg.style.backgroundSize = "contain";
		this.RightStickySpinImg.style.backgroundRepeat = "no-repeat";
		//this.stickyrightTranslator.ResourcesLoaded(resourceManager);
		//this.RightStickySpinImg.appendChild(this.stickyrightTranslator.View());
		let infoFullAwardBonus = new HelpScreenShootInfoFullAward(this.initData,this.translator,this.symbolCollectionMap);
		infoFullAwardBonus.ResourcesLoaded(resourceManager);
		this.RightStickySpinImg.appendChild(infoFullAwardBonus.View())

		this.description.appendChild(this.RightStickySpinImg);

		this.CreateInfoCanvas(resourceManager);
	}
	public override View(): HTMLElement {

		//this.view.style.visibility = "hidden";
		return this.view;
	}

	protected CreateInfoCanvas(resourceManager: IReadOnlyResourceManager) {


		let StartnumberCanvas1: number = 0;
		let StartPosition: number = Scale.Y(0);
		let heightDivInfo: number = Scale.H(300);
		for (let trigger = 0; trigger < 3; trigger++) {


			if (trigger == 0) {

				this.InfoSymbolTrigger[trigger] = document.createElement("div");
				this.InfoSymbolTrigger[trigger].style.width = Scale.Wpx(1200);
				//this.InfoSymbolTrigger[trigger].style.height = heightDivInfo + "px";
				this.InfoSymbolTrigger[trigger].style.right = Scale.Ypx(37);
				this.InfoSymbolTrigger[trigger].style.top =   Scale.Ypx(59);
				this.InfoSymbolTrigger[trigger].style.position = "absolute";
				//this.SetInfoCanvas(this.translator.t.HoldAndSpinHelpWin, this.InfoCanvas[trigger]);

			}
			if (trigger == 1) {

				this.InfoSymbolTrigger[trigger] = document.createElement("div");
				this.InfoSymbolTrigger[trigger].style.width = Scale.Wpx(1730);
				//this.InfoSymbolTrigger[trigger].style.height = heightDivInfo + "px";
				this.InfoSymbolTrigger[trigger].style.right = Scale.Ypx(24);
				this.InfoSymbolTrigger[trigger].style.top = Scale.Ypx(312);
				this.InfoSymbolTrigger[trigger].style.position = "absolute";
				//this.SetInfoCanvas(this.translator.t.HoldAndSpinHelpWin2, this.InfoCanvas[trigger]);

			}
			if (trigger == 2) {

				this.InfoSymbolTrigger[trigger] = document.createElement("div");
				this.InfoSymbolTrigger[trigger].style.width = Scale.Wpx(803);
				//this.InfoSymbolTrigger[trigger].style.height = heightDivInfo + "px";
				this.InfoSymbolTrigger[trigger].style.right = Scale.Ypx(452);
				this.InfoSymbolTrigger[trigger].style.top = Scale.Xpx(526);
				this.InfoSymbolTrigger[trigger].style.position = "absolute";
				//this.SetInfoCanvas(this.translator.t.BigHoldAndSpinHelpWin3, this.InfoCanvas[trigger]);

			}

			this.InfoSymbolTrigger[trigger].style.color = "yellow";
			this.InfoSymbolTrigger[trigger].style.fontSize = Scale.fhpx(40);
			this.InfoSymbolTrigger[trigger].style.fontFamily = "NotoSansDisplay-Black";
			this.InfoSymbolTrigger[trigger].style.webkitTextStroke = `${ Scale.fhpx(3)} black`;
			this.InfoSymbolTrigger[trigger].style.textAlign = "left";
			this.InfoSymbolTrigger[trigger].style.lineHeight = "initial";
			this.description.appendChild(this.InfoSymbolTrigger[trigger]);
			StartPosition = StartPosition + heightDivInfo;
		}
		let translatedMessage1 = this.translator.Translate(() => this.translator.t.HoldAndSpinHelpWin(this.triggerCountBonusHit));
		this.InfoSymbolTrigger[0].appendChild(translatedMessage1.location);


		let translatedMessage2 = this.translator.Translate(() => 
		{
			let message = this.translator.t.HoldAndSpinHelpWin2(this.fullAwardBonusCount)
			message += Settings.ShowMinBetInfo ? this.translator.t.minimumbetText() : "";
			return message;
		});
		
		this.InfoSymbolTrigger[1].appendChild(translatedMessage2.location);

		let translatedMessage3 = this.translator.Translate(() => this.translator.t.BigHoldAndSpinHelpWin3);
		this.InfoSymbolTrigger[2].appendChild(translatedMessage3.location);

	}
	
	public override Update() {
		if (this.TitleCanvas.WasContextLost()) {
			this.RedrawTitleCanvas("STICKY SPIN BONUS", this.TitleCanvas);
		}
	}	
}

export class HelpBigSymbolFreegames extends HelpPage {

	protected TitleElement: HTMLElement = null;
	protected ContainerElement: HTMLElement = null;
	//protected view: HTMLElement = null;
	protected gamePath: string = null;
	protected translator: Translator = null;
	protected description: HTMLElement = null;
	protected trigger: HTMLElement = null;
	protected descriptionTranslate: TranslatedLocation = null;

	protected PlusOneImg: HTMLElement = null;
	protected SymbolTriggerImg: HTMLElement = null;
	protected ScreenShootBigFG: HTMLElement = null;
	protected InfoContainer: HTMLElement[] = [];
	protected InfoPlusOne: HTMLElement[] = [];
	//protected InfoCanvas: MyCanvas[] = [];
	//protected InfoCanvasCtx:CanvasRenderingContext2D[] =[] ;
	protected InfofontHeight: number = Scale.fh(48);
	protected PlusOnePath: string = Settings.ResourcesFolder + "multigame/slot/common/resources/BigSymbolFreegames/";

	protected NumberFreeGames: HTMLElement;
	protected CanvasNumberFreeGames: MyCanvas;
	protected CanvasNumberFreeGamesCtx: MyCanvasContext;
	protected NumbreFGfontHeight: number = Scale.fh(300);
	constructor(path: string, resid: ResourceIdentifier, gamePath: string, translator: Translator, pickBonusConfig: any) {
		super("BigSymbolFreeGame", path, resid)
		this.resid = this.resid.Add("BigSymbolFreeGame");
		this.gamePath = gamePath;
		this.translator = translator;
		//this.view = document.createElement("div");
		//this.view.classList.add("help-page");
		this.pageContent.style.flexDirection = "row";
		this.pageContent.style.alignItems = "flex-start";
		//this.pageContent.style.flexFlow = "row";
		this.pageContent.style.flexWrap = "wrap";		
		

	}
	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//resourceManager.Add(new HTMLResource(this.path + "BigSymbolFreeGame.html", this.resid.ScopedResourceName("html")));
		resourceManager.Add(new ImageResource(this.gamePath + "HelpInfo/trigger.png", this.resid.ScopedResourceName(["trigger", "img"])));
		resourceManager.Add(new ImageResource(this.PlusOnePath + "resources/addfreegames.png", this.resid.ScopedResourceName(["plusone", "img"])));

	}

	protected CreateInfoContainer() {
		//One Canvas per Row 
		//Create another for number of FreeGames that you could win
		for (let i = 0; i < 2; i++) {
	
			
			this.InfoContainer[i] = CreateElement("div", {
				classes: ["description"+i],
				parentToAppend:this.pageContent,
				style: {
					width:Scale.Wpx(960),
					//height: Scale.Hpx(350),
					display: "flex",					
					position : "relative",
					margin : "auto",
					color: "yellow",
					fontSize: Scale.fhpx(42),
					fontFamily: "NotoSansDisplay-Black",
					webkitTextStroke: `${ Scale.fhpx(3)}  black`,
					textAlign: "left",					
					lineHeight : "initial",					
					//padding : Scale.XYpx(10),
				}
			});		
	 	}
	 }

	protected SetNumberFreeGameCanvas(text: string, Canvas: MyCanvas , fontHeight: number ) {
		Canvas.context.font = "bold " + fontHeight + "px " + "NotoSansDisplay-Black";

		Canvas.context.fillStyle = "yellow";

		Canvas.context.textBaseline = "middle";
		Canvas.context.textAlign = "center";
		Canvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		Canvas.context.miterLimit = Scale.fh(2);

		Canvas.context.shadowBlur = Scale.fh(10);
		Canvas.context.shadowColor = "black";
		Canvas.context.shadowOffsetX = Scale.fh(8);
		Canvas.context.shadowOffsetY = Scale.fh(8);


		Canvas.context.clearRect(0, 0, (Canvas.size.Width), (Canvas.size.Height));
		Canvas.context.strokeStyle = "black";
		Canvas.context.lineWidth = Scale.fh(10);
		Canvas.context.strokeText(text, (Canvas.size.Width / 2), (Canvas.size.Height / 2));

		Canvas.context.strokeStyle = "white";
		Canvas.context.lineWidth = Scale.fh(10) / Scale.fh((4));
		Canvas.context.strokeText(text, (Canvas.size.Width / 2), (Canvas.size.Height / 2));

		Canvas.context.fillText(text, (Canvas.size.Width / 2), (Canvas.size.Height / 2));
	}

	protected SetInfoCanvas(text: string, Canvas: MyCanvas, xposition: number, fontHeight?: number) {
		Canvas.context.clearRect(0, 0, (Canvas.rect.width), (Canvas.rect.height));
		
		Canvas.context.font = "bold " + fontHeight + "px " + "NotoSansDisplay-Black";

		Canvas.context.fillStyle = "yellow";

		Canvas.context.textBaseline = "middle";
		Canvas.context.textAlign = "center";
		Canvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		Canvas.context.miterLimit = Scale.fh(2);

		Canvas.context.shadowBlur = Scale.fh(10);
		Canvas.context.shadowColor = "black";
		Canvas.context.shadowOffsetX = Scale.fh(8);
		Canvas.context.shadowOffsetY = Scale.fh(8);


		let str = text;
		let x = xposition;
		let y = 0;
		let lineheight = fontHeight;
		let lines = str.split('\n');



		y = (Canvas.rect.height / 2) - ((fontHeight * lines.length) / 2);
		let resultado = (fontHeight * lines.length) / 2;

		for (let row = 0; row < lines.length; row++) {
			Canvas.context.strokeStyle = "black";
			Canvas.context.lineWidth =Scale.fh(10);
			Canvas.context.strokeText(lines[row], Canvas.size.Width / 2 , y + (row * lineheight));
			Canvas.context.strokeStyle = "white";
			Canvas.context.lineWidth =Scale.fh(10) /Scale.fh(4);
			Canvas.context.strokeText(lines[row], Canvas.size.Width / 2 , y + (row * lineheight));
			Canvas.context.fillText(lines[row], Canvas.size.Width / 2 , y + (row * lineheight));
		}

		Canvas.RestoreContext();
	}	

	protected CreateNumberFreeGameCanvas(resourceManager: IReadOnlyResourceManager) {

		this.CanvasNumberFreeGames = new MyCanvas(new Size(Scale.W(250), Scale.H(350)), {
            style: {
                //display: "flex",
                zIndex: "" + ZIndex.BonusWin,
            }
        });	
	} 

	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		this.CreateTitleCanvas();	
		this.CreateNumberFreeGameCanvas(resourceManager);
		let text = "BIG SYMBOL FREEGAME";
		this.RedrawTitleCanvas(text, this.TitleCanvas);		
		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);
		this.SymbolTriggerImg = document.createElement("div");

		SetStyles(this.SymbolTriggerImg,
			{
				width:Scale.Hpx(650),
				height:Scale.Hpx(500),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["trigger", "img"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "flex",
				verticalAlign: "middle",
				margin : "auto",
				position : "relative",
				top : Scale.Ypx(50),
			});

		this.PlusOneImg = document.createElement("div");
		SetStyles(this.PlusOneImg,
			{
				width:Scale.Hpx(650),
				height:Scale.Hpx(500),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["plusone", "img"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "flex",
				margin : "auto",
				position : "relative",
				top: Scale.Ypx(-100),				
			});

		this.NumberFreeGames = document.createElement("div");
		this.NumberFreeGames.style.width = Scale.Wpx(200);
		this.NumberFreeGames.style.height = Scale.Hpx(300);
		this.NumberFreeGames.style.left = Scale.Xpx(450);
		this.NumberFreeGames.style.position = "relative";
		this.NumberFreeGames.style.top =Scale.Ypx(16);
		this.NumberFreeGames.appendChild(this.CanvasNumberFreeGames.view);
		this.PlusOneImg.appendChild(this.NumberFreeGames);

		this.SetNumberFreeGameCanvas("3", this.CanvasNumberFreeGames, this.NumbreFGfontHeight);
		this.CreateInfoContainer();

		this.pageContent.appendChild(this.SymbolTriggerImg);
		this.pageContent.appendChild(this.InfoContainer[0]);
		this.pageContent.appendChild(this.InfoContainer[1]);

		this.pageContent.appendChild(this.PlusOneImg);	
		
		let translatedInfoMessage1 = this.translator.Translate(() => this.translator.t.HelpInfoTriggerBigFG);
		this.InfoContainer[0].appendChild(translatedInfoMessage1.location);

		let translatedInfoMessage2 = this.translator.Translate(() => this.translator.t.HelpInfoPlusBigFG(3));
		this.InfoContainer[1].appendChild(translatedInfoMessage2.location);
	}
	
	public override View(): HTMLElement {
		return this.view;
	}

	public override Update() {
		if (this.TitleCanvas.WasContextLost()) {
			this.RedrawTitleCanvas("BIG SYMBOL FREEGAME", this.TitleCanvas);
		}
	}	
}

export class HelpBigSymbolFreegamesStikySpin extends HelpPage {

	protected TitleElement: HTMLElement = null;
	protected ContainerElement: HTMLElement = null;
	//protected view: HTMLElement = null;
	protected gamePath: string = null;
	protected translator: Translator = null;
	protected description: HTMLElement = null;
	protected trigger: HTMLElement = null;
	protected descriptionTranslate: TranslatedLocation = null;
	protected LeftStickySpinImg: HTMLElement = null;
	protected RightStickySpinImg: HTMLElement = null;
	protected ScreenShootStickySpinImg: HTMLElement = null;
	protected TextInfo: HTMLElement = null;
	protected InfoCanvas: MyCanvas[] = [];
	protected InfofontHeight: number =Scale.fh(40);
	protected InfoSymbolTrigger: HTMLElement[] = [];
	protected bigStickyRightTranslator : TranslatedImage;

	constructor(path: string, resid: ResourceIdentifier, gamePath: string, translator: Translator, pickBonusConfig: any) {
		super("BigSymbolFreegamesStikySpin", path, resid)
		this.resid = this.resid.Add("BigSymbolFreegamesStikySpin");
		this.gamePath = gamePath;
		this.translator = translator;
		//this.view = document.createElement("div");
		//this.view.classList.add("help-page");

		let paramsBigStickyRight : ITranslatedImageParams = {
			resid : this.resid,
			path : this.gamePath + "HelpInfo/"+Settings.JackpotDisplayType.toString()+"Slides/bigstickyright",
			translator : this.translator,
			nameResourceImg : "bigstickyright",

		}

		this.bigStickyRightTranslator = new TranslatedImage(paramsBigStickyRight);

	}
	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//resourceManager.Add(new HTMLResource(this.path + "HelpPageBigSymbolFreeGameStickySpin.html", this.resid.ScopedResourceName("html")));
		// resourceManager.Add(new ImageResource(this.gamePath + "background.3.png", this.resid.ScopedResourceName(["background", "img"])));
		resourceManager.Add(new ImageResource(this.gamePath + "HoldAndSpin/trigger.png", this.resid.ScopedResourceName(["trigger", "img"])));

		
		if ( Settings.JackpotDisplayType != JackpotDisplayType.PaytableJackpotDisplay ){
			resourceManager.Add(new ImageResource(this.gamePath + "HelpInfo/"+Settings.JackpotDisplayType.toString()+"Slides/bigstickyleft.png", this.resid.ScopedResourceName(["bigstickyleft", "img"])));
			//resourceManager.Add(new ImageResource(this.gamePath + "HelpInfo/"+Settings.JackpotDisplayType.toString()+"Slides/bigstickyright.png", this.resid.ScopedResourceName(["bigstickyright", "img"])));
			this.bigStickyRightTranslator.PrepareResources(resourceManager);
			resourceManager.Add(new ImageResource(this.gamePath + "HelpInfo/"+Settings.JackpotDisplayType.toString()+"Slides/bigfgscreenshoot.png", this.resid.ScopedResourceName(["bigfgscreenshoot", "img"])));
		}		
	}
	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		//use to put a backgound in the div view
		//this.view.innerHTML = resourceManager.Get<HTMLResource>(this.resid.ScopedResourceName("html")).html;
		// this.view.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["background", "img"])).CssBackground();
		// this.view.style.backgroundSize = "cover";
		this.CreateTitleCanvas();

		//this.TitleElement = this.view.querySelector(".title");
		//this.TitleElement.innerHTML = "STICKY SPIN BONUS";
		let text = "BIG STICKY BONUS";
		this.RedrawTitleCanvas(text, this.TitleCanvas);

		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);

			this.description = CreateElement("div", {
				classes: ["description"],
				parentToAppend:this.pageContent,
				style: {
					width:Scale.Wpx(1920),
					height: Scale.Hpx(1080),
					display: "flex",
				}
			});

		

		this.ScreenShootStickySpinImg = document.createElement("div");
		this.ScreenShootStickySpinImg.classList.add("ScreenShootStickySpinImg");
		this.ScreenShootStickySpinImg.setAttribute("class", "ScreenShootStickySpinImg");
		this.ScreenShootStickySpinImg.style.height =Scale.Hpx(350);
		this.ScreenShootStickySpinImg.style.width = Scale.Wpx(475);
		this.ScreenShootStickySpinImg.style.position = "absolute";
		this.ScreenShootStickySpinImg.style.top =Scale.Ypx(-28);
		this.ScreenShootStickySpinImg.style.left =Scale.Xpx(20);
		this.ScreenShootStickySpinImg.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["bigfgscreenshoot", "img"])).CssBackground();
		this.ScreenShootStickySpinImg.style.backgroundPosition = "center";
		this.ScreenShootStickySpinImg.style.backgroundSize = "contain";
		this.ScreenShootStickySpinImg.style.backgroundRepeat = "no-repeat";
		this.description.appendChild(this.ScreenShootStickySpinImg);



		this.LeftStickySpinImg = document.createElement("div");
		this.LeftStickySpinImg.classList.add("LeftStickySpinImg");
		this.LeftStickySpinImg.setAttribute("class", "LeftStickySpinImg");
		this.LeftStickySpinImg.style.height = Scale.Hpx(350);
		this.LeftStickySpinImg.style.width = Scale.Wpx(475);
		this.LeftStickySpinImg.style.position = "absolute";
		this.LeftStickySpinImg.style.bottom =Scale.Ypx(-26);
		this.LeftStickySpinImg.style.left =Scale.Xpx(20);
		this.LeftStickySpinImg.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["bigstickyleft", "img"])).CssBackground();
		this.LeftStickySpinImg.style.backgroundPosition = "center";
		this.LeftStickySpinImg.style.backgroundSize = "contain";
		this.LeftStickySpinImg.style.backgroundRepeat = "no-repeat";
		this.description.appendChild(this.LeftStickySpinImg);




		this.bigStickyRightTranslator.ResourcesLoaded(resourceManager);
		this.RightStickySpinImg = document.createElement("div");
		this.RightStickySpinImg.classList.add("RightStickySpinImg");
		this.RightStickySpinImg.setAttribute("class", "RightStickySpinImg");
		this.RightStickySpinImg.style.height = Scale.Hpx(350);
		this.RightStickySpinImg.style.width = Scale.Wpx(475);
		this.RightStickySpinImg.style.position = "absolute";
		this.RightStickySpinImg.style.bottom = Scale.Ypx(0);
		this.RightStickySpinImg.style.right =Scale.Xpx(-5);
		//this.RightStickySpinImg.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["bigstickyright", "img"])).CssBackground();
		this.RightStickySpinImg.style.backgroundPosition = "center";
		this.RightStickySpinImg.style.backgroundSize = "contain";
		this.RightStickySpinImg.style.backgroundRepeat = "no-repeat";
		this.bigStickyRightTranslator.ResourcesLoaded(resourceManager);
		this.RightStickySpinImg.appendChild(this.bigStickyRightTranslator.View());
		this.description.appendChild(this.RightStickySpinImg);		
		this.CreateInfoCanvas(resourceManager);




	}
	public override View(): HTMLElement {

		//this.view.style.visibility = "hidden";
		return this.view;
	}

	protected CreateInfoCanvas(resourceManager: IReadOnlyResourceManager) {
	
	
		let heightDivInfo: number = Scale.W(300);
		for (let trigger = 0; trigger < 3; trigger++) {


			if (trigger == 0) {

				this.InfoSymbolTrigger[trigger] = document.createElement("div");
				this.InfoSymbolTrigger[trigger].style.width = Scale.Wpx(1100);
				//this.InfoSymbolTrigger[trigger].style.height =Scale.Hpx(250);
				this.InfoSymbolTrigger[trigger].style.right = Scale.Xpx(97);
				this.InfoSymbolTrigger[trigger].style.top = Scale.Xpx(59);
				this.InfoSymbolTrigger[trigger].style.position = "absolute";
				//this.SetInfoCanvas(this.translator.t.BigHoldAndSpinHelpWin, this.InfoCanvas[trigger]);

			}
			if (trigger == 1) {

				this.InfoSymbolTrigger[trigger] = document.createElement("div");
				this.InfoSymbolTrigger[trigger].style.width = Scale.Wpx(1730);
				//this.InfoSymbolTrigger[trigger].style.height = heightDivInfo + "px";
				this.InfoSymbolTrigger[trigger].style.right = Scale.Xpx(24);
				this.InfoSymbolTrigger[trigger].style.top = Scale.Ypx(312);
				this.InfoSymbolTrigger[trigger].style.position = "absolute";
				//this.SetInfoCanvas(this.translator.t.BigHoldAndSpinHelpWin2, this.InfoCanvas[trigger]);

			}
			if (trigger == 2) {

				this.InfoSymbolTrigger[trigger] = document.createElement("div");
				this.InfoSymbolTrigger[trigger].style.width = Scale.Wpx(803);
				//this.InfoSymbolTrigger[trigger].style.height = heightDivInfo + "px";
				this.InfoSymbolTrigger[trigger].style.right = Scale.Xpx(452);
				this.InfoSymbolTrigger[trigger].style.top = Scale.Ypx(526);
				this.InfoSymbolTrigger[trigger].style.position = "absolute";
				//this.SetInfoCanvas(this.translator.t.BigHoldAndSpinHelpWin3, this.InfoCanvas[trigger]);

			}

			this.InfoSymbolTrigger[trigger].style.color= "yellow";
			this.InfoSymbolTrigger[trigger].style.fontSize=Scale.fhpx(40);
			this.InfoSymbolTrigger[trigger].style.fontFamily="NotoSansDisplay-Black";
			this.InfoSymbolTrigger[trigger].style.webkitTextStroke=`${Scale.fhpx(3)} black`;
			this.InfoSymbolTrigger[trigger].style.textAlign="left";	
			this.InfoSymbolTrigger[trigger].style.lineHeight="initial";
			this.description.appendChild(this.InfoSymbolTrigger[trigger]);
			
		}
		
		let translatedMessage1= this.translator.Translate(() => this.translator.t.BigHoldAndSpinHelpWin);
		this.InfoSymbolTrigger[0].appendChild(translatedMessage1.location);

		let translatedMessage2 = this.translator.Translate(() => this.translator.t.BigHoldAndSpinHelpWin2);
		this.InfoSymbolTrigger[1].appendChild(translatedMessage2.location);

		let translatedMessage3 = this.translator.Translate(() => this.translator.t.BigHoldAndSpinHelpWin3);
		this.InfoSymbolTrigger[2].appendChild(translatedMessage3.location);
		
	}



	public override Update() {
		if (this.TitleCanvas.WasContextLost()) {
			this.RedrawTitleCanvas("BIG STICKY BONUS", this.TitleCanvas);
		}
	}
}

export class HelpTurboPlayGame extends HelpPage {
	protected TitleElement: HTMLElement = null;
	protected ContainerElement: HTMLElement = null;
	//protected view: HTMLElement = null;
	protected gamePath: string = null;
	protected translator: Translator = null;
	protected description: HTMLElement = null;
	protected trigger: HTMLElement = null;
	protected descriptionTranslate: TranslatedLocation = null;
	//HTML FOR TITLE 
	protected TuboImgSpanish: HTMLElement = null;
	protected TuboImgEnglish: HTMLElement = null;


	protected InfoCanvas: MyCanvas = null;
	protected InfofontHeight: number = Scale.H(35);
	protected infoPage: HTMLElement = null;
	protected ResourcePathTurboGame: string = null;


	constructor(path: string, resid: ResourceIdentifier, gamePath: string, translator: Translator, pickBonusConfig: any) {
		super("TurboPlayGame", path, resid)
		this.resid = this.resid.Add("TurboPlayGame");
		this.gamePath = gamePath;
		this.translator = translator;
		//this.view = document.createElement("div");
		//this.view.classList.add("help-page");
		this.ResourcePathTurboGame = Settings.ResourcesFolder + "multigame/slot/common/resources/TurboGame/";


	}
	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		//resourceManager.Add(new HTMLResource(this.path + "HelpPageTuboPlay.html", this.resid.ScopedResourceName("html")));
		// resourceManager.Add(new ImageResource(this.gamePath + "background.3.png", this.resid.ScopedResourceName(["background", "img"])));
		resourceManager.Add(new ImageResource(this.ResourcePathTurboGame + "TurboGameSpanish.png", this.resid.ScopedResourceName(["TurboGameSpanish", "img"])));
		resourceManager.Add(new ImageResource(this.ResourcePathTurboGame + "TurboGameEnglish.png", this.resid.ScopedResourceName(["TurboGameEnglish", "img"])));

	}
	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		//create Title Canvas for Turbo
		this.CreateTitleCanvas();
		this.description = CreateElement("div", {
			classes: ["description"],
			parentToAppend:this.pageContent,
			style: {
				width: "100%",
				height: "100%",
				//display: "flex",
				margin : "0 auto",
			}
		});

		this.TuboImgSpanish = document.createElement("span");
		SetStyles(this.TuboImgSpanish,
			{
				width: Scale.Wpx(600),
				height: Scale.Hpx(360),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["TurboGameSpanish", "img"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
				margin: "0px",
			});

		this.TuboImgEnglish = document.createElement("span");
		SetStyles(this.TuboImgEnglish,
			{
				width: Scale.Wpx(600),
				height: Scale.Hpx(360),
				backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["TurboGameEnglish", "img"])).CssBackground(),
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
				margin: "0px",
			});


			this.infoPage = CreateElement("div", {
				classes: ["infoPage"],
				parentToAppend:this.description,
				style: {
					
					display: "flex",
					width: "100%",
					//margin : "0 auto",
					color: "yellow",
					fontSize: Scale.fhpx(42),
					fontFamily: "NotoSansDisplay-Black",
					webkitTextStroke: `${ Scale.fhpx(3)} black`,
					textAlign: "justify",					
					lineHeight : "initial",
					position:"absolute",
					top: Scale.Ypx(330),
					padding : Scale.XYpx(50),
				}
			});

		this.RedrawTitleCanvas(this.translator.t.TitleTurboPlay, this.TitleCanvas);
		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);
		this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas(this.translator.t.TitleTurboPlay, this.TitleCanvas));
		let translatedImg = this.translator.Translate(() => this.translator.t.TurboTitle(this.TuboImgSpanish.outerHTML, this.TuboImgEnglish.outerHTML));
		this.description.appendChild(translatedImg.location);

		let translatedInfoMessage = this.translator.Translate(() => this.translator.t.turboDescription);
		this.infoPage.appendChild(translatedInfoMessage.location);
	}

	public override View(): HTMLElement {
		return this.view;
	}

	

	public SetInfoCanvas(text: string, Canvas: MyCanvas) {
		Canvas.context.clearRect(0, 0, (Canvas.rect.width), (Canvas.rect.height));		
		Canvas.context.font = "bold " + this.InfofontHeight + "px " + "NotoSansDisplay-Black";
		Canvas.context.fillStyle = "yellow";
		Canvas.context.textBaseline = "middle";
		Canvas.context.textAlign = "center";
		Canvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		Canvas.context.miterLimit = 2;
		Canvas.context.shadowBlur = Scale.fh(10);
		Canvas.context.shadowColor = "black";
		Canvas.context.shadowOffsetX = Scale.fh(8);
		Canvas.context.shadowOffsetY = Scale.fh(8);

		let str = text;
		//let a = 120;
		let b = 0;
		let lineheight = Scale.fh(30);
		let lines = str.split('\n');
		for (let j = 0; j < lines.length; j++) {
			Canvas.context.strokeStyle = "black";
			Canvas.context.lineWidth = 10;
			Canvas.context.strokeText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
			//Canvas.context.strokeStyle = "white";
			//Canvas.context.lineWidth = 10 / 4;
			Canvas.context.strokeText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
			Canvas.context.fillText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
		}
		Canvas.RestoreContext();
	}

	public override Update() {
		if (this.TitleCanvas.WasContextLost()) {
			this.RedrawTitleCanvas(this.translator.t.TitleTurboPlay, this.TitleCanvas);
		}		
	}	
}

export class HelpPageDoubleUpGame extends HelpPage {
	protected TitleElement: HTMLElement = null;
	protected ContainerElement: HTMLElement = null;
	//protected view: HTMLElement = null;
	protected gamePath: string = null;
	protected translator: Translator = null;
	protected description: HTMLElement = null;
	protected trigger: HTMLElement = null;
	protected descriptionTranslate: TranslatedLocation = null;


	protected InfoCanvas: MyCanvas = null;
	protected InfofontHeight: number = Scale.H(35);
	protected infoPage: HTMLElement = null;
	protected backendSettings: IBackendSettingsService;
	protected redCardImg: ImageResource = null;
	protected blackCardImg: ImageResource = null;
	
	protected resourcesPath:string = null;



	constructor(path: string, resid: ResourceIdentifier, translator: Translator, backendSettings:IBackendSettingsService) {
		super("HelpPageDoubleUpGame", path, resid)
		this.resid = this.resid.Add("HelpPageDoubleUpGame");
		this.resourcesPath = Settings.ResourcesFolder  + "multigame/slot/common/resources/DoubleUpFeature/cards/";
		

		this.translator = translator;
		this.backendSettings = backendSettings;
		//this.doubleUpView = new DoubleUp(doubleUpParams, doubleUpConfig, backendSettings);
		//this.view = document.createElement("div");
		//this.view.classList.add("help-page");


	}
	public override async PrepareResources(resourceManager: ResourceManager) {

		resourceManager.Add(new ImageResource(this.resourcesPath + "blackcard.png", this.resid.ScopedResourceName() + "blackCard"))
		resourceManager.Add(new ImageResource(this.resourcesPath + "redcard.png", this.resid.ScopedResourceName() + "redCard"))
	}
	public override async ResourcesLoaded(resourceManager: ResourceManager) {

		this.redCardImg = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName() + "redCard");
		this.blackCardImg = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName() + "blackCard");
		
		this.CreateTitleCanvas();

		let redCardDiv = document.createElement("img");
		redCardDiv.src = `${this.redCardImg.path}`;
		SetStyles(redCardDiv,
			{
				width:Scale.Hpx(200),
			});

		let blackCardDiv = document.createElement("img");
			blackCardDiv.src = `${this.blackCardImg.path}`;
			SetStyles(blackCardDiv,
				{
					width:Scale.Hpx(200),
				});

		let cardImgDiv = document.createElement("div");
		SetStyles(cardImgDiv,
			{
				display:"flex",
				position:"absolute",
				flexDirection: "row",
				marginTop: Scale.Ypx(17),
				gap: Scale.Xpx(17)
			})

		cardImgDiv.appendChild(redCardDiv);
		cardImgDiv.appendChild(blackCardDiv);

		this.description = CreateElement("div", {
			classes: ["description"],
			parentToAppend:this.pageContent,
			style: {
				width: "100%",
				height: "100%",
				//display: "flex",
				margin : "0 auto",
			}
		});

			this.infoPage = CreateElement("div", {
				classes: ["infoPage"],
				parentToAppend:this.description,
				style: {
					
					display: "flex",
					width: "100%",
					//margin : "0 auto",
					color: "yellow",
					fontSize: Scale.fhpx(42),
					fontFamily: "NotoSansDisplay-Black",
					webkitTextStroke: `${ Scale.fhpx(3)} black`,
					textAlign: "justify",					
					lineHeight : "initial",
					position:"absolute",
					top: Scale.Ypx(330),
					padding : Scale.XYpx(50),
				}
			});

		this.RedrawTitleCanvas(this.translator.t.doubleUpTitle, this.TitleCanvas);
		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);

		this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas(this.translator.t.doubleUpTitle, this.TitleCanvas));

		let translatedInfoMessage = this.translator.Translate(() => this.translator.t.doubleUpDescription(service.moneyFormatter.FormatCurrency(this.backendSettings.GetNum("play.doubleuplimit",100))));
		this.pageContent.appendChild(cardImgDiv);
		this.infoPage.appendChild(translatedInfoMessage.location);
	}

	public override View(): HTMLElement {
		return this.view;
	}

	

	public SetInfoCanvas(text: string, Canvas: MyCanvas) {
		Canvas.context.clearRect(0, 0, (Canvas.rect.width), (Canvas.rect.height));		
		Canvas.context.font = "bold " + this.InfofontHeight + "px " + "NotoSansDisplay-Black";
		Canvas.context.fillStyle = "yellow";
		Canvas.context.textBaseline = "middle";
		Canvas.context.textAlign = "center";
		Canvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		Canvas.context.miterLimit = 2;
		Canvas.context.shadowBlur = Scale.fh(10);
		Canvas.context.shadowColor = "black";
		Canvas.context.shadowOffsetX = Scale.fh(8);
		Canvas.context.shadowOffsetY = Scale.fh(8);

		let str = text;
		//let a = 120;
		let b = 0;
		let lineheight = Scale.fh(30);
		let lines = str.split('\n');
		for (let j = 0; j < lines.length; j++) {
			Canvas.context.strokeStyle = "black";
			Canvas.context.lineWidth = 10;
			Canvas.context.strokeText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
			//Canvas.context.strokeStyle = "white";
			//Canvas.context.lineWidth = 10 / 4;
			Canvas.context.strokeText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
			Canvas.context.fillText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
		}
		Canvas.RestoreContext();
	}
}

export class HelpPageFillingPot extends HelpPage {
	protected TitleElement: HTMLElement = null;
	protected ContainerElement: HTMLElement = null;
	//protected view: HTMLElement = null;
	protected gamePath: string = null;
	protected translator: Translator = null;
	protected description: HTMLElement = null;
	protected trigger: HTMLElement = null;
	protected descriptionTranslate: TranslatedLocation = null;


	protected InfoCanvas: MyCanvas = null;
	protected InfofontHeight: number = Scale.H(35);
	protected infoPage: HTMLElement = null;
	protected redCardImg: ImageResource = null;
	protected blackCardImg: ImageResource = null;
	
	protected resourcesPath:string = null;



	constructor(path: string, gamePath:string,resid: ResourceIdentifier, translator: Translator) {
		super("HelpPageFillingPot", path, resid)
		this.resid = this.resid.Add("HelpPageFillingPot");
		this.resourcesPath = Settings.ResourcesFolder  + "multigame/slot/common/resources/DoubleUpFeature/cards/";
		

		this.translator = translator;


	}
	public override async PrepareResources(resourceManager: ResourceManager) {

	}
	public override async ResourcesLoaded(resourceManager: ResourceManager) {

		
		this.CreateTitleCanvas();

		this.description = CreateElement("div", {
			classes: ["description"],
			parentToAppend:this.pageContent,
			style: {
				width: "100%",
				height: "100%",
				//display: "flex",
				margin : "0 auto",
			}
		});

			this.infoPage = CreateElement("div", {
				classes: ["infoPage"],
				parentToAppend:this.description,
				style: {
					
					display: "flex",
					width: "100%",
					//margin : "0 auto",
					color: "yellow",
					fontSize: Scale.fhpx(42),
					fontFamily: "NotoSansDisplay-Black",
					webkitTextStroke: `${ Scale.fhpx(3)} black`,
					textAlign: "justify",					
					lineHeight : "initial",
					position:"absolute",
					top: Scale.Ypx(330),
					padding : Scale.XYpx(50),
				}
			});

		this.RedrawTitleCanvas(this.translator.t.fillingPotTitle, this.TitleCanvas);
		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);

		this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas(this.translator.t.fillingPotTitle, this.TitleCanvas));

		let translatedInfoMessage = this.translator.Translate(() => this.translator.t.fillingPotDescription);
		this.infoPage.appendChild(translatedInfoMessage.location);

	}

	public override View(): HTMLElement {
		return this.view;
	}

	

	public SetInfoCanvas(text: string, Canvas: MyCanvas) {
		Canvas.context.clearRect(0, 0, (Canvas.rect.width), (Canvas.rect.height));		
		Canvas.context.font = "bold " + this.InfofontHeight + "px " + "NotoSansDisplay-Black";
		Canvas.context.fillStyle = "yellow";
		Canvas.context.textBaseline = "middle";
		Canvas.context.textAlign = "center";
		Canvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		Canvas.context.miterLimit = 2;
		Canvas.context.shadowBlur = Scale.fh(10);
		Canvas.context.shadowColor = "black";
		Canvas.context.shadowOffsetX = Scale.fh(8);
		Canvas.context.shadowOffsetY = Scale.fh(8);

		let str = text;
		//let a = 120;
		let b = 0;
		let lineheight = Scale.fh(30);
		let lines = str.split('\n');
		for (let j = 0; j < lines.length; j++) {
			Canvas.context.strokeStyle = "black";
			Canvas.context.lineWidth = 10;
			Canvas.context.strokeText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
			//Canvas.context.strokeStyle = "white";
			//Canvas.context.lineWidth = 10 / 4;
			Canvas.context.strokeText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
			Canvas.context.fillText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
		}
		Canvas.RestoreContext();
	}
}



export class HelpPageJackpotShared extends HelpPage {
	//protected TitleElement: HTMLElement = null;
	//protected ContainerElement: HTMLElement = null;
	//protected view: HTMLElement = null;
	//protected gamePath: string = null;
	protected translator: Translator = null;
	protected description: HTMLElement = null;
	//protected trigger: HTMLElement = null;
	//protected descriptionTranslate: TranslatedLocation = null;


	//protected InfoCanvas: MyCanvas = null;
	protected InfofontHeight: number = Scale.H(35);
	protected infoPage: HTMLElement = null;
	//protected redCardImg: ImageResource = null;
	//protected blackCardImg: ImageResource = null;
	
	//protected resourcesPath:string = null;


	protected symbolCollectionMap: Map<string, SymbolsCollectionResources> = null;

	constructor(path: string, gamePath:string,resid: ResourceIdentifier, translator: Translator, symbolCollectionMap: Map<string, SymbolsCollectionResources>) {
		super("HelpPageJackpotShared", path, resid)
		this.resid = this.resid.Add("HelpPageJackpotShared");	
		this.translator = translator;
		this.symbolCollectionMap = symbolCollectionMap;

	}
	

	protected jackpotAvailablesForHitShared : string [] = ["jp4","jp3"]
	public override async PrepareResources(resourceManager: ResourceManager) {
		for (let jp of this.jackpotAvailablesForHitShared){
			resourceManager.Add(new ImageResource(Settings.ResourcesFolder + `multigame/slot/common/resources/ScatterRandomAward/${Settings.JackpotDisplayType}/${jp}.png`, this.resid.ScopedResourceName(`${jp}-HelpAward`)));	
		}
	}
	public override async ResourcesLoaded(resourceManager: ResourceManager) {

		
		this.CreateTitleCanvas();

		this.description = CreateElement("div", {
			classes: ["description"],
			parentToAppend:this.pageContent,
			style: {
				width: "100%",
				height: "100%",
				//display: "flex",
				margin : "0 auto",
			}
		});

			this.infoPage = CreateElement("div", {
				classes: ["infoPage"],
				parentToAppend:this.description,
				style: {
					
					display: "flex",
					width: "100%",
					//margin : "0 auto",
					color: "yellow",
					fontSize: Scale.fhpx(42),
					fontFamily: "NotoSansDisplay-Black",
					webkitTextStroke: `${ Scale.fhpx(3)} black`,
					textAlign: "justify",					
					lineHeight : "initial",
					position:"absolute",
					top: Scale.Ypx(330),
					padding : Scale.XYpx(50),
				}
			});

		this.RedrawTitleCanvas("JACKPOT SHARED", this.TitleCanvas);
		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);


		let containerAllAwardShared = CreateElement("div",
			{
				parentToAppend : this.description,
				style:
				{
					display: "flex",
					justifyContent: "center",
					alignContent: "center",
					margin: Scale.fhpx(100),
					//margin: Scale.fhpx(50),							
					//position : "relative",
					//top : Scale.Ypx(-357),
					//left : Scale.Xpx(225),
				}
			}
		)
			//let containerArray: HTMLElement [] = [];
			for (let jp of this.jackpotAvailablesForHitShared) {	
	
				let nameAwardJackpot = document.createElement("div");
				SetStyles(nameAwardJackpot,
					{
						backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(`${jp}-HelpAward`)).CssBackground(),
						width: "50%",
						height: Scale.Hpx(100),
						//backgroundImage: this.symbolCollectionMap.get("Symbol_SRA").imgResource,
						backgroundRepeat: "no-repeat",
						backgroundSize: "contain",
						backgroundPosition: "center",
						display: "flex",
						//position: "absolute"
						//verticalAlign: "middle",
						//margin: Scale.fhpx(100),
					});
	
					//containerAward.appendChild(nameAwardJackpot);
					//containerAward.appendChild(scatterExtendend);
	
	
				containerAllAwardShared.appendChild(nameAwardJackpot)
				//containerArray.push(container);
			}
	

		//this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas(this.translator.t.fillingPotTitle, this.TitleCanvas));
		let translatedInfoMessage = this.translator.Translate(() => this.translator.t.jackpotSharedDescription);
		this.infoPage.appendChild(translatedInfoMessage.location);
	}

	public override View(): HTMLElement {
		return this.view;
	}

	

	public SetInfoCanvas(text: string, Canvas: MyCanvas) {
		Canvas.context.clearRect(0, 0, (Canvas.rect.width), (Canvas.rect.height));		
		Canvas.context.font = "bold " + this.InfofontHeight + "px " + "NotoSansDisplay-Black";
		Canvas.context.fillStyle = "yellow";
		Canvas.context.textBaseline = "middle";
		Canvas.context.textAlign = "center";
		Canvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		Canvas.context.miterLimit = 2;
		Canvas.context.shadowBlur = Scale.fh(10);
		Canvas.context.shadowColor = "black";
		Canvas.context.shadowOffsetX = Scale.fh(8);
		Canvas.context.shadowOffsetY = Scale.fh(8);

		let str = text;
		//let a = 120;
		let b = 0;
		let lineheight = Scale.fh(30);
		let lines = str.split('\n');
		for (let j = 0; j < lines.length; j++) {
			Canvas.context.strokeStyle = "black";
			Canvas.context.lineWidth = 10;
			Canvas.context.strokeText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
			//Canvas.context.strokeStyle = "white";
			//Canvas.context.lineWidth = 10 / 4;
			Canvas.context.strokeText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
			Canvas.context.fillText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
		}
		Canvas.RestoreContext();
	}
}

export class HelpPageBonusMultiplier extends HelpPage {
	//protected TitleElement: HTMLElement = null;
	//protected ContainerElement: HTMLElement = null;
	//protected view: HTMLElement = null;
	//protected gamePath: string = null;
	protected translator: Translator = null;
	protected description: HTMLElement = null;
	//protected trigger: HTMLElement = null;
	//protected descriptionTranslate: TranslatedLocation = null;


	//protected InfoCanvas: MyCanvas = null;
	protected InfofontHeight: number = Scale.H(35);
	protected infoPage: HTMLElement = null;
	//protected redCardImg: ImageResource = null;
	//protected blackCardImg: ImageResource = null;
	
	//protected resourcesPath:string = null;


	protected symbolCollectionMap: Map<string, SymbolsCollectionResources> = null;

	constructor(path: string, gamePath:string,resid: ResourceIdentifier, translator: Translator, symbolCollectionMap: Map<string, SymbolsCollectionResources>) {
		super("HelpPageBonusMultiplier", path, resid)
		this.resid = this.resid.Add("HelpPageBonusMultiplier");	
		this.translator = translator;
		this.symbolCollectionMap = symbolCollectionMap;
	}
	
	
	protected bonusMultiplier : string [] = ["X2","X3"]
	public override async PrepareResources(resourceManager: ResourceManager) {
		for (let bnMulti of this.bonusMultiplier){
			resourceManager.Add(new ImageResource(Settings.ResourcesFolder + `multigame/slot/common/resources/BonusResorucesSpine/BonusMultiplier/Help/${bnMulti}.png`, this.resid.ScopedResourceName(`${bnMulti}-HelpBonusMultiplier`)));				
		}
	}
	public override async ResourcesLoaded(resourceManager: ResourceManager) {

		
		this.CreateTitleCanvas();

		this.description = CreateElement("div", {
			classes: ["description"],
			parentToAppend:this.pageContent,
			style: {
				width: "100%",
				height: "100%",
				//display: "flex",
				margin : "0 auto",
			}
		});

			this.infoPage = CreateElement("div", {
				classes: ["infoPage"],
				parentToAppend:this.description,
				style: {
					
					display: "flex",
					width: "100%",
					//margin : "0 auto",
					color: "yellow",
					fontSize: Scale.fhpx(42),
					fontFamily: "NotoSansDisplay-Black",
					webkitTextStroke: `${ Scale.fhpx(3)} black`,
					textAlign: "justify",					
					lineHeight : "initial",
					position:"absolute",
					top: Scale.Ypx(560),
					padding : Scale.XYpx(50),
				}
			});

		this.RedrawTitleCanvas("BONUS MULTIPLIER", this.TitleCanvas);
		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);


		let containerAllAwardShared = CreateElement("div",
			{
				parentToAppend : this.description,
				style:
				{
					display: "flex",
					justifyContent: "center",
					alignContent: "center",
					margin: Scale.fhpx(50),
					//margin: Scale.fhpx(50),							
					//position : "relative",
					//top : Scale.Ypx(-357),
					//left : Scale.Xpx(225),
				}
			}
		)
			//let containerArray: HTMLElement [] = [];
			for (let bnMulti of this.bonusMultiplier) {
			
	
				// let scatterExtendend = this.symbolCollectionMap.get("Symbol_SRA").imgResource.cloneNode(true) as HTMLSpanElement;
				// SetStyles(scatterExtendend,
				// 	{
				// 		width: Scale.Wpx(300),
				// 		height: Scale.Hpx(250),
				// 		//backgroundImage: this.symbolCollectionMap.get("Symbol_SRA").imgResource,
				// 		backgroundRepeat: "no-repeat",
				// 		backgroundSize: "contain",
				// 		backgroundPosition: "center",
				// 		display: "flex",					
				// 		//verticalAlign: "middle",
				// 		//margin: Scale.fhpx(-15),
				// 	});
	
	
				let nameAwardJackpot = document.createElement("div");
				SetStyles(nameAwardJackpot,
					{
						backgroundImage: resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(`${bnMulti}-HelpBonusMultiplier`)).CssBackground(),
						width: "50%",
						height: Scale.Hpx(500),						
						backgroundRepeat: "no-repeat",
						backgroundSize: "contain",
						backgroundPosition: "center",
						display: "flex",
						//position: "absolute"
						//verticalAlign: "middle",
						//margin: Scale.fhpx(100),
					});
	
					//containerAward.appendChild(nameAwardJackpot);
					//containerAward.appendChild(scatterExtendend);
	
	
				containerAllAwardShared.appendChild(nameAwardJackpot)
				//containerArray.push(container);
			}
	

		//this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas(this.translator.t.fillingPotTitle, this.TitleCanvas));
		let translatedInfoMessage = this.translator.Translate(() => this.translator.t.bonusMultiplierDescription);
		this.infoPage.appendChild(translatedInfoMessage.location);
	}

	public override View(): HTMLElement {
		return this.view;
	}

	

	public SetInfoCanvas(text: string, Canvas: MyCanvas) {
		Canvas.context.clearRect(0, 0, (Canvas.rect.width), (Canvas.rect.height));		
		Canvas.context.font = "bold " + this.InfofontHeight + "px " + "NotoSansDisplay-Black";
		Canvas.context.fillStyle = "yellow";
		Canvas.context.textBaseline = "middle";
		Canvas.context.textAlign = "center";
		Canvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		Canvas.context.miterLimit = 2;
		Canvas.context.shadowBlur = Scale.fh(10);
		Canvas.context.shadowColor = "black";
		Canvas.context.shadowOffsetX = Scale.fh(8);
		Canvas.context.shadowOffsetY = Scale.fh(8);

		let str = text;
		//let a = 120;
		let b = 0;
		let lineheight = Scale.fh(30);
		let lines = str.split('\n');
		for (let j = 0; j < lines.length; j++) {
			Canvas.context.strokeStyle = "black";
			Canvas.context.lineWidth = 10;
			Canvas.context.strokeText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
			//Canvas.context.strokeStyle = "white";
			//Canvas.context.lineWidth = 10 / 4;
			Canvas.context.strokeText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
			Canvas.context.fillText(lines[j], Canvas.rect.width / 2, b + (j * lineheight));
		}
		Canvas.RestoreContext();
	}
}



export class HelpPageExtendedHoldAndSpin extends HelpPage {

	protected ContainerElement: HTMLElement = null;
	//protected view: HTMLElement = null;
	protected gamePath: string = null;
	protected translator: Translator = null;
	protected description: HTMLElement = null;
	protected commonPath: string = null;
	protected bonusConfig: ExtendedSpinAndHoldCommonConfiguration = null;
	readonly symbolCollectionMap: Map<string, SymbolsCollectionResources> = null;

	constructor(path: string, resid: ResourceIdentifier, gamePath: string, translator: Translator, bonusConfig: ExtendedSpinAndHoldCommonConfiguration , symbolCollectionMap: Map<string, SymbolsCollectionResources>) {
		super("HelpPageExtendendHoldAndSpin", path, resid)
		this.resid = this.resid.Add("HelpPageExtendendHoldAndSpin");
		this.gamePath = gamePath;
		this.translator = translator;
		this.commonPath = Settings.ResourcesFolder + "multigame/slot/common/resources/HoldAndSpin/resources/"
		this.bonusConfig = bonusConfig;
		this.symbolCollectionMap = symbolCollectionMap;
	}
	// public override async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
	// 	// let triggerPath = this.gamePath + "ExtendedHoldAndSpin/trigger.png";
    //     // if (this.symbolsByJackpot[Settings.JackpotDisplayType]?.includes("SRA")) {
    //     //     triggerPath = this.gamePath + "ExtendedHoldAndSpin/SymbolJackpots/" + Settings.JackpotDisplayType + "/Help/trigger.png";
    //     // }
        
	// 	// resourceManager.Add(new ImageResource(triggerPath, this.resid.ScopedResourceName(["extendedHelpTriegger", "img"])));
	// }
	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		this.CreateTitleCanvas();
		let text = "EXTENDEND STICKY SPIN BONUS";
		this.RedrawTitleCanvas(text, this.TitleCanvas);

		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);

		this.description = CreateElement("div", {
			classes: ["description"],
			parentToAppend: this.pageContent,
			style: {
				width: Scale.Wpx(1765),
				height: Scale.Hpx(820),
				color: "yellow",
				fontSize: Scale.fhpx(40),
				fontFamily: "NotoSansDisplay-Black",
				//textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "justify",
				//display: "flex",
				//flexDirection: "column",
				//background: "pink",
				//fontSizeAdjust: "0.58",
				lineHeight : "initial",
				webkitTextStroke : Scale.fhpx(3)+" black"
				
				
			}
		});

		

		//let scatterExtendend = document.createElement("span");
		let scatterExtendend = this.symbolCollectionMap.get("Symbol_SRA").imgResource as HTMLSpanElement;
		SetStyles(scatterExtendend,
			{
				width: Scale.Wpx(110),
				height: Scale.Hpx(100),
				//backgroundImage: this.symbolCollectionMap.get("Symbol_SRA").imgResource,
				backgroundRepeat: "no-repeat",
				backgroundSize: "contain",
				backgroundPosition: "center",
				display: "inline-block",
				verticalAlign: "middle",
				margin: Scale.fhpx(-15),
			});
			


		// let symbolMapImg = DrawSymbolImage(resourceManager, this.symbolTriggerNameBonus, new Size(), `ScreenAll-Multigame-${this.gameName}-Symbol`);
		// let symbolcontainer = symbolMapImg.get("SRA");
		// symbolcontainer.style.display = "flex";
		// symbolcontainer.style.width = Scale.Wpx(120);
		// symbolcontainer.style.height = Scale.Wpx(100);
		// scatterExtendend.appendChild(symbolcontainer);			

		const unlockRowsConfigs = FilterFeatures(this.bonusConfig.MultiFeatureConfiguration, (f): f is UnlockRowsConfig => f.FeatureType == "UnlockRows");
		assertTrue(!IsEmptyOrNull(unlockRowsConfigs), "UnlockRowsConfig must exist");

		const unlockRowsConfig = Object.values(unlockRowsConfigs)[0];


		const playWindow = this.bonusConfig.MultiPlayWindow[0];
		let translatedMessage = this.translator.Translate(() => this.translator.t.helpInfoExttendedSpinAndHold(
			scatterExtendend.outerHTML,
			this.bonusConfig.TriggerCount,
			this.bonusConfig.ResetSpinsCount,
			playWindow.Width,
			playWindow.Height,
			unlockRowsConfig
		));
		this.description.appendChild(translatedMessage.location);

	}

	public override View(): HTMLElement {

		//this.view.style.visibility = "hidden";
		return this.view;
	}

	public override Update() {
		if (this.TitleCanvas.WasContextLost()) {
			this.RedrawTitleCanvas("EXTENDEND STICKY SPIN BONUS", this.TitleCanvas);
		}
	}
}

export class HelpWildScreenShoot implements Resourceful {
	protected view: HTMLElement = null;
	protected playWindow: PlayWindow = null;
	protected symbolsNamesArray: string[] = [];
	protected featuresGame: string[] = [];
	protected gameName: string = "";
	protected wildInReelShow: number[] = [];
	protected symbolPath : string  = "";
	protected symbolSize: Size = null;
	readonly symbolCollectionMap: Map<string, SymbolsCollectionResources>;
	readonly symbolTypeAnim : SymbolTypeAnim = null;

	constructor(initData: SlotGameInitData , symbolCollectionMap: Map<string, SymbolsCollectionResources> , symbolTypeAnim : SymbolTypeAnim ) {
		this.symbolCollectionMap = symbolCollectionMap;
		//initData.Symbols;
		this.symbolsNamesArray = initData.Symbols.flatMap((symbol) => {
			return symbol.ID;
		})
		// .filter((symbol) => symbol != "Wild" && symbol != "SCA" && symbol != "FG" );

		this.gameName = initData.Name;

		this.view = CreateElement("div", {
			style: {
				width: "100%",
				height: "100%",
				display: "flex",
				verticalAlign: "middle",
				margin: "0px",
				//left : Scale.Xpx(-10),
				position: "relative",
				backgroundColor: "rgba(0,0,0,0,5)",
				justifyContent : "center",
				alignItems: "center"				

			}
		})
		this.playWindow = initData.PlayWindow;
		//this is for know where its the wild symbol on math 				
		let wildSymbol = initData.Symbols.find(symbol => symbol.ID == "Wild" && symbol.IsWild == true);
		if (wildSymbol) {
			for (let reel = 0; reel < initData.ReelSet.length; reel++) {
				for (let row = 0; row < initData.ReelSet[reel].length; row++) {
					if (initData.ReelSet[reel][row] == wildSymbol.Index) {
						this.wildInReelShow.push(reel);
						break
					}
				}
			}
		}
		wildSymbol = null;
		this.featuresGame = initData.Feature;

		//create path for search symbols into resource manager per game 
		this.symbolPath = `ScreenAll-Multigame-${this.gameName}-Symbol`;
		//auto size symbols depends how many have 
		this.symbolSize = new Size(Scale.W(Math.max(85 - (this.playWindow.Width * this.playWindow.Height), 30 - (this.playWindow.Width * this.playWindow.Height))), Scale.H(Math.max(75 - (this.playWindow.Width * this.playWindow.Height), 25 - (this.playWindow.Width * this.playWindow.Height))))		
		this.symbolTypeAnim = symbolTypeAnim;
	}
	
	public PrepareResources(resourceManager: IWriteOnlyResourceManager) {		
		if (this.symbolTypeAnim == SymbolTypeAnim.Spine && this.featuresGame.find(feature => feature == "ExpandingWildReel")) {
			resourceManager.AddGlobal(new JSONResource(`${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/expanding_wild_reel/Spine/expanding_wild_reel.json`, ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-Feature-ExpandingWildReel-Json`)));
			resourceManager.AddGlobal(new AtlasResource(`${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/expanding_wild_reel/Spine/expanding_wild_reel.atlas`, ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-Feature-ExpandingWildReel-Atlas`)));
		}
	}
	
	protected skeleton : ISkeletonData = null;
	public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {		
		if (this.symbolTypeAnim == SymbolTypeAnim.Spine && this.featuresGame.find(feature => feature == "ExpandingWildReel")) {
			let symbolJsonResource = await Assets.load(resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-Feature-ExpandingWildReel-Json`)).path);
			this.skeleton = symbolJsonResource.spineData as ISkeletonData;
		}
		this.CreateBackgroundReelsTable(resourceManager);	
		await this.CreateTable(resourceManager);		
	}

	protected symbolsResid: ResourceIdentifier = new ResourceIdentifier(ResourceIdentifier.Shared, "SystemContext");

	protected async CreateTable(resourceManager: IReadOnlyResourceManager) {	
		//create table symbols
		let symbolsTable = CreateElement("table", {
			parentToAppend: this.view,
			style: {
				//width: "100%",
				//height: "100%",
				alignContent: "center",
				position: "absolute",
				justifyContent : "center",
			}
		});

		


		for (let reel = 0; reel < this.playWindow.Height; reel++) {
			let reelElement = CreateElement("tr", {
				parentToAppend: symbolsTable,
				style: {
					display: "flex",
					flexDirection: "row",
				}
			});
			for (let row = 0; row < this.playWindow.Width; row++) {		
				let rowElement = CreateElement("td", {
					parentToAppend: reelElement,
					style: {
						display: "flex",
						justifyContent: "center",
					}
				});

				//take integer part
				let middleRow = (this.playWindow.Width / 2) >> 0;
				let middleReel = (this.playWindow.Height / 2) >> 0;
				//add wild Img to table
				if (middleRow == row && middleReel == reel) {

					rowElement.style.justifyContent = "center";
					rowElement.style.alignItems = "center";
					//rowElement.style.display = "flex";

					let wildImg = this.symbolCollectionMap.get("Symbol_Wild").imgResource.cloneNode(true) as HTMLSpanElement;
					wildImg.style.width = this.symbolSize.Width + "px";
					wildImg.style.height = this.symbolSize.Height + "px";
					wildImg.style.display = "flex";
					rowElement.appendChild(wildImg);

					await this.CreateFeatureWild(resourceManager, rowElement, this.symbolSize);
				}
				else {
					//put random symbol
					let symbolname = "";
					//repeat this process if random symbols its wild
					do {
						symbolname = this.symbolsNamesArray.random();
					} while (symbolname == "Wild");
					//take img from map for append and use 
					let imgSymbol = this.symbolCollectionMap.get("Symbol_"+symbolname).imgResource.cloneNode(true) as HTMLSpanElement;		
					imgSymbol.style.width = this.symbolSize.Width + "px";
					imgSymbol.style.height = this.symbolSize.Height + "px";		
					imgSymbol.style.display = "flex";					
					rowElement.appendChild(imgSymbol.cloneNode(true));
					if(symbolname == "SRA") rowElement.appendChild(this.CreateAward(resourceManager))
				}
				rowElement = null;
			}
			reelElement = null;			
		}
	}

	protected CreateBackgroundReelsTable(resourceManager: IReadOnlyResourceManager){
		//create table background
		let symbolsTableBackground = CreateElement("div", {
			parentToAppend: this.view,
			style: {
				width: "100%",
				height: (this.symbolSize.Height * this.playWindow.Height)+ Scale.fh(15) + "px",
				alignContent: "center",
				position: "absolute",
				justifyContent : "center",
				flexDirection : "row",
				display : "flex"
			}
		});


		for (let row = 0; row < this.playWindow.Width; row++) {
			let backgroundContainer = CreateElement("div", {
				parentToAppend: symbolsTableBackground,
				style: {
					alignContent: "center",
					backgroundImage: resourceManager.Get<DecodedImageResource>(`Screen1-Multigame-${this.gameName}-reel-image`).CssBackground(),
					backgroundPosition: "center",
					backgroundSize: "100% 100%",
					backgroundRepeat: "no-repeat",
					width: this.symbolSize.Width + "px",
					height: "100%",
					display: "flex",
					margin : Scale.fhpx(1.5)  ,
					//objectFit : "cover",
				}
			});
			backgroundContainer = null;
		}
	}

	//create view for featureWild
	protected async CreateFeatureWild(resourceManager: IReadOnlyResourceManager, appendElement: HTMLElement, symbolSize: Size) {
		if (this.featuresGame.find(feature => feature == "ExpandingWildBulk")) {
			//create path for search symbols into resource manager per game 
			//let symbolPath = `ScreenAll-Multigame-${this.gameName}-Symbol`;

			//create 3x3 wildBulk
			let WildBulkContainer = CreateElement("div", {
				parentToAppend: appendElement,
				style: {
					display: "flex",
					position: "absolute",
					zIndex : "1",
				}
			});

			appendElement.style.display = "flex";


			//create 3x3 wildBulk and take frame 0 			
			let bigSymbolMap = this.symbolCollectionMap.get("Symbol_Wild").imgResource.cloneNode(true) as HTMLSpanElement;
			bigSymbolMap.style.width = symbolSize.Width * 3 + "px";
			bigSymbolMap.style.height = symbolSize.Height * 3 + "px";		
			
			
			bigSymbolMap.style.display = "flex";
			WildBulkContainer.appendChild(bigSymbolMap);

			//crear data
			//wildImg = null;
			WildBulkContainer = null;
			bigSymbolMap = null;			
			//symbolPath = null;

			//rowElement.innerText = `Wild`
		} else if (this.featuresGame.find(feature => feature == "ExpandingWildReel") && false) {
			//create 3x3 wildBulk
			let WildReelContainer = CreateElement("div", {
				parentToAppend: appendElement,
				style: {
					width: symbolSize.Width + "px",
					height: (symbolSize.Height * this.playWindow.Height) * 1.12 + "px",
					display: "flex",
					position: "absolute"
				}
			});

			appendElement.style.display = "flex";

			if (this.symbolTypeAnim == SymbolTypeAnim.Sprites) {
				let wildReelMap = DrawSymbolImage(resourceManager, ["ExpandingWildReel"], new Size(symbolSize.Width, (symbolSize.Height * this.playWindow.Height) * 1.12), ResourceIdentifier.Global.Add(this.gameName).Add("Feature").Scope(), true);
				let wildReelImg = wildReelMap.get("ExpandingWildReel");
				wildReelImg.style.display = "flex";
				WildReelContainer.appendChild(wildReelImg);
			}else {
				let symbolReed  = await DrawSymbolImageSpine(this.skeleton , new Size(symbolSize.Width, (symbolSize.Height * this.playWindow.Height) * 1.12));
				let wildReelImg = symbolReed;
				wildReelImg.style.display = "flex";
				WildReelContainer.appendChild(wildReelImg);
			}
		}
	}

	public View(): HTMLElement {
		return this.view;
	}

	readonly weightsAward = [0.7, 0.8, 0.9, 1]
	readonly awardsArray = ["number", "jp1", "jp2", "jp3"]

	readonly weightsCash = [0.08, 0.16, 0.24, 0.32, 0.4, 0.58, 0.76, 1]
	readonly awardsCash = ["100", "200", "300", "500", "1000", "1500", "2000", "2500"]
	protected CreateAward(resourceManager: IReadOnlyResourceManager): HTMLElement {

		let randomPercent = Math.random();
		let randomIndex = this.weightsAward.findIndex(p => randomPercent < p);

		//Screen1-Multigame-CloverGirlGreenFillingPot-Feature-ScatterRandomAward-JP-jp1-image
		let containerAward = CreateElement("div", {
			style: {

				position: "absolute",
				width: this.symbolSize.Width + "px",
				height: this.symbolSize.Height + "px",
				//top : Scale.Ypx(22),
				display: "flex",
			}
		})

		if (randomIndex != 0) {
			//containerAward.style.display = "flex";	
			//containerAward.style.backgroundImage = resourceManager.Get<DecodedImageResource>(`Screen1-Multigame-${this.gameName}-Feature-ScatterRandomAward-JP-${this.awardsArray[randomIndex]}-image`).CssBackground(),
			containerAward.style.backgroundPosition = "50% 48%";
			containerAward.style.backgroundSize = "60% 20%";
			containerAward.style.backgroundRepeat = "no-repeat";
		}
		else {
			let awardCash = CreateElement("div", {
				parentToAppend: containerAward,
				style: {
					textAlign: "center",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					textShadow: `${Scale.H(3)}px ${Scale.H(1)}px ${Scale.H(4)}px rgba(0,0,0,1) , ${Scale.H(3)}px ${Scale.H(1)}px ${Scale.H(4)}px rgba(0,0,0,1) , ${Scale.H(5)}px ${Scale.H(2)}px ${Scale.H(5)}px rgba(0,0,0,0.42)`,
					color: "white",
					webkitTextStroke : `${ Scale.fhpx(1)} black`,
					fontSize : Scale.fhpx(15),
				
				}
			})

			let randomPercentCashAward = Math.random();
			let randomIndexCashAward = this.weightsCash.findIndex(p => randomPercentCashAward < p);
			awardCash.textContent = this.awardsCash[randomIndexCashAward];
			//containerAward.style.display = "flex";	
			containerAward.style.justifyContent = "center";
			containerAward.style.alignItems = "center";
		}
		return containerAward;
	}
}

export class HelpSRAFullAwardScreenShoot extends HelpWildScreenShoot {
	protected override async CreateTable(resourceManager: IReadOnlyResourceManager) {		
		//create table 
		let symbolsTable = CreateElement("table", {
			parentToAppend: this.view,
			style: {
				//width: "100%",
				//height: "100%",
				alignContent: "center",
				position: "absolute",
				justifyContent: "center",
			}
		});



		for (let reel = 0; reel < this.playWindow.Height; reel++) {
			let reelElement = CreateElement("tr", {
				parentToAppend: symbolsTable,
				style: {
					display: "flex",
					flexDirection: "row",
				}
			});
			for (let row = 0; row < this.playWindow.Width; row++) {

				let rowElement = CreateElement("td", {
					parentToAppend: reelElement,
					style: {
						display: "flex",
						justifyContent: "center",
					}
				});
				//take integer part
				let middleRow = (this.playWindow.Width / 2) >> 0;
				let middleReel = (this.playWindow.Height / 2) >> 0;
				//add wild Img to table

				//put random symbol
				let symbolname = "SRA";
				//take img from map for append and use 
				let imgSymbol = this.symbolCollectionMap.get("Symbol_"+symbolname).imgResource.cloneNode(true) as HTMLSpanElement;
				imgSymbol.style.width = this.symbolSize.Width + "px";
				imgSymbol.style.height = this.symbolSize.Height + "px";				
				imgSymbol.style.display = "flex";
				//let clone = imgSymbol.cloneNode(true);
				rowElement.appendChild(imgSymbol.cloneNode(true));

				rowElement.appendChild(this.CreateAward(resourceManager));

				rowElement = null;
			}
			reelElement = null;
		}
	}
}

export class HelpWildStackScreenShoot extends HelpWildScreenShoot {
	protected override async CreateTable(resourceManager: IReadOnlyResourceManager) {
		//create map for save frame 0 for all symbols 
		let symbolMapImg = DrawSymbolImage(resourceManager, this.symbolsNamesArray, this.symbolSize, this.symbolPath);
		//create table symbols
		let symbolsTable = CreateElement("table", {
			parentToAppend: this.view,
			style: {
				//width: "100%",
				//height: "100%",
				alignContent: "center",
				position: "absolute",
				justifyContent: "center",
			}
		});


		//console.log("WildStack:", this.wildInReelShow);
		let numberRandomReelWild = this.wildInReelShow.random();
		let symbolsToConvertWild: HTMLTableCellElement[] = []
		for (let reel = 0; reel < this.playWindow.Height; reel++) {
			let reelElement = CreateElement("tr", {
				parentToAppend: symbolsTable,
				classes: [`reel-${reel}`],
				style: {
					display: "flex",
					flexDirection: "row",
				}
			});

			for (let row = 0; row < this.playWindow.Width; row++) {
				let rowElement = CreateElement("td", {
					parentToAppend: reelElement,
					classes: [`row-${row}`],
					style: {
						display: "flex",
						justifyContent: "center",
					}
				});

				//take integer part
				//let middleRow = (this.playWindow.Width / 2) >> 0;
				//let middleReel = (this.playWindow.Height / 2) >> 0;
				//add wild Img to table
				if (row != numberRandomReelWild) {
					//put random symbol
					let symbolname = "";
					//repeat this process if random symbols its wild
					do {
						symbolname = this.symbolsNamesArray.random();
					} while (symbolname == "Wild");
					//take img from map for append and use 
					let imgSymbol = symbolMapImg.get(symbolname)
					imgSymbol.style.display = "flex";
					rowElement.appendChild(imgSymbol.cloneNode(true));
					if (symbolname == "SRA") rowElement.appendChild(this.CreateAward(resourceManager))
				}
				else {
					symbolsToConvertWild.push(rowElement);
				}
			}
		}

		//console.log("symbolsElements:", numberRandomReelWild);
		//console.log("symbolsElements:", symbolsToConvertWild);
		symbolsToConvertWild.forEach((element) => {
			let wildImg = symbolMapImg.get("Wild");
			wildImg.style.display = "flex";
			//element.removeChild();
			element.appendChild(wildImg.cloneNode(true));
		})
	}
}

export class HelpScreenShootInfoFullAward implements Resourceful {
	protected view: HTMLElement = null;
	protected playWindow: PlayWindow = null;
	protected symbolsNamesArray: string[] = [];
	protected featuresGame: string[] = [];
	protected gameName: string = "";
	protected wildInReelShow: number[] = [];
	protected symbolPath: string = "";
	protected symbolSize: Size = null;
	protected FullAwardCount : number = 0;
	protected configBonus: Record<string, ScatterRandomAwardConfiguration> = null;
	protected translator: Translator = null;
	readonly symbolCollectionMap: Map<string, SymbolsCollectionResources> = null
	constructor(initData: SlotGameInitData, translator: Translator, symbolCollectionMap: Map<string, SymbolsCollectionResources>,) {


		this.gameName = initData.Name;
		this.symbolCollectionMap = symbolCollectionMap;

		this.view = CreateElement("div", {
			style: {
				width: "100%",
				height: "100%",
				display: "flex",
				verticalAlign: "middle",
				margin: "0px",
				//left : Scale.Xpx(-10),
				position: "relative",
				backgroundColor: "rgba(0,0,0,0,5)",
				justifyContent: "center",
				alignItems: "center"

			}
		});
		
		this.configBonus = FilterFeatures(initData.BonusConfiguration.SpinAndHold.MultiFeatureConfiguration, (f): f is ScatterRandomAwardConfiguration => f && f.FeatureType == "ScatterRandomAward")
		this.translator = translator;
	}
	public PrepareResources(resourceManager: IWriteOnlyResourceManager) {
		

		
	}
	public ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
		this.CreateInfoFullAward(resourceManager);
	}

	protected arrayDivs : HTMLElement [] = [];
	protected CreateInfoFullAward(resourceManager: IReadOnlyResourceManager) {

		let viewContainer = CreateElement("div", {
			parentToAppend: this.view,
			style: {
				width: "100%",
				height: "100%",
				display: "flex",
				flexDirection : "column",
				justifyContent : "center",
				alignContent : "center",
			}
		})
		for (let a = 0; a <=2; a++) {
			let divContainer = CreateElement("div", {
				parentToAppend: viewContainer,
				style: {
					width: "100%",
					height: "33.3%",
					display : "flex",
					justifyContent : "center",
					alignContent : "center",
				}
			})
			this.arrayDivs.push(divContainer)
		}

		//create full Award info 
		let CanvasNumberFreeGames = new MyCanvas(new Size(Scale.W(120), Scale.H(110)), {
            style: {
                display: "flex",
                zIndex: "" + ZIndex.BonusWin,
				justifyContent : "center",
				alignContent : "center",
            }
        });	
		this.SetNumbeCanvasFullAward(Object.values(this.configBonus)[0].FullCount + " x " ,CanvasNumberFreeGames , Scale.fh(50));
		this.arrayDivs[0].appendChild(CanvasNumberFreeGames.View());
		let bonusTriggerImg = this.symbolCollectionMap.get("Symbol_SRA").imgResource.cloneNode(true) as HTMLSpanElement;
		bonusTriggerImg.style.width = Scale.Wpx(125);
		bonusTriggerImg.style.height = Scale.Hpx(100);
		bonusTriggerImg.style.display = "flex";
		this.arrayDivs[0].appendChild(bonusTriggerImg);


		
		let spineScreenShot = globalThis?.jackpotDisplayGlobal?.GetSImgTitleJackpotSpine() ?? null;
		if (!spineScreenShot) {
			//Append Title for Jackpot , 
			let sprite: ISprite = resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add(Settings.JackpotDisplayType).Add("presentation-title")).sprite;
			let canvasSprite: CanvasSprite = new CanvasSprite({
				sprite: sprite, canvasSize: new Size(Scale.W(475), Scale.H(176)), drawFirstFrame: true, sizing: CanvasSpriteSizing.Fit, createElementParams: {
					style: {
						position: "absolute",
						alignContent: "center",
						justifyContent: "center",
						// hidden by default
						visibility: "hidden",
					}
				}
			});

			//canvasSprite.Scale(0.8);
			//return data saved from  img from canvas
			let dataCanvas = canvasSprite.PreviewImage(false);

			//create img div empty
			let imgConverted = CreateElement("img", {
				style: {
					width: "90%",
					height: "115%",
					backgroundPosition: "center",
					backgroundSize: "contain",
					backgroundOrigin: "center",
					position: "relative",
					top: Scale.Ypx(-25),
				}
			});
			//add img src from data img saved 
			imgConverted.src = dataCanvas;



			this.arrayDivs[1].appendChild(imgConverted);
			canvasSprite = null;
			sprite = null;
			imgConverted = null;
			dataCanvas = null;

		}
		else {
			this.arrayDivs[1].appendChild(spineScreenShot);
		}

		this.arrayDivs[1].style.height = "45%";
		

		// add translate 
		let translatedMessage1 = this.translator.Translate(() => this.translator.t.spinandHoldInfoHelpFullAward);
		this.arrayDivs[2].style.fontSize = Scale.fhpx(25);
		this.arrayDivs[2].style.fontFamily = "NotoSansDisplay-Black";
		this.arrayDivs[2].style.webkitTextStroke = `${Scale.fhpx(1)} black`;
		this.arrayDivs[2].appendChild(translatedMessage1.location);
	}

	protected SetNumbeCanvasFullAward(text: string, Canvas: MyCanvas , fontHeight: number ) {
		Canvas.context.font = "bold " + fontHeight + "px " + "NotoSansDisplay-Black";

		Canvas.context.fillStyle = "yellow";

		Canvas.context.textBaseline = "middle";
		Canvas.context.textAlign = "center";
		Canvas.context.lineJoin = "round"; //Experiment with "bevel" & "round" for the effect you want!
		Canvas.context.miterLimit = Scale.fh(2);

		Canvas.context.shadowBlur = Scale.fh(10);
		Canvas.context.shadowColor = "black";
		Canvas.context.shadowOffsetX = Scale.fh(2);
		Canvas.context.shadowOffsetY = Scale.fh(2);


		Canvas.context.clearRect(0, 0, (Canvas.size.Width), (Canvas.size.Height));
		Canvas.context.strokeStyle = "black";
		Canvas.context.lineWidth = Scale.fh(10);
		Canvas.context.strokeText(text, (Canvas.size.Width / 2), (Canvas.size.Height / 2));

		Canvas.context.strokeStyle = "white";
		Canvas.context.lineWidth = Scale.fh(10) / Scale.fh((4));
		Canvas.context.strokeText(text, (Canvas.size.Width / 2), (Canvas.size.Height / 2));

		Canvas.context.fillText(text, (Canvas.size.Width / 2), (Canvas.size.Height / 2));
	}

	public View(): HTMLElement {
		return this.view
	}
}

export class HelpPageBuyBonus extends HelpPage implements Resourceful{

	private gamePath: string;
	protected translator: Translator;
	protected description: HTMLElement = null;


	constructor(path: string, resid: ResourceIdentifier, gamePath: string, translator: Translator) {		
		super("BuyBonus", path, resid)
		this.gamePath = gamePath;
		this.translator = translator;

		this.resid.Add("HelpPageBuyBonus");
	}

	public override PrepareResources(resourceManager: IWriteOnlyResourceManager) {
	}
	public override ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
		this.CreateTitleCanvas();

		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);

		
		this.description = CreateElement("div", {
			classes: ["description-buybonus", this.resid.Scope()],
			parentToAppend: this.pageContent,
			style: {
				width: Scale.Wpx(1765),
				height: Scale.Hpx(820),
				color: "yellow",
				fontSize: Scale.fhpx(42),
				fontFamily: "NotoSansDisplay-Black",
				//textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
				display: "flex",
				alignItems: "center",
				//flexDirection: "column",
				//background: "pink",
				//fontSizeAdjust: "0.58",
				lineHeight : "initial",
				webkitTextStroke : Scale.fhpx(3)+" black",
				flexDirection: "column",
				justifyContent: "space-evenly",
				
				
			}
		});

		let butBuyBonusColor: ButtonColors = {
			backgroundButtonColor: "linear-gradient(rgb(139, 0, 0), rgb(178, 34, 34), rgb(139, 0, 0)), linear-gradient(#BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
			linearColor: "linear-gradient(to left, transparent, LightGoldenrodYellow, transparent) 0 10 100%",
		};

		let butBuyBonusStyle: Partial<CSSStyleDeclaration> = {
            borderRadius: Scale.XYpx(16),
    
            border: `${Scale.XYpx(7)} solid transparent`,
            //backgroundClip: "padding-box",
            borderStyle: "inset",
        
            margin: `${Scale.Wpx(5)} ${Scale.Hpx(10)}`,
            height: Scale.Hpx(195),
        
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
        
            backgroundOrigin: "border-box",
            backgroundClip: "content-box, border-box",
            backgroundImage: butBuyBonusColor.backgroundButtonColor,
        };

		let cssLabelBuyButton: Partial<CSSStyleDeclaration>  = {
			// fontSize: Scale.fhpx(20),
			lineHeight: "0px",//Scale.Hpx(50),
			//color: "white",
			textAlign: "center",
			
		
			fontFamily: "NotoSansDisplay-Bold",
			fontWeight: "bold", 
			
			color: "white",
			textShadow: Array(Math.round(Scale.XY(18))).fill("#001 0px 0px 4px").join(", ") //.repeat() #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
		};

		let butBuyBonus = CreateElement("div",
			{
				classes: ["butBuyBonus", "help"],
				parentToAppend: this.description,
				style:{

                    position: "relative",
                    width: Scale.Wpx(180),
                    ...butBuyBonusStyle
				}
			});
		
		let butBuyBonusLabel = CreateElement("div",
            {
                classes: ["butBuyBonusLabel"],
                parentToAppend: butBuyBonus,
                style:{
                    ...cssLabelBuyButton,                   
                }
            });
		
			//let betTypeValue = CreateElement("span", { classes: ["but-bet-type"], parentToAppend: butBuyBonusLabel, innerHTML: "BUY" });
            let betValue = CreateElement("div", {
                classes: ["but-bet-value"],
                parentToAppend: butBuyBonus,
                //innerHTML: "BONUS",
                style: {
                    ...cssLabelBuyButton,
					lineHeight : "40px",
					fontSize : Scale.XYpx(24),
                }
            });

			betValue.innerText = this.translator.t.buyBonusTitle;
		this.RedrawTitleCanvas(this.translator.t.buyBonusTitle, this.TitleCanvas);

		let translatedMessage = this.translator.Translate(() => this.translator.t.buyStickyBonusConfirmMessage2);
		this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas(this.translator.t.buyBonusTitle, this.TitleCanvas));
		this.translator.SetOnLanguageChangedCallback(() => betValue.innerText = this.translator.t.buyBonusTitle);		
		this.description.appendChild(translatedMessage.location);
	}
}

export class HelpPageBuyBonusOnline extends HelpPageBuyBonus implements Resourceful {
	protected cssLabel: Partial<CSSStyleDeclaration> = {
		fontSize: Scale.fhpx(50),
		lineHeight: "0px",
		//color: "white",
		textAlign: "center",


		fontFamily: "NotoSansDisplay-Bold",
		fontWeight: "bold",

		color: "white",
		textShadow: Array(Math.round(Scale.XY(18))).fill("#001 0px 0px 4px").join(", ") //.repeat() #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px, #000 0px 0px 4px",
	};

	    protected sideSpinButtonsSize = {
        width: "5",
        height: "5",        
    };

	public override PrepareResources(resourceManager: IWriteOnlyResourceManager) {
	}

	public override ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
		this.CreateTitleCanvas();

		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);


		this.description = CreateElement("div", {
			classes: ["description-buybonus", this.resid.Scope()],
			parentToAppend: this.pageContent,
			style: {
				width: Scale.Wpx(1765),
				height: Scale.Hpx(820),
				color: "yellow",
				fontSize: Scale.fhpx(42),
				fontFamily: "NotoSansDisplay-Black",
				//textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
				display: "flex",
				alignItems: "center",
				//flexDirection: "column",
				//background: "pink",
				//fontSizeAdjust: "0.58",
				lineHeight: "initial",
				webkitTextStroke: Scale.fhpx(3) + " black",
				flexDirection: "column",
				justifyContent: "space-evenly",


			}
		});

				let btnChangeBetType = CreateElement("div", {
					classes: ["but-buy-bonus", "button"],
					parentToAppend: this.description,
					style: {
						width: this.sideSpinButtonsSize.width + "vw",
						height: this.sideSpinButtonsSize.height + "vw",
						position: "relative",
						borderRadius: "50%",
						aspectRatio: "1/1",
						justifyContent:"center",
						alignItems: "center",
						display:"flex",
						transform: "rotate(90deg)",
						//background: `${this.panelColors.backgroundButtonColor}`,
						border: `${Scale.W(16)}px solid gold`,
						margin:`0px ${Scale.W(20)}px ${Scale.W(54)}px 0px`,
					},
				});
		
				let betTypeLabel = CreateElement("div", {
					classes: ["but-bet-type"],
					parentToAppend: btnChangeBetType,
					style: {
						...this.cssLabel,
						rotate: "-90deg",
						lineHeight: Scale.Hpx(45)
					},
					childToAppend: this.translator.Anchor(() => this.translator.t.buyBonusButton),
				});


		this.RedrawTitleCanvas(this.translator.t.buyBonusTitle, this.TitleCanvas);

		let translatedMessage = this.translator.Translate(() => this.translator.t.buyStickyBonusConfirmMessage2);
		this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas(this.translator.t.buyBonusTitle, this.TitleCanvas));
		// this.translator.SetOnLanguageChangedCallback(() => betValue.innerText = this.translator.t.buyBonusTitle);
		this.description.appendChild(translatedMessage.location);
	}
}

export class HelpPageMultibonus2 extends HelpPage implements Resourceful{

	private gamePath: string;
	private translator: Translator;
	private buyBonusTitle: string = "MULTIBONUS";
	private description: HTMLElement = null;
	private infoContainer: HTMLElement = null;
	// private tableInfo: HTMLElement = null;

	private resourcesPath = `${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/`

	protected layoutPotsElementsMap: Map<string, LayoutPotElement> = new Map<string, LayoutPotElement>()
	protected jsonSpine: ISkeletonData = null;
	protected multiBonusType: MultiBonusType[] = [
		MultiBonusType.Jackpot,
		MultiBonusType.Double,		
		MultiBonusType.Multiplier,
	] 

	constructor(path: string, resid: ResourceIdentifier, translator: Translator, gameName:string ) {		
		super("Multibonus", path, resid)
		this.translator = translator;
		this.resid.Add("HelpPageMultibonus2");
		this.gameName = gameName;
		this.resourcesPath = `${Settings.ResourcesFolder}multigame/slot/${gameName}/resources/`

	}

	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager) {
		// MultiPotName.forEach(potName => {
		// resourceManager.AddGlobal(new JSONResource(`${this.resourcesPath}FillingPotFeature/${Settings.Screens}Screens/LayoutPotElement/${potName}/${potName}.json`, ResourceIdentifier.Global.ScopedResourceName(`${this.resid.Scope()}-layoutPotElement-Json`)));
        // resourceManager.AddGlobal(new AtlasResource(`${this.resourcesPath}FillingPotFeature/${Settings.Screens}Screens/LayoutPotElement/${potName}/${potName}.atlas`, ResourceIdentifier.Global.ScopedResourceName(`${this.resid.Scope()}-layoutPotElement-Atlas`)));
		// })

	}

	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {

		for (let i = 0; i <= this.multiBonusType.length - 1; i++) {

			
			let jsonResource = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-${this.multiBonusType[i]}-LayoutPotElement-Json`));
			let resource = await Assets.load(jsonResource.path);
			this.jsonSpine = resource.spineData;
			
			
			let elem = new LayoutPotElement(this.multiBonusType[i], this.resourcesPath, this.gameName, null , null , null);
			await elem.ScreenShootLayoutExternal(this.jsonSpine)
			
			this.layoutPotsElementsMap.set(this.multiBonusType[i], elem );
		}
		
		this.CreateTitleCanvas();

		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);
		
		this.description = CreateElement("div", {
			classes: ["description", this.resid.Scope()],
			parentToAppend: this.pageContent,
			style: {
				width: Scale.Wpx(1765),
				height: Scale.Hpx(820),
				color: "yellow",
				fontSize: Scale.fhpx(25),
				fontFamily: "NotoSansDisplay-Black",
				//textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
				display: "flex",
				alignItems: "center",
				flexDirection: "column",
				//background: "pink",
				//fontSizeAdjust: "0.58",
				lineHeight : "initial",
				webkitTextStroke : Scale.fhpx(2)+" black"
				
				
			}
		});

		this.infoContainer = CreateElement("div", {
			classes: ["multibonus", "info-container"],
			parentToAppend: this.description,
			style: {
				width: "100%",
				height: Scale.Hpx(820), 
				overflow: "hidden", 
				justifyContent: "space-between",
				alignItems: "center",
				display: "flex",
				flexDirection: "column",
			}
		});


		this.CreateMultiBonusInfoOneByOne();



		this.RedrawTitleCanvas(this.translator.t.multibonusTitle, this.TitleCanvas);

		let translatedMessage = this.translator.Translate(() => this.translator.t.buyStickyBonusConfirmMessage2);
		this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas(this.translator.t.multibonusTitle, this.TitleCanvas));


		// this.description.appendChild(translatedMessage.location);
	}

	// protected layoutImgByPotName: Map<string, HTMLImageElement> = new Map<string, HTMLImageElement>();

	// private tdTrStyle: Partial<CSSStyleDeclaration> = {
	// 	// border: "1px solid blue",
	// 	textAlign: "center",
	// 	maxWidth: "100%",
	// 	maxHeight: "100%",

	// }
	// private row: HTMLElement = null;

	private CreateMultiBonusInfoOneByOne()
	{
		const MultiBonusDescriptionsMap: Record<MultiBonusType, HTMLElement> = {
			[MultiBonusType.Jackpot]: this.translator.Translate(() => this.translator.t.jackpotBonusDescription).location,
			[MultiBonusType.Double]: this.translator.Translate(() => this.translator.t.doubleBonusDescription).location,//this.translator.t.doubleBonusDescription,
			[MultiBonusType.Multiplier]: this.translator.Translate(() => this.translator.t.multiplierBonusDescription).location,//this.translator.t.bonusMultiplierDescription,
		}
		let tableInfo = CreateElement("table", {
			classes: ["multibonus", "info-table"],
			parentToAppend: this.infoContainer,
			style: {
				// width: "100%",
				// height: "100%",
				borderCollapse: "collapse",
				borderBottom: `${Scale.Wpx(5)} solid yellow`,
			}
		});
		// this.row= CreateElement("div", {
		// 	parentToAppend: this.infoContainer,
		// 	classes: ['multibonus', 'row'],
		// 	style:
		// 	{
		// 		// width: Scale.Wpx(1765),
		// 		// height: Scale.Hpx(820),
		// 		// display: "flex",
		// 		// flexDirection: "row",
		// 		// justifyContent: "space-between",
		// 		// alignItems: "center",
		// 		// transform: `scale(0.5)`,
		// 		// transformOrigin: 'center',
		// 		// margin: "auto",
		// 		flex: "1 1 auto", 
		// 		maxWidth: "100%",  
		// 		maxHeight: "100%", 
		// 		backgroundColor: "lightblue",  
		// 		border: "1px solid blue", 
		// 		boxSizing: "border-box",
		// 	}
		// });

		for (let i = 0; i < this.multiBonusType.length; i++) {

			// this.description.appendChild(this.layoutPotsElementsMap.get(potName).GetScreenShotLayout());

			let rowInternal = CreateElement("tr", {
				parentToAppend: tableInfo,
				classes: ['multibonus', 'row', this.multiBonusType[i].toLowerCase()],
				style: {
					// ...this.tdTrStyle
				}
			});
			
			let multibonusImgContainer = CreateElement("td", {
				parentToAppend: rowInternal,
				style: {

				}
			});

			const origImage = this.layoutPotsElementsMap.get(this.multiBonusType[i]).GetScreenShotLayout();
			assertNotNullish(origImage, "missing image for etiquete " + this.multiBonusType[i]);

			const image = CreateElement("img", {
				parentToAppend: multibonusImgContainer,
				childToAppend: origImage,
				style: {
					height: Scale.Hpx(100),
					backgroundPosition: "center",
					backgroundSize: "contain",
					backgroundRepeat: "no-repeat",
					backgroundOrigin: "center",
				},
				attrs: {
					src: origImage.src,
				}
			});

			let imgContainer = CreateElement("div", {
				parentToAppend: multibonusImgContainer,
				childToAppend: image,
				style: {
					width: ''
				}
			});

			let multibonusDescriptionDiv = CreateElement("td", {
				parentToAppend: rowInternal,
				childToAppend: MultiBonusDescriptionsMap[this.multiBonusType[i]],
				style: {
					paddingLeft: Scale.Wpx(35),
				}
			});
		};
		this.CreateMultibonusMatrix();
	}

	private CreateMultibonusMatrix()
	{
		let tableCombinations = CreateElement("table", {
			classes: ["multibonus", "info-table"],
			parentToAppend: this.infoContainer,
			style: {
				// width: "100%",
				// height: "100%",
				borderCollapse: "collapse",
				// borderTop: `${Scale.Wpx(5)} solid yellow`,
				borderBottom: `${Scale.Wpx(5)} solid yellow`,
			}
		});

		let doubleMultiplier = 	CreateElement("tr",{parentToAppend: tableCombinations, classes: ['multibonus', 'row', 'mixed']});

		const origImageDouble = this.layoutPotsElementsMap.get(MultiBonusType.Double).GetScreenShotLayout();
		const imageDouble = CreateElement("img", {
			childToAppend: origImageDouble,
			style: {
				height: Scale.Hpx(100),
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				backgroundOrigin: "center",
			},
			attrs: {
				src: origImageDouble.src,
			}
		});
		let doubleImgCell = CreateElement("td",{parentToAppend: doubleMultiplier, childToAppend: imageDouble, classes: ['multibonus', 'row', 'mixed', 'internal']});

		const origImageMultiplier = this.layoutPotsElementsMap.get(MultiBonusType.Multiplier).GetScreenShotLayout();
		const imageMultiplier = CreateElement("img", {
			childToAppend: origImageMultiplier,
			style: {
				height: Scale.Hpx(100),
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				backgroundOrigin: "center",
			},
			attrs: {
				src: origImageMultiplier.src,
			}
		});
		let multiplierCell = CreateElement("td",{parentToAppend: doubleMultiplier,childToAppend: imageMultiplier, classes: ['multibonus', 'row', 'mixed', 'internal']});

		let doubleJackpot = CreateElement("tr",{parentToAppend: tableCombinations, classes: ['multibonus', 'row', 'mixed']});

		const origImageDouble2 = this.layoutPotsElementsMap.get(MultiBonusType.Double).GetScreenShotLayout();
		const imageDouble2 = CreateElement("img", {
			childToAppend: origImageDouble,
			style: {
				height: Scale.Hpx(100),
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				backgroundOrigin: "center",
			},
			attrs: {
				src: origImageDouble2.src,
			}
		});
		let doubleImgCell2 = CreateElement("td",{parentToAppend: doubleJackpot, childToAppend: imageDouble2, classes: ['multibonus', 'row', 'mixed', 'internal']});

		const origImageJackpot = this.layoutPotsElementsMap.get(MultiBonusType.Jackpot).GetScreenShotLayout();
		const imageJackpot = CreateElement("img", {
			childToAppend: origImageJackpot,
			style: {
				height: Scale.Hpx(100),
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				backgroundOrigin: "center",
			},
			attrs: {
				src: origImageJackpot.src,
			}
		});
		let jackpotCell = CreateElement("td",{parentToAppend: doubleJackpot,childToAppend: imageJackpot, classes: ['multibonus', 'row', 'mixed', 'internal']});


		let multiplierJackpot = CreateElement("tr",{parentToAppend: tableCombinations, classes: ['multibonus', 'row', 'mixed']});
		
		const origImageMultiplier2 = this.layoutPotsElementsMap.get(MultiBonusType.Multiplier).GetScreenShotLayout();
		const imageMultiplier2 = CreateElement("img", {
			childToAppend: origImageMultiplier2,
			style: {
				height: Scale.Hpx(100),
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				backgroundOrigin: "center",
			},
			attrs: {
				src: origImageMultiplier2.src,
			}
		});
		let multiplierCell2 = CreateElement("td",{parentToAppend: multiplierJackpot,childToAppend: imageMultiplier2, classes: ['multibonus', 'row', 'mixed', 'internal']});

		const origImageJackpot2 = this.layoutPotsElementsMap.get(MultiBonusType.Jackpot).GetScreenShotLayout();
		const imageJackpot2 = CreateElement("img", {
			childToAppend: origImageJackpot2,
			style: {
				height: Scale.Hpx(100),
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				backgroundOrigin: "center",
			},
			attrs: {
				src: origImageJackpot2.src,
			}
		});
		let jackpotCell2 = CreateElement("td",{parentToAppend: multiplierJackpot,childToAppend: imageJackpot2, classes: ['multibonus', 'row', 'mixed', 'internal']});

		let doubleMultiplierDescriptionCell = CreateElement("td", { parentToAppend: doubleJackpot, childToAppend: this.translator.Translate(() => this.translator.t.multibonusCombinedDescription).location, classes: ['multibonus', 'row', 'mixed', 'internal'], style: {paddingLeft: Scale.Wpx(35)}});
		
		this.CreateMultiBonusRow();
	}

	private CreateMultiBonusRow()
	{
		let tableRow = CreateElement("table", {
			classes: ["multibonus", "info-table", "row"],
			parentToAppend: this.infoContainer,
			style: {
				// width: "100%",
				// height: "100%",
				borderCollapse: "collapse",
			}
		});

		let row = CreateElement("tr", {parentToAppend: tableRow, classes: ['multibonus', 'row']});

		const origImageDouble = this.layoutPotsElementsMap.get(MultiBonusType.Double).GetScreenShotLayout();
		const imageDouble = CreateElement("img", {
			childToAppend: origImageDouble,
			style: {
				height: Scale.Hpx(100),
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				backgroundOrigin: "center",
			},
			attrs: {
				src: origImageDouble.src,
			}
		});

		let doubleColumn = CreateElement("td", {parentToAppend: row, childToAppend: imageDouble, classes: ['multibonus', 'row', 'mixed']});

		const origImageMultiplier = this.layoutPotsElementsMap.get(MultiBonusType.Multiplier).GetScreenShotLayout();
		const imageMultiplier = CreateElement("img", {
			childToAppend: origImageMultiplier,
			style: {
				height: Scale.Hpx(100),
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				backgroundOrigin: "center",
			},
			attrs: {
				src: origImageMultiplier.src,
			}
		});

		let multiplierColumn = CreateElement("td", {parentToAppend: row, childToAppend: imageMultiplier, classes: ['multibonus', 'row', 'mixed']});

		const origImageJackpot = this.layoutPotsElementsMap.get(MultiBonusType.Jackpot).GetScreenShotLayout();
		const imageJackpot = CreateElement("img", {
			childToAppend: origImageJackpot,
			style: {
				height: Scale.Hpx(100),
				backgroundPosition: "center",
				backgroundSize: "contain",
				backgroundRepeat: "no-repeat",
				backgroundOrigin: "center",
			},
			attrs: {
				src: origImageJackpot.src,
			}
		});

		let jackpotColumn = CreateElement("td", {parentToAppend: row, childToAppend: imageJackpot, classes: ['multibonus', 'row', 'mixed']});

		let description = CreateElement("td", {parentToAppend: row, childToAppend: this.translator.Translate(() => this.translator.t.rowHelpDescription).location, classes: ['multibonus', 'row', 'mixed', 'description'], style: {paddingLeft: Scale.Wpx(35)}});
	}

	private divStyleMix: Partial<CSSStyleDeclaration> = {
		width: Scale.Wpx(650),
		height: Scale.Hpx(150),
		// padding: Scale.Wpx(10),
		// transform: `scale(0.5)`,
		transformOrigin: 'center',
		backgroundPosition: "center",
		backgroundSize: "cover",
		backgroundRepeat: "no-repeat",
		backgroundOrigin: "center",
		margin: Scale.Wpx(5),
	}
}

export class HelpPageMultibonus extends HelpPage implements Resourceful{

	private gamePath: string;
	private translator: Translator;
	private multibonusTitle: string = "MULTIBONUS";
	private description: HTMLElement = null;
	private infoContainer: HTMLElement = null;
	// private tableInfo: HTMLElement = null;

	private resourcesPath = null;

	private bonusTriggers: IPublicSimpleBonusTrigger[] = [];
	readonly symbolCollectionMap :Map<string, SymbolsCollectionResources> = null;
	// private symbols: SlotSymbol[] = [];
	private desiredSymbolsIndex: number[] = [];
	private symbols: SlotSymbol[] = [];
	private randomAwardRequiredSymbolsIndex: number[] = [];

	// private symbols: Map<string, SymbolsCollectionResources>;

	constructor(path: string, resid: ResourceIdentifier, translator: Translator, symbolCollectionMap: Map<string, SymbolsCollectionResources>, initData: SlotGameInitData) {		
		super("Multibonus", path, resid)
		this.translator = translator;
		this.resid.Add("HelpPageMultibonus");
		this.gameName = initData?.Meta?.onlineParams?.original ?? initData.GameName;
		this.bonusTriggers = initData.BonusTriggers;
		this.symbolCollectionMap = symbolCollectionMap;
		this.symbols = initData.Symbols;
		this.resourcesPath = `${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/`

		const scatterRandomAwardConfiguration: ScatterRandomAwardConfiguration[] = Object.values(initData.BonusConfiguration.MultiBonus.MultiFeatureConfiguration) as ScatterRandomAwardConfiguration[];
		let randomAwardRequiredSymbols = scatterRandomAwardConfiguration.flatMap(c => c.RequiredSymbols).filter(Filter.UniqueItem);
		this.randomAwardRequiredSymbolsIndex = randomAwardRequiredSymbols.map(s => this.symbols.find(s2 => s2.ID == s).Index);
			
		
		// let sraGenericIndex = this.symbols.findIndex(s => sraGeneric.includes(s.ID));
		// this.desiredSymbolsIndex.push(sraGenericIndex);
		//scatterRandomAwardConfiguration.RequiredSymbols;
		// console.log("indexSRA: ", indices);
		let desiredSymbols = initData.BonusTriggers.filter(s => s.BonusName == "MultiBonus").flatMap(b => b.RequiredSymbols).filter(Filter.UniqueItem);
		desiredSymbols.forEach(symbolIndex => this.desiredSymbolsIndex.push(symbolIndex));
		// this.symbolsCollection = symbolsMap;

		this.description = CreateElement("div", {
			classes: ["description", this.resid.Scope()],
			parentToAppend: this.pageContent,
			style: {
				width: Scale.Wpx(1765),
				height: Scale.Hpx(820),
				color: "yellow",
				fontSize: Scale.fhpx(42),
				fontFamily: "NotoSansDisplay-Black",
				//textShadow: "0px 0px 10px black, 0px 0px 20px black",
				textAlign: "center",
				justifyContent: "center",
				display: "flex",
				alignItems: "center",
				flexDirection: "column",
				//background: "pink",
				//fontSizeAdjust: "0.58",
				lineHeight : "initial",
				webkitTextStroke : Scale.fhpx(2)+" black",				
			}
		});

	}

	private SymbolsList: HTMLImageElement[] = [];

	public override async PrepareResources(resourceManager: IWriteOnlyResourceManager) {



	}
	
	public override async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {

		this.CreateTitleCanvas();

		this.desiredSymbolsIndex.forEach(index => {
			const image = this.symbolCollectionMap.get(`Symbol_${this.symbols[index].ID}`).imgResource.cloneNode(true) as HTMLImageElement;
			const imageClone = CreateElement("img", {
				childToAppend: image,
				style: {
					width: Scale.Wpx(300),
				},
				attrs: {
					src: image.src,
				}
			});
			this.SymbolsList.push(imageClone);
		})

		this.pageTitle.appendChild(this.TitleCanvas.context.canvas);

		this.RedrawTitleCanvas(this.translator.t.multibonusTitle, this.TitleCanvas);

		let translatedMessage = this.translator.Translate(() => this.translator.t.multibonusTitle);
		this.translator.SetOnLanguageChangedCallback(() => this.RedrawTitleCanvas(this.translator.t.multibonusTitle, this.TitleCanvas));

		this.buildElements();

	}

	private buildElements()
	{
		let divContainer = CreateElement("div", {
			classes: ["multibonus", "info-container"],
			parentToAppend: this.description,
			style: {
				display: "flex",
			}
		});

		this.SymbolsList.forEach(symbol => {

			let symbolContainer = CreateElement("div", {
				classes: ["multibonus", "symbol-container"],
				parentToAppend: divContainer,
				childToAppend: symbol,

			});
		});

		let symbolContainer: HTMLElement = null;

		this.randomAwardRequiredSymbolsIndex.forEach(index => {
		
			symbolContainer = document.createElement("div");
			symbolContainer.setAttribute("class", "symbolsra-container");
			SetStyles(symbolContainer,
				{
					width:Scale.Wpx(150),
					height:Scale.Hpx(120),				
					backgroundRepeat: "no-repeat",
					backgroundSize: "contain",
					backgroundPosition: "center",
					display: "inline-block",
					verticalAlign: "middle",
				});

				const imageSRA = this.symbolCollectionMap.get(`Symbol_${this.symbols[index].ID}`).imgResource.cloneNode(true) as HTMLImageElement;
				const imageCloneSRA = CreateElement("img", {
					classes:["symbol-image", "sra"],
					childToAppend: imageSRA,
					style: {
						width : Scale.Wpx(150),
						// height: Scale.Hpx(100),
						// backgroundPosition: "center",
						// backgroundSize: "contain",
						// backgroundRepeat: "no-repeat",
						// backgroundOrigin: "center",
					},
					attrs: {
						src: imageSRA.src,
					}
				});
				symbolContainer.appendChild(imageCloneSRA);
		});

		let translatedDescription = this.translator.Translate(() => this.translator.t.multibonusDescription);
		this.description.appendChild(translatedDescription.location);

		let translatedDescription2 = this.translator.Translate(() => this.translator.t.grandJackpotMultiBonusDescription(symbolContainer.outerHTML));
		this.description.appendChild(translatedDescription2.location);
	}


}
